webpackJsonp([1],{

/***/ "3Gzn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DS8o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fh1t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MRsk":
/***/ (function(module, exports) {

module.exports = [{"currNumber":"1","name":"Ablaß, Bruno","lastName":"Ablaß","firstName":"Bruno","page":"7","scan":"00000007","nameMari":"","notes":""},{"currNumber":"2","name":"Alexander, Richard","lastName":"Alexander","firstName":"Richard","page":"8","scan":"00000008","nameMari":"","notes":""},{"currNumber":"3","name":"Andrade, Francisco d /Mus./","lastName":"Andrade","firstName":"Francisco d /Mus./","page":"9","scan":"00000009","nameMari":"","notes":""},{"currNumber":"4","name":"Apt, Max","lastName":"Apt","firstName":"Max","page":"10","scan":"00000010","nameMari":"","notes":""},{"currNumber":"5","name":"Arnhold, Eduard","lastName":"Arnhold","firstName":"Eduard","page":"13","scan":"00000013","nameMari":"","notes":""},{"currNumber":"6","name":"Aronsohn, Louis","lastName":"Aronsohn","firstName":"Louis","page":"14","scan":"00000014","nameMari":"","notes":""},{"currNumber":"7","name":"Ballin, Albert","lastName":"Ballin","firstName":"Albert","page":"17","scan":"00000017","nameMari":"","notes":""},{"currNumber":"8","name":"Band, Victor","lastName":"Band","firstName":"Victor","page":"18","scan":"00000018","nameMari":"","notes":""},{"currNumber":"9","name":"Bar, Karl Ludwig v.","lastName":"Bar","firstName":"Karl Ludwig v.","page":"19","scan":"00000019","nameMari":"","notes":""},{"currNumber":"10","name":"Barclay, Sir Thomas","lastName":"Barclay","firstName":"Sir Thomas","page":"20","scan":"00000020","nameMari":"","notes":""},{"currNumber":"11","name":"Barnay, Ludwig","lastName":"Barnay","firstName":"Ludwig","page":"21","scan":"00000021","nameMari":"","notes":""},{"currNumber":"12","name":"Barth, Hans","lastName":"Barth","firstName":"Hans","page":"22","scan":"00000022","nameMari":"","notes":""},{"currNumber":"13","name":"Bauer, Julius","lastName":"Bauer","firstName":"Julius","page":"23","scan":"00000023","nameMari":"","notes":""},{"currNumber":"14","name":"Bauer, Max","lastName":"Bauer","firstName":"Max","page":"24","scan":"00000024","nameMari":"","notes":""},{"currNumber":"15","name":"Baumberger, Hermann","lastName":"Baumberger","firstName":"Hermann","page":"26","scan":"00000026","nameMari":"","notes":""},{"currNumber":"16","name":"Baumfeld, M","lastName":"Baumfeld","firstName":"M","page":"25","scan":"00000025","nameMari":"","notes":""},{"currNumber":"17","name":"Behrens, Peter","lastName":"Behrens","firstName":"Peter","page":"27","scan":"00000027","nameMari":"","notes":""},{"currNumber":"18","name":"Benedikt, Moritz","lastName":"Benedikt","firstName":"Moritz","page":"28","scan":"00000028","nameMari":"","notes":""},{"currNumber":"19","name":"Bennigson","lastName":"Bennigson","firstName":"","page":"29","scan":"00000029","nameMari":"","notes":"Unterschrift unleserlich, mit Bleistift \"Bennert\" unten rechts"},{"currNumber":"20","name":"Bernauer, Rudolf","lastName":"Bernauer","firstName":"Rudolf","page":"30","scan":"00000030","nameMari":"","notes":""},{"currNumber":"21","name":"Bernstein, Max","lastName":"Bernstein","firstName":"Max","page":"31","scan":"00000031","nameMari":"","notes":""},{"currNumber":"22","name":"Bertens - Block, Rosa","lastName":"Bertens - Block","firstName":"Rosa","page":"32","scan":"00000032","nameMari":"","notes":""},{"currNumber":"23","name":"Birnbaum, Leonhard","lastName":"Birnbaum","firstName":"Leonhard","page":"33","scan":"00000033","nameMari":"","notes":""},{"currNumber":"24","name":"Björnson, Björn (jr.)","lastName":"Björnson","firstName":"Björn (jr.)","page":"34","scan":"00000034","nameMari":"","notes":""},{"currNumber":"25","name":"Block, Paul","lastName":"Block","firstName":"Paul","page":"35","scan":"00000035","nameMari":"","notes":""},{"currNumber":"26","name":"Blumenthal, Oscar","lastName":"Blumenthal","firstName":"Oscar","page":"36","scan":"00000036","nameMari":"","notes":""},{"currNumber":"27","name":"Brandis, A.v.","lastName":"Brandis","firstName":"A.v.","page":"37","scan":"00000037","nameMari":"Brandis, August von","notes":""},{"currNumber":"28","name":"Brentano, Lujo","lastName":"Brentano","firstName":"Lujo","page":"38","scan":"00000038","nameMari":"","notes":""},{"currNumber":"29","name":"Breslauer, Alfons","lastName":"Breslauer","firstName":"Alfons","page":"39","scan":"00000039","nameMari":"","notes":""},{"currNumber":"30","name":"Bryk, Siegfried","lastName":"Bryk","firstName":"Siegfried","page":"40","scan":"00000040","nameMari":"","notes":""},{"currNumber":"31","name":"Bühle, Richard","lastName":"Bühle","firstName":"Richard","page":"41","scan":"00000041","nameMari":"","notes":""},{"currNumber":"32","name":"Büxenstein, Georg W.","lastName":"Büxenstein","firstName":"Georg W.","page":"43","scan":"00000043","nameMari":"","notes":""},{"currNumber":"33","name":"Bunsen, Marie v.","lastName":"Bunsen","firstName":"Marie v.","page":"42","scan":"00000042","nameMari":"","notes":""},{"currNumber":"34","name":"Cassel, Oscar","lastName":"Cassel","firstName":"Oscar","page":"44","scan":"00000044","nameMari":"","notes":""},{"currNumber":"35","name":"Clewing, Carl /Mus./","lastName":"Clewing","firstName":"Carl /Mus./","page":"45","scan":"00000045","nameMari":"","notes":""},{"currNumber":"36","name":"Cohen, Hermann","lastName":"Cohen","firstName":"Hermann","page":"46","scan":"00000046","nameMari":"","notes":""},{"currNumber":"37","name":"Cohn, Martin","lastName":"Cohn","firstName":"Martin","page":"47","scan":"00000047","nameMari":"","notes":""},{"currNumber":"38","name":"Corvey, Johannes","lastName":"Corvey","firstName":"Johannes","page":"48","scan":"00000048","nameMari":"","notes":""},{"currNumber":"39","name":"Cretschmar, Cornelius","lastName":"Cretschmar","firstName":"Cornelius","page":"49","scan":"00000049","nameMari":"","notes":""},{"currNumber":"40","name":"Curti, Theodor","lastName":"Curti","firstName":"Theodor","page":"50","scan":"00000050","nameMari":"","notes":""},{"currNumber":"41","name":"Demuth, Fritz","lastName":"Demuth","firstName":"Fritz","page":"51","scan":"00000051","nameMari":"","notes":""},{"currNumber":"42","name":"Dernburg, Bernhard","lastName":"Dernburg","firstName":"Bernhard","page":"52","scan":"00000052","nameMari":"","notes":""},{"currNumber":"43","name":"Dincklage-Campe, Friedr.Frh.v.","lastName":"Dincklage-Campe","firstName":"Friedr.Frh.v.","page":"53","scan":"00000053","nameMari":"","notes":""},{"currNumber":"44","name":"Dohm, Hedwig","lastName":"Dohm","firstName":"Hedwig","page":"54","scan":"00000054","nameMari":"","notes":""},{"currNumber":"45","name":"Doepler, Emil (jr.)","lastName":"Doepler","firstName":"Emil (jr.)","page":"55","scan":"00000055","nameMari":"","notes":""},{"currNumber":"46","name":"Dove, Heinrich","lastName":"Dove","firstName":"Heinrich","page":"56","scan":"00000056","nameMari":"","notes":""},{"currNumber":"47","name":"Ehlers, Otto","lastName":"Ehlers","firstName":"Otto","page":"57","scan":"00000057","nameMari":"","notes":""},{"currNumber":"48","name":"Ehrenhorst, Carl Fr.","lastName":"Ehrenhorst","firstName":"Carl Fr.","page":"58","scan":"00000058","nameMari":"","notes":""},{"currNumber":"49","name":"Elias, Julius","lastName":"Elias","firstName":"Julius","page":"59","scan":"00000059","nameMari":"","notes":""},{"currNumber":"50","name":"Engel, Eduard","lastName":"Engel","firstName":"Eduard","page":"60","scan":"00000060","nameMari":"","notes":""},{"currNumber":"51","name":"Engel, Fritz","lastName":"Engel","firstName":"Fritz","page":"61","scan":"00000061","nameMari":"","notes":""},{"currNumber":"52","name":"Engel, Georg","lastName":"Engel","firstName":"Georg","page":"62","scan":"00000062","nameMari":"","notes":""},{"currNumber":"53","name":"Enking, Ottomar","lastName":"Enking","firstName":"Ottomar","page":"63","scan":"00000063","nameMari":"","notes":""},{"currNumber":"54","name":"Ernst, Albert","lastName":"Ernst","firstName":"Albert","page":"64","scan":"00000064","nameMari":"","notes":""},{"currNumber":"55","name":"Eulenberg, Herbert","lastName":"Eulenberg","firstName":"Herbert","page":"65","scan":"00000065","nameMari":"","notes":""},{"currNumber":"56","name":"Eulenberg, Albert","lastName":"Eulenberg","firstName":"Albert","page":"66","scan":"00000066","nameMari":"","notes":""},{"currNumber":"57","name":"Fegter, Jan Frers Martens","lastName":"Fegter","firstName":"Jan Frers Martens","page":"69","scan":"00000069","nameMari":"","notes":""},{"currNumber":"58","name":"Feldmann, Wilhelm","lastName":"Feldmann","firstName":"Wilhelm","page":"70","scan":"00000070","nameMari":"","notes":""},{"currNumber":"59","name":"Fiedler, Alfred","lastName":"Fiedler","firstName":"Alfred","page":"71","scan":"00000071","nameMari":"","notes":""},{"currNumber":"60","name":"Fischbeck, Otto","lastName":"Fischbeck","firstName":"Otto","page":"72","scan":"00000072","nameMari":"","notes":""},{"currNumber":"61","name":"Fischer, Hermann","lastName":"Fischer","firstName":"Hermann","page":"73","scan":"00000073","nameMari":"","notes":""},{"currNumber":"62","name":"Fischer, Karl","lastName":"Fischer","firstName":"Karl","page":"74","scan":"00000074","nameMari":"","notes":""},{"currNumber":"63","name":"Flamm, Oswald","lastName":"Flamm","firstName":"Oswald","page":"75","scan":"00000075","nameMari":"","notes":""},{"currNumber":"64","name":"Flemming, H.","lastName":"Flemming","firstName":"H.","page":"76","scan":"00000076","nameMari":"","notes":""},{"currNumber":"65","name":"Flesch, Karl","lastName":"Flesch","firstName":"Karl","page":"77","scan":"00000077","nameMari":"","notes":""},{"currNumber":"66","name":"Foerster, Wilhlem","lastName":"Foerster","firstName":"Wilhlem","page":"78","scan":"00000078","nameMari":"","notes":""},{"currNumber":"67","name":"Frenz, Hugo","lastName":"Frenz","firstName":"Hugo","page":"79","scan":"00000079","nameMari":"","notes":""},{"currNumber":"68","name":"Frenzel, Karl","lastName":"Frenzel","firstName":"Karl","page":"80","scan":"00000080","nameMari":"","notes":""},{"currNumber":"69","name":"Friedenthal, Joachim","lastName":"Friedenthal","firstName":"Joachim","page":"81","scan":"00000081","nameMari":"","notes":""},{"currNumber":"70","name":"Friedländer, Martin","lastName":"Friedländer","firstName":"Martin","page":"84","scan":"00000084","nameMari":"","notes":""},{"currNumber":"71","name":"Friedländer, Max /Mus./","lastName":"Friedländer","firstName":"Max /Mus./","page":"83","scan":"00000083","nameMari":"","notes":""},{"currNumber":"72","name":"Friedländer, Max J.","lastName":"Friedländer","firstName":"Max J.","page":"82","scan":"00000082","nameMari":"","notes":""},{"currNumber":"73","name":"Friedmann, Alfred","lastName":"Friedmann","firstName":"Alfred","page":"85","scan":"00000085","nameMari":"","notes":""},{"currNumber":"74","name":"Fritze, Georg","lastName":"Fritze","firstName":"Georg","page":"86","scan":"00000086","nameMari":"","notes":""},{"currNumber":"75","name":"Fürst, Artur","lastName":"Fürst","firstName":"Artur","page":"88","scan":"00000088","nameMari":"","notes":""},{"currNumber":"76","name":"Fulda, Ludwig","lastName":"Fulda","firstName":"Ludwig","page":"87","scan":"00000087","nameMari":"","notes":""},{"currNumber":"77","name":"Gehrke, Fritz","lastName":"Gehrke","firstName":"Fritz","page":"90","scan":"00000090","nameMari":"","notes":""},{"currNumber":"78","name":"Geiger, Ludwig","lastName":"Geiger","firstName":"Ludwig","page":"91","scan":"00000091","nameMari":"","notes":""},{"currNumber":"79","name":"Ginsberg, J.","lastName":"Ginsberg","firstName":"J.","page":"92","scan":"00000092","nameMari":"","notes":""},{"currNumber":"80","name":"Ginsberg, Max","lastName":"Ginsberg","firstName":"Max","page":"93","scan":"00000093","nameMari":"","notes":""},{"currNumber":"81","name":"Glicenstein, Henryk (Enoch)","lastName":"Glicenstein","firstName":"Henryk (Enoch)","page":"94","scan":"00000094","nameMari":"Glycenstein, Henryk","notes":""},{"currNumber":"82","name":"Gothein, Eberhard","lastName":"Gothein","firstName":"Eberhard","page":"97","scan":"00000097","nameMari":"","notes":""},{"currNumber":"83","name":"Goetze, Marie /Mus./","lastName":"Goetze","firstName":"Marie /Mus./","page":"98","scan":"00000098","nameMari":"","notes":""},{"currNumber":"84","name":"Grube, Max","lastName":"Grube","firstName":"Max","page":"99","scan":"00000099","nameMari":"","notes":""},{"currNumber":"85","name":"Habermann","lastName":"Habermann","firstName":"","page":"100","scan":"00000100","nameMari":"","notes":""},{"currNumber":"86","name":"Hajduk, August","lastName":"Hajduk","firstName":"August","page":"102","scan":"00000102","nameMari":"","notes":""},{"currNumber":"87","name":"Halke, Paul","lastName":"Halke","firstName":"Paul","page":"104","scan":"00000104","nameMari":"","notes":""},{"currNumber":"88","name":"Harms, Paul","lastName":"Harms","firstName":"Paul","page":"106","scan":"00000106","nameMari":"","notes":""},{"currNumber":"89","name":"Hauschner, Auguste","lastName":"Hauschner","firstName":"Auguste","page":"109","scan":"00000109","nameMari":"","notes":""},{"currNumber":"90","name":"Haußmann, Conrad","lastName":"Haußmann","firstName":"Conrad","page":"110","scan":"00000110","nameMari":"","notes":""},{"currNumber":"91","name":"Heims-Reinhardt, Else","lastName":"Heims-Reinhardt","firstName":"Else","page":"111","scan":"00000111","nameMari":"","notes":""},{"currNumber":"92","name":"Heineken, Philip","lastName":"Heineken","firstName":"Philip","page":"112","scan":"00000112","nameMari":"","notes":""},{"currNumber":"93","name":"Heinitz, Georg","lastName":"Heinitz","firstName":"Georg","page":"113","scan":"00000113","nameMari":"","notes":""},{"currNumber":"94","name":"Henig, Arno","lastName":"Henig","firstName":"Arno","page":"114","scan":"00000114","nameMari":"","notes":""},{"currNumber":"95","name":"Hermann, Georg","lastName":"Hermann","firstName":"Georg","page":"117","scan":"00000117","nameMari":"","notes":""},{"currNumber":"96","name":"Herz, Wilhelm","lastName":"Herz","firstName":"Wilhelm","page":"105","scan":"00000105","nameMari":"","notes":""},{"currNumber":"97","name":"Heyking, Elisabeth v.","lastName":"Heyking","firstName":"Elisabeth v.","page":"118","scan":"00000118","nameMari":"","notes":""},{"currNumber":"98","name":"Hillger, Hermann","lastName":"Hillger","firstName":"Hermann","page":"119","scan":"00000119","nameMari":"","notes":""},{"currNumber":"99","name":"Hirsch, Sally","lastName":"Hirsch","firstName":"Sally","page":"120","scan":"00000120","nameMari":"","notes":""},{"currNumber":"100","name":"Hirschfeld, Georg","lastName":"Hirschfeld","firstName":"Georg","page":"121","scan":"00000121","nameMari":"","notes":""},{"currNumber":"101","name":"Hirth, Georg","lastName":"Hirth","firstName":"Georg","page":"122","scan":"00000122","nameMari":"","notes":""},{"currNumber":"102","name":"Hochdorf, Max","lastName":"Hochdorf","firstName":"Max","page":"123","scan":"00000123","nameMari":"","notes":""},{"currNumber":"103","name":"Hof, Ludwig","lastName":"Hof","firstName":"Ludwig","page":"124","scan":"00000124","nameMari":"","notes":""},{"currNumber":"104","name":"Hoff, Friedr. Ferdinand","lastName":"Hoff","firstName":"Friedr. Ferdinand","page":"125","scan":"00000125","nameMari":"","notes":""},{"currNumber":"105","name":"Hoffmann, Ludwig","lastName":"Hoffmann","firstName":"Ludwig","page":"126","scan":"00000126","nameMari":"","notes":""},{"currNumber":"106","name":"Hollaender, Felix","lastName":"Hollaender","firstName":"Felix","page":"130","scan":"00000130","nameMari":"","notes":""},{"currNumber":"107","name":"Jacobs, Paul","lastName":"Jacobs","firstName":"Paul","page":"131","scan":"00000131","nameMari":"","notes":""},{"currNumber":"108","name":"Jelski","lastName":"Jelski","firstName":"","page":"132","scan":"00000132","nameMari":"","notes":""},{"currNumber":"109","name":"Jöhlinger, Otto","lastName":"Jöhlinger","firstName":"Otto","page":"133","scan":"00000133","nameMari":"","notes":""},{"currNumber":"110","name":"Jolles, Bernhard","lastName":"Jolles","firstName":"Bernhard","page":"134","scan":"00000134","nameMari":"","notes":""},{"currNumber":"111","name":"Kadelburg, Gustav","lastName":"Kadelburg","firstName":"Gustav","page":"135","scan":"00000135","nameMari":"","notes":""},{"currNumber":"112","name":"Kaempf, Johannes","lastName":"Kaempf","firstName":"Johannes","page":"137","scan":"00000136","nameMari":"","notes":""},{"currNumber":"113","name":"Kalisch, Leopold","lastName":"Kalisch","firstName":"Leopold","page":"136","scan":"00000137","nameMari":"","notes":""},{"currNumber":"114","name":"Kallmorgen, Friedrich","lastName":"Kallmorgen","firstName":"Friedrich","page":"138","scan":"00000138","nameMari":"Kallmorgen, Friedrich","notes":""},{"currNumber":"115","name":"Karstaedt, Fritz","lastName":"Karstaedt","firstName":"Fritz","page":"141","scan":"00000141","nameMari":"","notes":""},{"currNumber":"116","name":"Kassner, Carl","lastName":"Kassner","firstName":"Carl","page":"142","scan":"00000142","nameMari":"","notes":""},{"currNumber":"117","name":"Kastan, Isidor","lastName":"Kastan","firstName":"Isidor","page":"143","scan":"00000143","nameMari":"","notes":""},{"currNumber":"118","name":"Kirchenheim, Arthur v.","lastName":"Kirchenheim","firstName":"Arthur v.","page":"144","scan":"00000144","nameMari":"","notes":""},{"currNumber":"119","name":"Klebinder, Robert","lastName":"Klebinder","firstName":"Robert","page":"145","scan":"00000145","nameMari":"","notes":""},{"currNumber":"120","name":"Kleefeld, Kurt v.","lastName":"Kleefeld","firstName":"Kurt v.","page":"146","scan":"00000146","nameMari":"","notes":""},{"currNumber":"121","name":"Koerner, Ernst","lastName":"Koerner","firstName":"Ernst","page":"151","scan":"00000151","nameMari":"Koerner, Ernst Karl Eugen","notes":""},{"currNumber":"122","name":"Kraft,","lastName":"Kraft","firstName":"","page":"152","scan":"00000152","nameMari":"","notes":""},{"currNumber":"123","name":"Krüger, Alfred","lastName":"Krüger","firstName":"Alfred","page":"153","scan":"00000153","nameMari":"","notes":""},{"currNumber":"124","name":"Kruse, Käthe","lastName":"Kruse","firstName":"Käthe","page":"154","scan":"00000154","nameMari":"","notes":""},{"currNumber":"125","name":"Kruse, Max","lastName":"Kruse","firstName":"Max","page":"154","scan":"00000154","nameMari":"","notes":""},{"currNumber":"126","name":"Lachmann, Georg","lastName":"Lachmann","firstName":"Georg","page":"155","scan":"00000155","nameMari":"","notes":""},{"currNumber":"127","name":"Lachmann-Mosse, Felicia","lastName":"Lachmann-Mosse","firstName":"Felicia","page":"157","scan":"00000157","nameMari":"","notes":""},{"currNumber":"128","name":"Lachmann-Mosse, Hans","lastName":"Lachmann-Mosse","firstName":"Hans","page":"156","scan":"00000156","nameMari":"","notes":""},{"currNumber":"129","name":"Lamprecht, Karl","lastName":"Lamprecht","firstName":"Karl","page":"159","scan":"00000159","nameMari":"","notes":""},{"currNumber":"130","name":"Landau, Adolf","lastName":"Landau","firstName":"Adolf","page":"160","scan":"00000160","nameMari":"","notes":""},{"currNumber":"131","name":"Landau, Isidor","lastName":"Landau","firstName":"Isidor","page":"161","scan":"00000161","nameMari":"","notes":""},{"currNumber":"132","name":"Landau, Leopold","lastName":"Landau","firstName":"Leopold","page":"162","scan":"00000162","nameMari":"","notes":""},{"currNumber":"133","name":"Landeker, S. /Mus./","lastName":"Landeker","firstName":"S. /Mus./","page":"163","scan":"00000163","nameMari":"","notes":""},{"currNumber":"134","name":"Langstein, Leo","lastName":"Langstein","firstName":"Leo","page":"164","scan":"00000164","nameMari":"","notes":""},{"currNumber":"135","name":"Lautenburg, Sigmund","lastName":"Lautenburg","firstName":"Sigmund","page":"165","scan":"00000165","nameMari":"","notes":""},{"currNumber":"136","name":"Lederer, Leo","lastName":"Lederer","firstName":"Leo","page":"166","scan":"00000166","nameMari":"","notes":""},{"currNumber":"137","name":"Leipziger, Leo","lastName":"Leipziger","firstName":"Leo","page":"171","scan":"00000171","nameMari":"","notes":""},{"currNumber":"138","name":"Levin, Else","lastName":"Levin","firstName":"Else","page":"173","scan":"00000173","nameMari":"","notes":""},{"currNumber":"139","name":"Levin, M.","lastName":"Levin","firstName":"M.","page":"174","scan":"00000174","nameMari":"","notes":""},{"currNumber":"140","name":"Lewin, Carl","lastName":"Lewin","firstName":"Carl","page":"172","scan":"00000172","nameMari":"","notes":""},{"currNumber":"141","name":"Lewin, Max","lastName":"Lewin","firstName":"Max","page":"175","scan":"00000175","nameMari":"","notes":""},{"currNumber":"142","name":"Lie, Bernt","lastName":"Lie","firstName":"Bernt","page":"176","scan":"00000176","nameMari":"","notes":""},{"currNumber":"143","name":"Liebermann, Max","lastName":"Liebermann","firstName":"Max","page":"177","scan":"00000177","nameMari":"Liebermann, Max","notes":""},{"currNumber":"144","name":"Lindau, Paul","lastName":"Lindau","firstName":"Paul","page":"178","scan":"00000178","nameMari":"","notes":""},{"currNumber":"145","name":"Lingner, K.A.F.","lastName":"Lingner","firstName":"K.A.F.","page":"179","scan":"00000179","nameMari":"","notes":""},{"currNumber":"146","name":"Lorenz, Felix","lastName":"Lorenz","firstName":"Felix","page":"180","scan":"00000180","nameMari":"","notes":""},{"currNumber":"147","name":"Ludwig, Emil","lastName":"Ludwig","firstName":"Emil","page":"181","scan":"00000181","nameMari":"","notes":""},{"currNumber":"148","name":"Mankiewitz, Paul","lastName":"Mankiewitz","firstName":"Paul","page":"182","scan":"00000182","nameMari":"","notes":""},{"currNumber":"149","name":"Manzel, Ludwig","lastName":"Manzel","firstName":"Ludwig","page":"183","scan":"00000183","nameMari":"Manzel, Ludwig","notes":""},{"currNumber":"150","name":"Matthias, Adolf","lastName":"Matthias","firstName":"Adolf","page":"184","scan":"00000184","nameMari":"","notes":""},{"currNumber":"151","name":"Mauthner, Fritz","lastName":"Mauthner","firstName":"Fritz","page":"185","scan":"00000185","nameMari":"","notes":""},{"currNumber":"152","name":"Maybaum","lastName":"Maybaum","firstName":"","page":"186","scan":"00000186","nameMari":"","notes":""},{"currNumber":"153","name":"Mehring, Sigmar","lastName":"Mehring","firstName":"Sigmar","page":"187","scan":"00000187","nameMari":"","notes":""},{"currNumber":"154","name":"Mendelssohn, Franz","lastName":"Mendelssohn","firstName":"Franz","page":"105","scan":"00000105","nameMari":"","notes":""},{"currNumber":"155","name":"Meyer, Oscar","lastName":"Meyer","firstName":"Oscar","page":"189","scan":"00000189","nameMari":"","notes":""},{"currNumber":"156","name":"Meyerheim, Paul","lastName":"Meyerheim","firstName":"Paul","page":"190","scan":"00000190","nameMari":"Meyerheim, Paul","notes":""},{"currNumber":"157","name":"Michaelis, Paul","lastName":"Michaelis","firstName":"Paul","page":"191","scan":"00000191","nameMari":"","notes":""},{"currNumber":"158","name":"Michaelis-Stangeland, Karin","lastName":"Michaelis-Stangeland","firstName":"Karin","page":"270","scan":"00000270","nameMari":"","notes":""},{"currNumber":"159","name":"Mieses, Jacques","lastName":"Mieses","firstName":"Jacques","page":"192","scan":"00000192","nameMari":"","notes":""},{"currNumber":"160","name":"Minden, Georg","lastName":"Minden","firstName":"Georg","page":"193","scan":"00000193","nameMari":"","notes":""},{"currNumber":"161","name":"Moraht, E.","lastName":"Moraht","firstName":"E.","page":"194","scan":"00000194","nameMari":"","notes":""},{"currNumber":"162","name":"Mosse, Emil","lastName":"Mosse","firstName":"Emil","page":"195","scan":"00000195","nameMari":"","notes":""},{"currNumber":"163","name":"Moszkowski, Alexander","lastName":"Moszkowski","firstName":"Alexander","page":"196","scan":"00000196","nameMari":"","notes":""},{"currNumber":"164","name":"Müller-Meiningen, Ernst","lastName":"Müller-Meiningen","firstName":"Ernst","page":"197","scan":"00000197","nameMari":"","notes":""},{"currNumber":"165","name":"Nansen, Peter","lastName":"Nansen","firstName":"Peter","page":"198","scan":"00000198","nameMari":"","notes":""},{"currNumber":"166","name":"Nathan, Paul","lastName":"Nathan","firstName":"Paul","page":"199","scan":"00000199","nameMari":"","notes":""},{"currNumber":"167","name":"Naumann, Friedrich","lastName":"Naumann","firstName":"Friedrich","page":"200","scan":"00000200","nameMari":"","notes":""},{"currNumber":"168","name":"Neumann-Hofer, Adolf","lastName":"Neumann-Hofer","firstName":"Adolf","page":"203","scan":"00000203","nameMari":"","notes":""},{"currNumber":"169","name":"Niemann, Albert /Mus./","lastName":"Niemann","firstName":"Albert /Mus./","page":"204","scan":"00000204","nameMari":"","notes":""},{"currNumber":"170","name":"Norden, Arthur","lastName":"Norden","firstName":"Arthur","page":"205","scan":"00000205","nameMari":"","notes":""},{"currNumber":"171","name":"Nuschke, Otto","lastName":"Nuschke","firstName":"Otto","page":"206","scan":"00000206","nameMari":"","notes":""},{"currNumber":"172","name":"Ochs, Siegfried /Mus./","lastName":"Ochs","firstName":"Siegfried /Mus./","page":"207","scan":"00000207","nameMari":"","notes":""},{"currNumber":"173","name":"Orlik, Emil","lastName":"Orlik","firstName":"Emil","page":"208","scan":"00000208","nameMari":"","notes":""},{"currNumber":"174","name":"Payer, Friedrich v.","lastName":"Payer","firstName":"Friedrich v.","page":"209","scan":"00000209","nameMari":"","notes":""},{"currNumber":"175","name":"Persius, Lothar","lastName":"Persius","firstName":"Lothar","page":"210","scan":"00000210","nameMari":"","notes":""},{"currNumber":"176","name":"Philippi, Felix","lastName":"Philippi","firstName":"Felix","page":"211","scan":"00000211","nameMari":"","notes":""},{"currNumber":"177","name":"Philippson, Martin","lastName":"Philippson","firstName":"Martin","page":"212","scan":"00000212","nameMari":"","notes":""},{"currNumber":"178","name":"Pierson, Edgar","lastName":"Pierson","firstName":"Edgar","page":"213","scan":"00000213","nameMari":"","notes":""},{"currNumber":"179","name":"Pilz, Albert","lastName":"Pilz","firstName":"Albert","page":"214","scan":"00000214","nameMari":"","notes":""},{"currNumber":"180","name":"Pinner, Fritz","lastName":"Pinner","firstName":"Fritz","page":"215","scan":"00000215","nameMari":"","notes":""},{"currNumber":"181","name":"Plothow, Anna","lastName":"Plothow","firstName":"Anna","page":"216","scan":"00000216","nameMari":"","notes":""},{"currNumber":"182","name":"Poppe, Rosa","lastName":"Poppe","firstName":"Rosa","page":"217","scan":"00000217","nameMari":"","notes":""},{"currNumber":"183","name":"Poppe, Theodor Adolf","lastName":"Poppe","firstName":"Theodor Adolf","page":"218","scan":"00000218","nameMari":"","notes":""},{"currNumber":"184","name":"Possart, Ernst v.","lastName":"Possart","firstName":"Ernst v.","page":"219","scan":"00000219","nameMari":"","notes":""},{"currNumber":"185","name":"Potthoff, Heinz","lastName":"Potthoff","firstName":"Heinz","page":"220","scan":"00000220","nameMari":"","notes":""},{"currNumber":"186","name":"Preuß, Hugo","lastName":"Preuß","firstName":"Hugo","page":"221","scan":"00000221","nameMari":"","notes":""},{"currNumber":"187","name":"Prochownik, Berthold","lastName":"Prochownik","firstName":"Berthold","page":"222","scan":"00000222","nameMari":"","notes":""},{"currNumber":"188","name":"Putlitz, Baron zu","lastName":"Putlitz","firstName":"Baron zu","page":"223","scan":"00000223","nameMari":"","notes":""},{"currNumber":"189","name":"Rathenau, Emil","lastName":"Rathenau","firstName":"Emil","page":"224","scan":"00000224","nameMari":"","notes":""},{"currNumber":"190","name":"Ravené, Louis","lastName":"Ravené","firstName":"Louis","page":"105","scan":"00000105","nameMari":"","notes":""},{"currNumber":"191","name":"Reiche-Frei, Laura","lastName":"Reiche-Frei","firstName":"Laura","page":"227","scan":"00000227","nameMari":"","notes":""},{"currNumber":"192","name":"Reicke, Georg","lastName":"Reicke","firstName":"Georg","page":"228","scan":"00000228","nameMari":"","notes":""},{"currNumber":"193","name":"Reinhardt, Max","lastName":"Reinhardt","firstName":"Max","page":"229","scan":"00000229","nameMari":"","notes":""},{"currNumber":"194","name":"Reuter, Gabriele","lastName":"Reuter","firstName":"Gabriele","page":"230","scan":"00000230","nameMari":"","notes":""},{"currNumber":"195","name":"Riesser, Jak.","lastName":"Riesser","firstName":"Jak.","page":"231","scan":"00000231","nameMari":"","notes":""},{"currNumber":"196","name":"Roda Roda, Alexander","lastName":"Roda Roda","firstName":"Alexander","page":"232","scan":"00000232","nameMari":"","notes":""},{"currNumber":"197","name":"Rodenberg, Julius","lastName":"Rodenberg","firstName":"Julius","page":"233","scan":"00000233","nameMari":"","notes":""},{"currNumber":"198","name":"Roeb, J.","lastName":"Roeb","firstName":"J.","page":"234","scan":"00000234","nameMari":"","notes":""},{"currNumber":"199","name":"Roeder, Adolf","lastName":"Roeder","firstName":"Adolf","page":"235","scan":"00000235","nameMari":"","notes":""},{"currNumber":"200","name":"Rosenow, Leopold","lastName":"Rosenow","firstName":"Leopold","page":"236","scan":"00000236","nameMari":"","notes":""},{"currNumber":"201","name":"Rosner, Karl","lastName":"Rosner","firstName":"Karl","page":"237","scan":"00000237","nameMari":"","notes":""},{"currNumber":"202","name":"Rüfer, Philipp /Mus./","lastName":"Rüfer","firstName":"Philipp /Mus./","page":"238","scan":"00000238","nameMari":"","notes":""},{"currNumber":"203","name":"Runze, Maximilian","lastName":"Runze","firstName":"Maximilian","page":"239","scan":"00000239","nameMari":"","notes":""},{"currNumber":"204","name":"Salomon, Alice","lastName":"Salomon","firstName":"Alice","page":"240","scan":"00000240","nameMari":"","notes":""},{"currNumber":"205","name":"Salten, Felix","lastName":"Salten","firstName":"Felix","page":"241","scan":"00000241","nameMari":"","notes":""},{"currNumber":"206","name":"Schach, Max","lastName":"Schach","firstName":"Max","page":"243","scan":"00000243","nameMari":"","notes":""},{"currNumber":"207","name":"Scherres, Carl","lastName":"Scherres","firstName":"Carl","page":"244","scan":"00000244","nameMari":"Scherres, Carl","notes":""},{"currNumber":"208","name":"Scheurenberg, Josef","lastName":"Scheurenberg","firstName":"Josef","page":"245","scan":"00000245","nameMari":"Scheurenberg, Josef","notes":""},{"currNumber":"209","name":"Schlenther, Paul","lastName":"Schlenther","firstName":"Paul","page":"246","scan":"00000246","nameMari":"","notes":""},{"currNumber":"210","name":"Schlingmann, Reinhold","lastName":"Schlingmann","firstName":"Reinhold","page":"247","scan":"00000247","nameMari":"","notes":""},{"currNumber":"211","name":"Schmidt, Friedrich","lastName":"Schmidt","firstName":"Friedrich","page":"248","scan":"00000248","nameMari":"","notes":""},{"currNumber":"212","name":"Schmidt, Leopold","lastName":"Schmidt","firstName":"Leopold","page":"249","scan":"00000249","nameMari":"","notes":""},{"currNumber":"213","name":"Schmölder, Robert","lastName":"Schmölder","firstName":"Robert","page":"250","scan":"00000250","nameMari":"","notes":""},{"currNumber":"214","name":"Schönaich-Carolath, Heinrich Prinz zu","lastName":"Schönaich-Carolath","firstName":"Heinrich Prinz zu","page":"251","scan":"00000251","nameMari":"","notes":""},{"currNumber":"215","name":"Schott, Walter","lastName":"Schott","firstName":"Walter","page":"252","scan":"00000252","nameMari":"Schott, Walter","notes":""},{"currNumber":"216","name":"Schrader, K.","lastName":"Schrader","firstName":"K.","page":"253","scan":"00000253","nameMari":"","notes":""},{"currNumber":"217","name":"Schreiber, Ferdinand","lastName":"Schreiber","firstName":"Ferdinand","page":"254","scan":"00000254","nameMari":"","notes":""},{"currNumber":"218","name":"Schröder, Max","lastName":"Schröder","firstName":"Max","page":"255","scan":"00000255","nameMari":"","notes":""},{"currNumber":"219","name":"Schubin, Ossip","lastName":"Schubin","firstName":"Ossip","page":"256","scan":"00000256","nameMari":"","notes":""},{"currNumber":"220","name":"Schüler, Paul","lastName":"Schüler","firstName":"Paul","page":"257","scan":"00000257","nameMari":"","notes":""},{"currNumber":"221","name":"Schulze-Gaevernitz, Gerhart v.","lastName":"Schulze-Gaevernitz","firstName":"Gerhart v.","page":"258","scan":"00000258","nameMari":"","notes":""},{"currNumber":"222","name":"Schuster-Woldan, Raffael","lastName":"Schuster-Woldan","firstName":"Raffael","page":"259","scan":"00000259","nameMari":"","notes":""},{"currNumber":"223","name":"Schwab, Josef","lastName":"Schwab","firstName":"Josef","page":"260","scan":"00000260","nameMari":"","notes":""},{"currNumber":"224","name":"Schwickert, Eberhard /Mus./ (Schwickereth?)","lastName":"Schwickert","firstName":"Eberhard /Mus./ (Schwickereth?)","page":"267","scan":"00000267","nameMari":"","notes":""},{"currNumber":"225","name":"Seebach, Nikolaus Graf v.","lastName":"Seebach","firstName":"Nikolaus Graf v.","page":"242","scan":"00000242","nameMari":"","notes":""},{"currNumber":"226","name":"Siegerist, Georg","lastName":"Siegerist","firstName":"Georg","page":"261","scan":"00000261","nameMari":"","notes":""},{"currNumber":"227","name":"Siegismund, Karl","lastName":"Siegismund","firstName":"Karl","page":"262","scan":"00000262","nameMari":"","notes":""},{"currNumber":"228","name":"Simon, James /Mus./","lastName":"Simon","firstName":"James /Mus./","page":"263","scan":"00000263","nameMari":"","notes":""},{"currNumber":"229","name":"Sontag","lastName":"Sontag","firstName":"","page":"265","scan":"00000265","nameMari":"","notes":""},{"currNumber":"230","name":"Sorma, Agnes","lastName":"Sorma","firstName":"Agnes","page":"266","scan":"00000266","nameMari":"","notes":""},{"currNumber":"231","name":"Stahl, Fritz","lastName":"Stahl","firstName":"Fritz","page":"268","scan":"00000268","nameMari":"","notes":""},{"currNumber":"232","name":"Stahl, H. v.","lastName":"Stahl","firstName":"H. v.","page":"269","scan":"00000269","nameMari":"","notes":""},{"currNumber":"233","name":"Stein, Ludwig","lastName":"Stein","firstName":"Ludwig","page":"271","scan":"00000271","nameMari":"","notes":""},{"currNumber":"234","name":"Steinthal, Max","lastName":"Steinthal","firstName":"Max","page":"272","scan":"00000272","nameMari":"","notes":""},{"currNumber":"235","name":"Stettenheim, Julius","lastName":"Stettenheim","firstName":"Julius","page":"273","scan":"00000273","nameMari":"","notes":""},{"currNumber":"236","name":"Stilke. Hermann","lastName":"Stilke. Hermann","firstName":"","page":"274","scan":"00000274","nameMari":"","notes":""},{"currNumber":"237","name":"Suttner, Bertha v.","lastName":"Suttner","firstName":"Bertha v.","page":"278","scan":"00000278","nameMari":"","notes":""},{"currNumber":"238","name":"Tews, Johannes","lastName":"Tews","firstName":"Johannes","page":"279","scan":"00000279","nameMari":"","notes":""},{"currNumber":"239","name":"Tietz, Oscar","lastName":"Tietz","firstName":"Oscar","page":"280","scan":"00000280","nameMari":"","notes":""},{"currNumber":"240","name":"Traub, Gottfried","lastName":"Traub","firstName":"Gottfried","page":"281","scan":"00000281","nameMari":"","notes":""},{"currNumber":"241","name":"Trojan, Johannes","lastName":"Trojan","firstName":"Johannes","page":"282","scan":"00000282","nameMari":"","notes":""},{"currNumber":"242","name":"Tschiedel, Johannes","lastName":"Tschiedel","firstName":"Johannes","page":"283","scan":"00000283","nameMari":"","notes":""},{"currNumber":"243","name":"Vely, Clara","lastName":"Vely","firstName":"Clara","page":"284","scan":"00000284","nameMari":"","notes":""},{"currNumber":"244","name":"Viebig, Clara","lastName":"Viebig","firstName":"Clara","page":"285","scan":"00000285","nameMari":"","notes":""},{"currNumber":"245","name":"Vogel, Hugo","lastName":"Vogel","firstName":"Hugo","page":"286","scan":"00000286","nameMari":"","notes":""},{"currNumber":"246","name":"Vohsen, Marie","lastName":"Vohsen","firstName":"Marie","page":"287","scan":"00000287","nameMari":"","notes":""},{"currNumber":"247","name":"Vollrath, Karl","lastName":"Vollrath","firstName":"Karl","page":"288","scan":"00000288","nameMari":"","notes":""},{"currNumber":"248","name":"Waldeyer, Wilhelm","lastName":"Waldeyer","firstName":"Wilhelm","page":"289","scan":"00000289","nameMari":"","notes":""},{"currNumber":"249","name":"Waldschmidt, Walther","lastName":"Waldschmidt","firstName":"Walther","page":"290","scan":"00000290","nameMari":"","notes":""},{"currNumber":"250","name":"Waldstein, Felix","lastName":"Waldstein","firstName":"Felix","page":"291","scan":"00000291","nameMari":"","notes":""},{"currNumber":"251","name":"Weißmann, Adolf","lastName":"Weißmann","firstName":"Adolf","page":"292","scan":"00000292","nameMari":"","notes":""},{"currNumber":"252","name":"Wendorff. Hugo","lastName":"Wendorff. Hugo","firstName":"","page":"293","scan":"00000293","nameMari":"","notes":""},{"currNumber":"253","name":"Wermuth, Adolf","lastName":"Wermuth","firstName":"Adolf","page":"294","scan":"00000294","nameMari":"","notes":""},{"currNumber":"254","name":"Werner, Anton v.","lastName":"Werner","firstName":"Anton v.","page":"295","scan":"00000295","nameMari":"Werner, Anton von","notes":""},{"currNumber":"255","name":"Whitman, Sidney","lastName":"Whitman","firstName":"Sidney","page":"296","scan":"00000296","nameMari":"","notes":""},{"currNumber":"256","name":"Wiemer, Otto","lastName":"Wiemer","firstName":"Otto","page":"297","scan":"00000297","nameMari":"","notes":""},{"currNumber":"257","name":"Wilke, H.","lastName":"Wilke","firstName":"H.","page":"298","scan":"00000298","nameMari":"","notes":""},{"currNumber":"258","name":"Wolff, Anna Julia","lastName":"Wolff","firstName":"Anna Julia","page":"299","scan":"00000299","nameMari":"","notes":""},{"currNumber":"259","name":"Wolff, Theodor","lastName":"Wolff","firstName":"Theodor","page":"300","scan":"00000300","nameMari":"","notes":""},{"currNumber":"260","name":"Wolff-Frank, Ulla","lastName":"Wolff-Frank","firstName":"Ulla","page":"301","scan":"00000301","nameMari":"","notes":""},{"currNumber":"261","name":"Wolzogen, Ernst v.","lastName":"Wolzogen","firstName":"Ernst v.","page":"302","scan":"00000302","nameMari":"","notes":""},{"currNumber":"262","name":"Wulle, Friedrich","lastName":"Wulle","firstName":"Friedrich","page":"303","scan":"00000303","nameMari":"","notes":""},{"currNumber":"263","name":"Wunschmann, Gustav","lastName":"Wunschmann","firstName":"Gustav","page":"304","scan":"00000304","nameMari":"","notes":""},{"currNumber":"264","name":"Zobeltitz, Fedor v.","lastName":"Zobeltitz","firstName":"Fedor v.","page":"307","scan":"00000307","nameMari":"","notes":""},{"currNumber":"265","name":"Zweig, Stefan","lastName":"Zweig","firstName":"Stefan","page":"308","scan":"00000308","nameMari":"","notes":""},{"currNumber":"266","name":"Zwenger, Eugen","lastName":"Zwenger","firstName":"Eugen","page":"309","scan":"00000309","nameMari":"","notes":""}]

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/create.js
var create = __webpack_require__("OvRC");
var create_default = /*#__PURE__*/__webpack_require__.n(create);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/static/album.json
var static_album = __webpack_require__("MRsk");
var album_default = /*#__PURE__*/__webpack_require__.n(static_album);

// CONCATENATED MODULE: ./src/store/store.js










vue_esm["default"].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  state: {
    loader: 0,
    loaderText: 'loader_text',
    currAlbumPage: null,
    markers: [{
      level: 'EG',
      id: 'EG_SF_04',
      top: 25.5,
      left: 89.1,
      label1908: 'Skulpturenhalle X'
    }, {
      level: 'OG-1',
      id: 'OG-1_SF_05',
      top: 24.5,
      left: 91.3,
      label1908: 'Gobelinsaal IX'
    }, {
      level: 'OG-1',
      id: 'OG-1_SF_04',
      top: 40,
      left: 91.3,
      label1908: 'Zimmer VIII'
    }, {
      level: 'OG-1',
      id: 'OG-1_SF_03',
      top: 50.2,
      left: 91.3,
      label1908: 'Zimmer VII'
    }, {
      level: 'OG-1',
      id: 'OG-1_SF_02',
      top: 61.6,
      left: 91.3,
      label1908: 'Zimmer VI'
    }, {
      level: 'OG-1',
      id: 'OG-1_VH_01',
      top: 90,
      left: 91.3,
      label1908: 'Musiksaal V'
    }, {
      level: 'OG-1',
      id: 'OG-1_VH_02',
      top: 90,
      left: 64.3,
      label1908: 'Rokkoko-Zimmer VII'
    }, {
      level: 'OG-1',
      id: 'OG-1_VH_03',
      top: 90,
      left: 49.9,
      label1908: 'Herren-Zimmer VIII'
    }, {
      level: 'OG-1',
      id: 'OG-1_VH_04',
      top: 90,
      left: 33.9,
      label1908: 'Damen-Zimmer IX'
    }, {
      level: 'OG-1',
      id: 'OG-1_VH_05',
      top: 90,
      left: 13.8,
      label1908: 'Speise-Zimmer X'
    }, {
      level: 'OG-2',
      id: 'OG-2_VH_01',
      top: 87.7,
      left: 88.8,
      label1908: 'Festsaal XV'
    }, {
      level: 'OG-2',
      id: 'OG-2_VH_02',
      top: 89.0,
      left: 63.8,
      label1908: 'Zimmer XVII'
    }, {
      level: 'OG-2',
      id: 'OG-2_VH_03',
      top: 89.0,
      left: 49.4,
      label1908: 'Zimmer XVIII'
    }, {
      level: 'OG-2',
      id: 'OG-2_VH_04',
      top: 89.0,
      left: 34.5,
      label1908: 'Zimmer XIX'
    }, {
      level: 'OG-2',
      id: 'OG-2_VH_05',
      top: 89.0,
      left: 16.8,
      label1908: 'Zimmer XX'
    }, {
      level: 'OG-2',
      id: 'OG-2_SF_01',
      top: 74.7,
      left: 88.8,
      label1908: 'Vorraum XI'
    }, {
      level: 'OG-2',
      id: 'OG-2_SF_02',
      top: 61.4,
      left: 88.8,
      label1908: 'Zimmer XII'
    }, {
      level: 'OG-2',
      id: 'OG-2_SF_03',
      top: 51.6,
      left: 88.8,
      label1908: 'Zimmer XIII'
    }, {
      level: 'OG-2',
      id: 'OG-2_SF_04',
      top: 42.4,
      left: 88.8,
      label1908: 'Zimmer XIV'
    }, {
      level: 'OG-2',
      id: 'OG-2_HF_01',
      top: 76.1,
      left: 74.7,
      label1908: 'Nebenraum XVI'
    }],
    lang: 'de',
    translate: {
      'Abschnitt': {
        en: 'Section',
        de: 'Abschnitt'
      },
      'Einleitung': {
        en: 'Introduction',
        de: 'Einleitung'
      },
      'Beitrag': {
        en: 'Post',
        de: 'Beitrag'
      },
      'Aktuelles': {
        en: 'News',
        de: 'Aktuelles'
      },
      'Beiträge': {
        en: 'Posts',
        de: 'Beiträge'
      },
      'mehr_erfahren': {
        en: 'learn more',
        de: 'mehr erfahren'
      },
      'search_results': {
        en: 'Searchresults',
        de: 'Suchergebnisse'
      },
      'Basisrecherche (Hausarbeit) von': {
        en: 'Term paper',
        de: 'Seminararbeit'
      },
      'Danksagung': {
        en: 'Acknowledgments',
        de: 'Unterstützung und Auskünfte'
      },
      'Textquelle': {
        en: 'Textual Source',
        de: 'Textquelle'
      },
      'Bilddokument': {
        en: 'Image document',
        de: 'Bilddokument'
      },
      'num_search_results': {
        en: 'objects found',
        de: 'Objekte gefunden'
      },
      'db_object_not_found': {
        en: 'The requested object could not be found in the database.',
        de: 'Das angefragte Objekt konnte in der Datenbannk nicht gefunden werden.'
      },
      'loading': {
        en: 'loading',
        de: 'Lade'
      },
      'loading_db': {
        en: 'loading database',
        de: 'Lade Datenbank'
      },
      'DB-Abdeckung': {
        en: '<p>The MARI database is in a process of continuous expansion: it currently only includes subsets of the works that were part of the Mosse/Lachmann-Mosse collection. Please also consult the <a   href="http://www.lostart.de/Webs/DE/LostArt/Index.html" alt="Link zu Lost Art-Datenbank des Deutschen Zentrums   Kulturgutverluste" target="_blank">Lost Art Internet Database</a>, Deutsches Zentrum Kulturgutverluste</p>',
        de: '<p>Die MARI-Datenbank befindet sich im Aufbau. Sie erfasst zurzeit nur einen Teil der Werke, die sich in der Sammlung Mosse bzw. Lachmann-Mosse befanden.<br/>Bitte konsultieren Sie auch die <a   href="http://www.lostart.de/Webs/DE/LostArt/Index.html" alt="Link zu Lost Art-Datenbank des Deutschen Zentrums   Kulturgutverluste" target="_blank">Lost Art-Datenbank</a> des Deutschen Zentrums Kulturgutverluste.</p>'
      },
      'Werke': {
        en: 'Artworks',
        de: 'Werke'
      },
      'Suchen': {
        en: 'Search',
        de: 'Suchen'
      },
      'Suche': {
        en: 'Search',
        de: 'Suche'
      },
      'Alle Werke': {
        en: 'All Works',
        de: 'Alle Werke'
      },
      'Künstler': {
        en: 'Artists',
        de: 'Künstler'
      },
      'mehr': {
        en: 'Metadata from Sources',
        de: 'Metadaten aus den Quellen'
      },
      'beziehungen_zu_diesem_werk': {
        en: 'Sources',
        de: 'Quellen'
      },
      'beziehungstyp': {
        en: 'Relation Type',
        de: 'Art der Beziehung'
      },
      'lost_art_link': {
        en: 'Lost Art Link',
        de: 'Lost Art Link'
      },
      'Forschungsstand': {
        en: 'State of Research',
        de: 'Forschungsstand'
      },
      // // // // Metadaten des Objekttyps Publikation
      'Ausgabe-Format': {
        en: 'Source',
        de: 'Quelle'
        // Anzeige in Textnachricht etc. anstelle von Feld Quellenangabe (ausschließendes oder)
      },
      // // // // Metadaten des Objekttyps Nachricht Textquelle
      // // // Quellenangaben
      'Quellenangabe': {
        en: 'Source',
        de: 'Quelle'
      },
      'Angabe Online-Quelle, Bezeichnung': {
        en: 'Source',
        de: 'Quelle'
        // als Link mit der URL aus Angabe Online-Quelle, URL
      },
      'Seite in Quelle': {
        en: 'Pagenumber',
        de: 'Seitenangabe'
      },
      'Nr. in Quelle': {
        en: 'Number',
        de: 'Nummer'
      },
      'Verweis Abbildung': {
        en: 'Illustration reference',
        de: 'Abbildungsverweis'
      },
      'Keine Abbildung vorhanden': {
        en: 'No image available',
        de: 'Keine Abbildung vorhanden'
      },
      // // // Metadaten zum Werk (Shared Object)
      'Objekt-Kategorie': {
        // ohne Feldbezeichnung ausgeben
        en: '',
        de: ''
      },
      // // Basisdaten
      'Titel': {
        en: 'Title',
        de: 'Titel'
      },
      'Urheber': {
        en: 'Artist',
        de: 'Künstler'
      },
      'Material und Technik': {
        en: 'Material and Technique',
        de: 'Material und Technik'
      },
      'Maße': {
        en: 'Dimensions',
        de: 'Maße'
      },
      // // charakterisierende Metadaten
      'Beschreibung': {
        en: 'Description',
        de: 'Beschreibung'
      },
      'Information Zustand, Beschaffenheit': {
        en: 'Condition',
        de: 'Zustand'
      },
      'Rubrik': {
        en: 'Category',
        de: 'Rubrik'
      },
      // // Details zum Objekt
      'Rahmen': {
        en: 'Frame',
        de: 'Angaben zur Rahmung'
      },
      'Signatur': {
        en: 'Signature or writing on the work',
        de: 'Bezeichnung'
      },
      'Datierung': {
        en: 'Date',
        de: 'Angaben zur Datierung'
      },
      'Erwerbung durch Mosse': {
        en: 'Information on Mosse\'s acquisition of the work',
        de: 'zum Erwerb durch Mosse'
      },
      'Angabe Besitzer/Eigentümer': {
        en: 'Owner',
        de: 'Besitzer'
      },
      'Angabe Vorbesitzer': {
        en: 'Previous owner',
        de: 'früherer Besitzer'
      },
      'Angabe Transaktion': {
        en: 'Transaction',
        de: 'Transaktion'
      },
      'Preisangaben': {
        en: 'Price Information',
        de: 'Preisangabe'
      },
      'Angabe Ausstellung': {
        en: 'Exhibition references',
        de: ''
      },
      'Ort': {
        en: 'Location',
        de: 'Ort'
      },
      'Angabe Standort': {
        en: 'Information about the location',
        de: 'Angabe zum Standort'
      },
      'Nachricht über das Werk': {
        en: 'History of the object',
        de: 'Geschichte des Werkes'
      },
      'Bildlegende': {
        en: 'Imagecaption',
        de: 'Bildlegende'
      },
      'Bildrechte': {
        en: 'Image rights',
        de: 'Bildrechte'
      },
      'Online-Quelle': {
        en: 'Online-Resource',
        de: 'Online-Quelle'
      },
      // // ergänzende Informationen
      'Verweis Literatur': {
        en: 'References',
        de: 'Literaturhinweise'
      },
      // // // Anmerkungen
      'Referenz': {
        en: 'Notes',
        de: 'Anmerkungen'
      },
      // // // // in shared objects
      'Claim vor MARI': {
        en: 'located before MARI',
        de: 'lokalisiert vor MARI'
      },
      // // // filter
      'Anzeigen alle Objekte': {
        en: 'Show objects',
        de: 'Anzeigen Objekte'
      },
      'nur Buchobjekte': {
        en: 'Only Books',
        de: 'Nur Buchobjekte'
      },
      'von MARI bearbeitet': {
        en: 'researched by MARI',
        de: 'von MARI bearbeitet'
      },
      'von MARI lokalisiert': {
        en: 'localized by MARI',
        de: 'von MARI lokalisiert'
      },
      'lokalisiert vor MARI': {
        en: 'located before MARI',
        de: 'lokalisiert vor MARI'
      },
      'alle': {
        en: 'all',
        de: 'alle'
      },
      'Nachgewiesen in': {
        en: 'Documented in',
        de: 'Nachgewiesen in'
      },
      'alle Quellen': {
        en: 'all sources',
        de: 'alle Quellen'
      },
      'andere Quellen': {
        en: 'other sources',
        de: 'andere Quellen'
      },
      'Detailseite': {
        en: 'Details about this object ...',
        de: 'Details zu diesem Objekt ...'
      },
      'transactions': {
        en: 'Provenance',
        de: 'Provenienz'
      },
      'allgemeine Quelle': {
        en: 'Resource',
        de: 'Quelle'
      },
      'Seite zurück': {
        en: 'go back',
        de: 'zurück'
      },
      'Bildquellen': {
        en: 'Image Sources',
        de: 'Bildquellen'
      },
      Forschungsdatenbank: {
        en: 'Research Database',
        de: 'Forschungsdatenbank'
      },
      Zitierhinweis: {
        en: 'Please cite this entry as:',
        de: 'Bitte zitieren Sie den Eintrag zu diesem Werk als:'
      },
      Volltextsuche: {
        en: 'Fulltext Search',
        de: 'Volltextsuche'
      },
      'Erweiterte Suche': {
        en: 'Advanced Search',
        de: 'Erweiterte Suche'
      },
      'Weitere Angaben': {
        de: 'Weitere Angaben',
        en: 'Details'
      },
      // Album
      'Intro Album': {
        de: 'Album Amicorum',
        en: 'Album Amicorum'
      },
      'Sub Album': {
        de: 'für Rudolf Mosse zum 8. Mai 1913',
        en: 'dedicated to Rudolf Mosse, May 8th, 1913'
      },
      'Widmungen': {
        de: 'Widmungen von:<br>(Namen anklicken)',
        en: 'Dedications by:<br>(click on names)'
      },
      'Widmung von': {
        de: 'Widmung von',
        en: 'Dedication by'
      },
      'Titelseite Album': {
        de: '(Titelseite)',
        en: '(Title Page)'
      },
      // Pläne
      'Intro Pläne': {
        de: 'Sammlungspräsentation im Mosse-Palais, Leipziger Platz',
        en: 'Presentation of the Mosses Collection in Mosse-Palais, Leipziger Platz'
      },
      'Zur Anzeige der Werke bitte im Plan auf einen Raum klicken!': {
        de: 'Zur Anzeige der Werke bitte im Plan auf einen Raum klicken!',
        en: 'Click on a room in the plan to display list of works'
      },
      'Werke in Raum': {
        de: 'Werke in Raum',
        en: 'works in room'
      },
      'Zeitstufe': {
        de: 'Zeitstufe',
        en: 'Period'
      },
      // Geschossangaben
      'Geschoss': {
        de: 'Geschoss',
        en: 'Floor'
      },
      'EG': {
        de: 'Erdgeschoss',
        en: 'Ground Floor'
      },
      'OG1': {
        de: '1. OG',
        en: 'First Floor'
      },
      'OG2': {
        de: '2. OG',
        en: 'Second Floor'
      },
      'Quelle der Rekonstruktion': {
        de: 'Quelle der Rekonstruktion',
        en: 'Source of reconstruction'
      },
      'Katalog einsehen': {
        de: 'Katalog einsehen ...',
        en: 'Show catalog ...'
      },
      'page_not_found': {
        de: '404 - Seite nicht gefunden',
        en: '404 - Page not found'
      },
      'page_not_found_text': {
        de: 'Die angeforderte Seite konnte nicht gefunden werden.',
        en: 'The requested page could not be found.'
      },
      'loader_text': {
        de: 'Die Anwendung wird geladen ...',
        en: 'Loading application ...'
      },
      'loader_text_db': {
        de: 'Die Werkliste wird geladen ...',
        en: 'Loading list of works ...'
      },
      'loader_text_mosse_palais': {
        de: 'Auf der Grundlage von historischen Plänen wurde ein interaktiver Grundriss des Mosse-Palais\' am Leipziger Platz erstellt und die in den Sammlungskatalogen verzeichneten Standorte der Kunstwerke den Räumen zugeordnet ...',
        en: 'An interactive floor plan of the Mosse-Palais on Leipziger Platz was created on the basis of historical plans and the locations of the artworks listed in the collection catalogs were assigned to the rooms ...'
      },
      '404': {
        de: '404 - Objekt nicht gefunden. Bitte überprüfen Sie die URL. Fehlermeldung war:',
        en: '404 - Object not found. Please check the URL. Error message was:'
      },
      'ohne Autorenangabe': {
        de: 'ohne Autorenangabe',
        en: 'without author'
      },
      'Bibliotheksobjekte': {
        de: 'Bibliotheksobjekte',
        en: 'Library objects'
      },
      'Kunstwerke': {
        de: 'Kunstwerke',
        en: 'Artworks'
      }
    },
    pages: [],
    posts: [],
    aktuelles: [],
    firstpost: {},
    pagesMultilang: { 'de': [], 'en': [] },
    pageNav: [],
    pageNavMultilang: { 'de': [], 'en': [] },
    dbIndex: [],
    contextTransactions: [{
      'Datum Transaktion (maschinell)': '1920-09-08',
      'Datum Transaktion Ausgabe': '08.09.1920',
      'Vorbesitzer': 'Rudolf Mosse',
      'Erwerber': 'Emilie Mosse',
      'Transaktion Ausgabe': '[Kontext:]<br>Eigentumsübertragung<br>Rudolf Mosse (†&nbsp;08.09.1920) an<br>Emilie Mosse als Alleinerbin',
      'Kontext': true
    }, {
      'Datum Transaktion (maschinell)': '1924-10-12',
      'Datum Transaktion Ausgabe': '12.10.1924',
      'Vorbesitzer': 'Emilie Mosse',
      'Erwerber': 'Felicia Lachmann-Mosse',
      'Transaktion Ausgabe': '[Kontext:]<br>Eigentumsübertragung<br>Emilie Mosse (†&nbsp;12.10.1924) an<br>Felicia Lachmann-Mosse als Alleinerbin',
      'Kontext': true
    }, {
      'Datum Transaktion (maschinell)': '1934-02-05',
      'Datum Transaktion Ausgabe': '05.02.1934',
      'Vorbesitzer': 'Felicia Lachmann-Mosse',
      'Erwerber': 'Rudolf Mosse Treuhand Verwaltungs GmbH',
      'Transaktion Ausgabe': '[Kontext:]<br>Eigentumsübertragung<br>Felicia Lachmann-Mosse an<br>Rudolf Mosse Treuhand Verwaltungs GmbH',
      'Kontext': true
    }],
    rooms: [{
      sigle: 'EG_SF_04',
      position: {
        x: 34.56,
        y: 12.78
      },
      1900: 'Skulpturenhalle',
      1908: 'Skulpturenhalle X',
      1912: 'Skulpturensaal IV',
      1913: 'Skulpturensaal IV',
      1915: 'Skulpturensaal IV',
      1921: 'Skulpturensaal IV'
    }, {
      sigle: 'EG_SF_05',
      position: {
        x: 44.56,
        y: 42.78
      },
      1900: null,
      1908: null,
      1912: 'Kuppelraum V',
      1913: 'Kuppelraum V',
      1915: 'Kuppelraum V',
      1921: 'Kuppelraum V'
    }, {
      sigle: 'EG_HF_01',
      position: {
        x: 54.56,
        y: 52.78
      },
      1900: null,
      1908: null,
      1912: 'Loggia VI',
      1913: 'Loggia VI',
      1915: 'Loggia VI',
      1921: 'Loggia VI'
    }],
    plans: {
      1908: [{
        EG: '/static/img/plans/1908_EG_01.svg',
        OG1: '/static/img/plans/1908_OG_01_01.svg',
        OG2: '/static/img/plans/1908_OG_02_01.svg'
      }]
    },
    periods: [1908, 1915, 1921],
    roomPeriods: [{
      year: 1908,
      source: 'Mosse 1908',
      key: 'period1908',
      levels: ['EG', 'OG1', 'OG2'],
      thumb: 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K_1908_Cover_thumbnail.jpg',
      pdf: 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K08_KBB_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1908-Leo-Baeck.pdf'

    }, {
      year: 1915,
      source: 'Mosse 1915',
      key: 'period1915'
    }, {
      year: 1921,
      source: 'Mosse 1921',
      key: 'period1921'
    }],
    roomIds: ['EG_VH_01', 'EG_VH_02', 'EG_SF_01', 'EG_SF_02',
    // 'EG_SF_03',
    'EG_SF_04', 'EG_SF_05', 'EG_HF_01', 'OG-1_VH_01', 'OG-1_VH_02', 'OG-1_VH_03', 'OG-1_VH_04', 'OG-1_VH_05', 'OG-1_SF_01', 'OG-1_SF_02', 'OG-1_SF_03', 'OG-1_SF_04', 'OG-1_SF_05',
    // 'OG-1_SF_06',
    'OG-1_HF_01',
    // 'OG-1_HF_02',
    // 'OG-1_HF_03',
    'OG-2_VH_01', 'OG-2_VH_02', 'OG-2_VH_03', 'OG-2_VH_04', 'OG-2_VH_05', 'OG-2_SF_01', 'OG-2_SF_02', 'OG-2_SF_03', 'OG-2_SF_04', 'OG-2_HF_01', 'OG-2_HF_02'
    // 'OG-2_HF_03'
    ],
    roomListings: {},
    sharedObjects: [],
    sharedObject: {},
    sharedObjectLoader: 0,
    metaSources: {},
    archivbestandObjekts: [],
    displayFields: ['Titel', 'Urheber', 'Material und Technik', 'Maße', 'Beschreibung', 'Information Zustand, Beschaffenheit', 'Rubrik', 'Rahmen', 'Signatur', 'Datierung', 'Erwerbung durch Mosse', 'Angabe Besitzer/Eigentümer', 'Angabe Vorbesitzer', 'Angabe Transaktion', 'Preisangaben', 'Angabe Ausstellung', 'Ort', 'Angabe Standort', 'Nachricht über das Werk', 'Weitere Angaben', 'Verweis Literatur', 'Referenz'],
    errors: []
  },
  getters: {
    loader: function loader(state) {
      return state.loader;
    },
    loaderText: function loaderText(state) {
      return state.loaderText;
    },
    currAlbumPage: function currAlbumPage(state) {
      return state.currAlbumPage;
    },
    album: function album() {
      return album_default.a;
    },
    markers1908: function markers1908(state) {
      var period = '1908';
      var markers = state.markers.map(function (m) {
        var marker = m;
        marker.label = m['label' + period];
        return marker;
      });
      var eg = markers.filter(function (m) {
        return m.level === 'EG';
      });
      var og1 = markers.filter(function (m) {
        return m.level === 'OG-1';
      });
      var og2 = markers.filter(function (m) {
        return m.level === 'OG-2';
      });
      return { eg: eg, og1: og1, og2: og2 };
    },

    roomPeriods: function roomPeriods(state) {
      return state.roomPeriods;
    },
    roomIds: function roomIds(state) {
      return state.roomIds;
    },
    roomListings: function roomListings(state) {
      return state.roomListings;
    },
    lang: function lang(state) {
      return state.lang;
    },
    translate: function translate(state) {
      return state.translate;
    },
    pages: function pages(state) {
      return state.pages;
    },
    posts: function posts(state) {
      return state.posts;
    },
    aktuelles: function aktuelles(state) {
      return state.aktuelles;
    },
    firstpost: function firstpost(state) {
      return state.firstpost;
    },
    pageNav: function pageNav(state) {
      return state.pageNav;
    },
    dbIndex: function dbIndex(state) {
      return state.dbIndex;
    },
    contextTransactions: function contextTransactions(state) {
      return state.contextTransactions;
    },
    plans: function plans(state) {
      return state.plans;
    },
    rooms: function rooms(state) {
      return state.rooms;
    },
    periods: function periods(state) {
      return state.periods;
    },
    sharedObjects: function sharedObjects(state) {
      return state.sharedObjects;
    },
    sharedObject: function sharedObject(state) {
      return state.sharedObject;
    },
    sharedObjectLoader: function sharedObjectLoader(state) {
      return state.sharedObjectLoader;
    },
    metaSources: function metaSources(state) {
      return state.metaSources;
    },
    archivbestandObjekts: function archivbestandObjekts(state) {
      return state.archivbestandObjekts;
    },
    displayFields: function displayFields(state) {
      return state.displayFields;
    },
    errors: function errors(state) {
      return state.errors;
    }
  },
  mutations: {
    setLoader: function setLoader(state, payload) {
      state.loader = state.loader + payload;
    },
    setLoaderText: function setLoaderText(state, payload) {
      state.loaderText = payload;
    },
    setLang: function setLang(state, payload) {
      state.lang = payload;
    },
    setWpPages: function setWpPages(state, payload) {
      // pages
      var pages = payload.sort(function (a, b) {
        return a.menu_position * 1 > b.menu_position * 1 ? 1 : b.menu_position * 1 > a.menu_position * 1 ? -1 : 0;
      });
      // pageNav
      // let nav = {'de': [], 'en': []}
      pages.forEach(function (page) {
        if (page.status === 'publish') {
          if (page.sprache.length === 0) {
            page.sprache = 'de';
          }
          state.pagesMultilang[page.sprache].push(page);
          if (page.hide_in_menu !== '1') {
            state.pageNavMultilang[page.sprache].push({
              menu_title: page.menu_title,
              slug: page.slug,
              lang: page.sprache,
              id: page.id,
              nav_css_classes: page.nav_css_classes,
              nav_init_open: page.nav_init_open,
              position: page.menu_position,
              parent: page.parent
            });
          }
        }
      });
      state.pages = state.pagesMultilang[state.lang];
      state.pageNav = state.pageNavMultilang[state.lang];
    },
    setWpAktuelles: function setWpAktuelles(state, payload) {
      var posts = payload.sort(function (a, b) {
        var dateA = new Date(a.display_date).getTime();
        var dateB = new Date(b.display_date).getTime();
        return dateA > dateB ? 1 : dateB > dateA ? -1 : 0;
      });
      posts = posts.filter(function (post) {
        return post.status === 'publish';
      });
      state.aktuelles = posts;
    },
    setPosts: function setPosts(state, payload) {
      var posts = payload.sort(function (a, b) {
        return a.post_order * 1 > b.post_order * 1 ? 1 : b.post_order * 1 > a.post_order * 1 ? -1 : 0;
      });
      state.posts = posts;
    },
    setFirstPost: function setFirstPost(state, payload) {
      if (payload.length > 0) {
        payload.forEach(function (post) {
          if (post.post_language === 'en' && !state.firstpost.hasOwnProperty('en')) {
            state.firstpost.en = post;
          }
          if (post.post_language !== 'en' && !state.firstpost.hasOwnProperty('de')) {
            state.firstpost.de = post;
          }
        });
        // state.firstpost = payload[0]
      }
    },
    switchPagesLang: function switchPagesLang(state, lang) {
      state.pages = state.pagesMultilang[lang];
      state.pageNav = state.pageNavMultilang[lang];
    },
    setDbIndex: function setDbIndex(state, payload) {
      state.dbIndex = payload;
    },
    setRoomListings: function setRoomListings(state, payload) {
      state.roomListings = payload;
    },
    setAlbumPage: function setAlbumPage(state, payload) {
      state.currAlbumPage = payload;
    },
    addSharedObject: function addSharedObject(state, payload) {
      state.sharedObjects.push(payload);
    },
    setSharedObjectLoader: function setSharedObjectLoader(state, payload) {
      state.sharedObjectLoader = state.sharedObjectLoader + payload;
    },
    setSharedObject: function setSharedObject(state, payload) {
      state.sharedObject = payload;
    },
    setMetaSources: function setMetaSources(state, payload) {
      state.metaSources = payload;
    },
    addMetaSource: function addMetaSource(state, payload) {
      state.metaSources[payload.id] = payload;
    },
    setArchivbestandObjekts: function setArchivbestandObjekts(state, payload) {
      state.archivbestandObjekts = payload;
    },
    addError: function addError(state, payload) {
      state.errors.push(payload);
    }
  },
  actions: {
    setAlbumPage: function setAlbumPage(_ref, person) {
      var commit = _ref.commit;

      commit('setAlbumPage', person);
    },
    getRoomObjects: function getRoomObjects(context) {
      if (keys_default()(context.state.roomListings).length === 0) {
        context.commit('setLoaderText', 'loader_text_mosse_palais');
        context.commit('setLoader', 1);
        // axios.get('https://www.mari-portal.de/omeka/custom/api/rooms')
        axios_default.a.get('https://www.mari-portal.de/omeka/staticapi/rooms.json').then(function (response) {
          context.commit('setRoomListings', response.data);
        }).catch(function (error) {
          return console.log(error);
        }).finally(function () {
          context.commit('setLoader', -1);
        });
      }
    },
    getWpPages: function getWpPages(context) {
      axios_default.a.get('https://www.mari-portal.de/wp/wp-json/wp/v2/pages?per_page=100').then(function (response) {
        context.commit('setWpPages', response.data);
        // console.log(response.data)
      }).catch(function () {});
    },
    getWpAktuelles: function getWpAktuelles(context) {
      axios_default.a.get('https://www.mari-portal.de/wp/wp-json/wp/v2/aktuelles?per_page=100').then(function (response) {
        context.commit('setWpAktuelles', response.data);
      }).catch(function () {});
    },
    getPosts: function getPosts(context) {
      axios_default.a.get('https://www.mari-portal.de/wp/wp-json/wp/v2/posts?per_page=100').then(function (response) {
        context.commit('setPosts', response.data);
        context.commit('setFirstPost', response.data);
      }).catch(function () {});
    },
    getDbIndex: function getDbIndex(context) {
      return new promise_default.a(function (resolve, reject) {
        if (context.state.dbIndex.length === 0) {
          context.commit('setLoaderText', 'loader_text_db');
          context.commit('setLoader', 1);
          axios_default.a.get('https://www.mari-portal.de/omeka/custom/api/sharedobjectlist').then(function (response) {
            context.commit('setDbIndex', response.data);
            resolve(response.data);
          }).catch(function (e) {
            context.commit('addError', e);
            reject(e);
          }).finally(function () {
            context.commit('setLoader', -1);
          });
        } else {
          resolve(context.state.dbIndex);
        }
      });
    },
    fetchSharedObject: function fetchSharedObject(context, id) {
      return new promise_default.a(function (resolve, reject) {
        var found = context.state.sharedObjects.find(function (obj) {
          return obj.id === id;
        });
        if (!found) {
          var getDublinCore = true;
          var sharedObject = {};
          sharedObject.hasImage = false;
          sharedObject.imageCount = 0;
          sharedObject.imageIds = [];
          context.commit('setSharedObjectLoader', 1);
          axios_default.a.get('https://www.mari-portal.de/omeka/api/items/' + id).then(function (response) {
            if (response.data.message && response.data.message === 'Invalid record. Record not found.') {
              reject(response.data.message);
            } else {
              sharedObject.id = response.data.id;
              sharedObject.meta = {};
              var cmsgId = null;
              var acquisitionDate = null;
              var contextTransactions = [].concat(toConsumableArray_default()(context.state.contextTransactions));
              response.data.element_texts.forEach(function (e) {
                if (e.element_set.name !== 'Dublin Core' || getDublinCore) {
                  sharedObject.meta[e.element.name.replace(/[-\s]/g, '_')] = e.text;
                }
                if (e.element.name === 'Sigle konstituierende Nachricht ID') {
                  cmsgId = e.text * 1;
                }
                if (e.element.name === 'Erwerbungsdatum (frühestens)') {
                  acquisitionDate = e.text;
                }
                if (e.element.name === 'Kontextinformation: Erbgang Rudolf auf Emilie Mosse' && e.text === 'ignorieren') {
                  contextTransactions.forEach(function (ct) {
                    if (ct.Erwerber === 'Emilie Mosse') {
                      contextTransactions.splice(contextTransactions.indexOf(ct), 1);
                    }
                  });
                }
                if (e.element.name === 'Kontextinforation: Erbgang Emilie Mosse auf Felicia Lachmann-Mosse' && e.text === 'ignorieren') {
                  contextTransactions.forEach(function (ct) {
                    if (ct.Erwerber === 'Felicia Lachmann-Mosse') {
                      contextTransactions.splice(contextTransactions.indexOf(ct), 1);
                    }
                  });
                }
                if (e.element.name === 'Kontextinformation: Eigentumsübertragung an Treuhand GmbH' && e.text === 'ignorieren') {
                  contextTransactions.forEach(function (ct) {
                    if (ct.Erwerber === 'Rudolf Mosse Treuhand Verwaltungs GmbH') {
                      contextTransactions.splice(contextTransactions.indexOf(ct), 1);
                    }
                  });
                }
              });
              if (acquisitionDate) {
                contextTransactions = contextTransactions.filter(function (ct) {
                  return new Date(ct['Datum Transaktion (maschinell)']) >= new Date(acquisitionDate);
                });
              }
              sharedObject.cmsg_meta = {};
              sharedObject.linked_objects = [];
              sharedObject.linked_objects_num_fields = {};
              sharedObject.sourceIds = [];
              sharedObject.transactions = [];
              var linkedObjectsNumFields = {};
              var transactions = [];
              if (response.data.extended_resources && response.data.extended_resources.linked_objects && response.data.extended_resources.linked_objects.items.length > 0) {
                var primaryImageId = null;
                response.data.extended_resources.linked_objects.items.forEach(function (e) {
                  if (e.id === cmsgId) {
                    sharedObject.cmsg_meta.id = e.id;
                    sharedObject.cmsg_meta.subject_item_type = e.subject_item_type.name;
                    e.subject_element_texts.forEach(function (se) {
                      sharedObject.cmsg_meta[se.element.name.replace(/[-\s]/g, '_')] = se.text;
                    });
                  }
                  var linkedObject = {};
                  var imgAllowed = false;
                  linkedObject.id = e.id;
                  linkedObject.subject_item_type = e.subject_item_type.name;
                  // linkedObject.relation_text = e.relation_text
                  linkedObject.meta = {};
                  e.subject_element_texts.forEach(function (subjectElementText) {
                    if (subjectElementText.element.name !== 'Title' && subjectElementText.element.id !== 50 || getDublinCore) {
                      linkedObject.meta[subjectElementText.element.name] = subjectElementText.text;
                      if (subjectElementText.element.name === 'Sigle Quelle ID' && subjectElementText.text && !sharedObject.sourceIds.includes(subjectElementText.text)) {
                        sharedObject.sourceIds.push(subjectElementText.text);
                      }
                      if (!linkedObjectsNumFields[subjectElementText.element.name] && context.state.displayFields.includes(subjectElementText.element.name)) {
                        linkedObjectsNumFields[subjectElementText.element.name] = [{
                          'count': 1,
                          'text': subjectElementText.text
                        }];
                      } else if (context.state.displayFields.includes(subjectElementText.element.name)) {
                        var _found = linkedObjectsNumFields[subjectElementText.element.name].find(function (f) {
                          return f.text === subjectElementText.text;
                        });
                        if (_found) {
                          _found.count++;
                        } else {
                          linkedObjectsNumFields[subjectElementText.element.name].push({
                            'count': 1,
                            'text': subjectElementText.text
                          });
                        }
                      }
                      if (linkedObject.subject_item_type === 'Bilddokument' && subjectElementText.element.name === 'Primärabbildung' && subjectElementText.text === 'ja') {
                        primaryImageId = e.id;
                      }
                      if (linkedObject.subject_item_type === 'Bilddokument' && subjectElementText.element.name === 'Rechtestatus Abbildung' && (subjectElementText.text === 'keine Einschränkung' || subjectElementText.text === 'Bildrechte eingeholt')) {
                        imgAllowed = true;
                      }
                    }
                  });
                  if (e.subject_item_type.name === 'Bilddokument' && e.subject_item_files && e.subject_item_files[0] && e.subject_item_files[0].hasOwnProperty('filename') && imgAllowed) {
                    linkedObject.meta.filename = e.subject_item_files[0].filename;
                    sharedObject.hasImage = true;
                    if (!sharedObject.imageIds.includes(e.id)) {
                      sharedObject.imageCount++;
                      sharedObject.imageIds.push(e.id);
                    }
                  }
                  if (e.subject_item_type.name === 'Transaktion') {
                    transactions.push(linkedObject.meta);
                  }
                  sharedObject.linked_objects.push(linkedObject);
                });
                if (primaryImageId) {
                  var _found2 = sharedObject.imageIds.find(function (id) {
                    return id === primaryImageId;
                  });
                  if (_found2) {
                    sharedObject.imageIds.splice(sharedObject.imageIds.indexOf(_found2), 1);
                    sharedObject.imageIds.unshift(_found2);
                  }
                }
                context.state.displayFields.forEach(function (field) {
                  if (linkedObjectsNumFields.hasOwnProperty(field)) {
                    sharedObject.linked_objects_num_fields[field] = linkedObjectsNumFields[field];
                  }
                });
                var transactionsAll = [];
                if (transactions.length > 0) {
                  transactionsAll = [].concat(transactions, toConsumableArray_default()(contextTransactions));
                  transactionsAll.sort(function (a, b) {
                    var ca = null;
                    var cb = null;
                    if (a.hasOwnProperty('Datum Transaktion (maschinell)')) {
                      ca = a['Datum Transaktion (maschinell)'];
                    } else if (a.hasOwnProperty('Spätestes Datum (maschinell)')) {
                      ca = a['Spätestes Datum (maschinell)'];
                    } else if (a.hasOwnProperty('Frühestes Datum (maschinell)')) {
                      ca = a['Frühestes Datum (maschinell)'];
                    }

                    if (b.hasOwnProperty('Datum Transaktion (maschinell)')) {
                      cb = b['Datum Transaktion (maschinell)'];
                    } else if (b.hasOwnProperty('Spätestes Datum (maschinell)')) {
                      cb = b['Spätestes Datum (maschinell)'];
                    } else if (b.hasOwnProperty('Frühestes Datum (maschinell)')) {
                      cb = b['Frühestes Datum (maschinell)'];
                    }
                    b.datum = cb;

                    if (ca < cb) {
                      return -1;
                    } else if (ca > cb) {
                      return 1;
                    }
                    return 0;
                  });
                  // when we find our earliest non-context transaction:
                  // remove preceding transactions since they're of type "Kontext"
                  for (var i = 0; i < transactionsAll.length; i++) {
                    if (!transactionsAll[i].Kontext) {
                      transactionsAll.splice(0, i);
                      break;
                    }
                  }
                }
                sharedObject.transactions = transactionsAll;
              }
              context.commit('addSharedObject', sharedObject);
              context.commit('setSharedObject', sharedObject);
              if (sharedObject.sourceIds.length > 0) {
                context.dispatch('fetchMetaSources', sharedObject.sourceIds).then(function (metaSources) {
                  return resolve(sharedObject);
                });
              } else {
                resolve(sharedObject);
              }
            }
          }).catch(function (e) {
            context.commit('addError', e);
            reject(e);
          }).finally(function () {
            context.commit('setSharedObjectLoader', -1);
          });
        } else {
          context.commit('setSharedObject', found);
          resolve(found);
        }
      });
    },
    fetchMetaSources: function fetchMetaSources(context, sourceIds) {
      return new promise_default.a(function (resolve, reject) {
        var sourceIdsString = '';
        sourceIds.forEach(function (id) {
          if (context.state.metaSources.hasOwnProperty(id)) {
            delete sourceIds[sourceIds.indexOf(id)];
          } else {
            sourceIdsString += sourceIdsString.length > 0 ? ',' + id : id;
          }
        });
        if (sourceIdsString.length > 0) {
          context.commit('setSharedObjectLoader', 1);
          axios_default.a.get('https://www.mari-portal.de/omeka/api/items?range=' + sourceIdsString).then(function (response) {
            response.data.forEach(function (item) {
              var meta = {};
              item.element_texts.forEach(function (e) {
                meta[e.element.name] = e.text;
              });
              context.commit('addMetaSource', {
                id: item.id,
                item_type: item.item_type.name,
                meta: meta
              });
            });
            resolve(context.state.metaSources);
          }).catch(function (e) {
            context.commit('addError', e);
            reject(e);
          }).finally(function () {
            context.commit('setSharedObjectLoader', -1);
          });
        } else {
          resolve(context.state.metaSources);
        }
      });
    },
    fetchArchivbestandObjekts: function fetchArchivbestandObjekts(context) {
      return new promise_default.a(function (resolve, reject) {
        if (context.state.archivbestandObjekts.length === 0) {
          context.commit('setLoader', 1);
          axios_default.a.get('https://www.mari-portal.de/omeka/custom/api/itemlist/?item_type=36').then(function (response) {
            response.data.sort(function (a, b) {
              a['meta']['Institution'] = a['meta']['Institution'] || '';
              a['meta']['Archiv___Stadt'] = a['meta']['Archiv___Stadt'] || '';
              a['meta']['Archiv___Land'] = a['meta']['Archiv___Land'] || '';
              return a['meta']['Archiv___Land'].localeCompare(b['meta']['Archiv___Land']) || a['meta']['Archiv___Stadt'].localeCompare(b['meta']['Archiv___Stadt']) || a['meta']['Institution'].localeCompare(b['meta']['Institution']);
            });
            var grouped = response.data.reduce(function (r, a) {
              r[a['meta']['Archiv___Land']] = r[a['meta']['Archiv___Land']] || {};
              r[a['meta']['Archiv___Land']][a['meta']['Archiv___Stadt']] = r[a['meta']['Archiv___Land']][a['meta']['Archiv___Stadt']] || {};
              r[a['meta']['Archiv___Land']][a['meta']['Archiv___Stadt']][a['meta']['Institution']] = r[a['meta']['Archiv___Land']][a['meta']['Archiv___Stadt']][a['meta']['Institution']] || [];
              r[a['meta']['Archiv___Land']][a['meta']['Archiv___Stadt']][a['meta']['Institution']].push({
                id: a['id'],
                Sigle: a['meta']['Sigle'],
                Archiv___Akten: a['meta']['Archiv___Akten'],
                Archiv___Bestand: a['meta']['Archiv___Bestand']
              });
              return r;
            }, create_default()(null));
            context.commit('setArchivbestandObjekts', extends_default()({}, grouped));
            resolve(extends_default()({}, grouped));
          }).catch(function (e) {
            context.commit('addError', e);
            reject(e);
          }).finally(function () {
            context.commit('setLoader', -1);
          });
        } else {
          resolve(context.state.archivbestandObjekts);
        }
      });
    }
  }
});

// export default store
// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.css
var dist_vuetify = __webpack_require__("QCv7");
var dist_vuetify_default = /*#__PURE__*/__webpack_require__.n(dist_vuetify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/navigation/Main.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Main = ({
  data: function data() {
    return {
      mobileBreakpointMax: 1024,
      projectTitle: 'Mosse Art research Initiative',
      projectTitleLogo: 'Mosse<br>Art Research<br>Initiative',
      showToolbar: true,
      navigationDrawerOpen: true,
      clipped: false,
      routes: this.$router.options.routes
    };
  },
  beforeMount: function beforeMount() {
    this.checkDrawerOpen();
    this.checkToolbarShow();
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener('resize', _this.checkResized);
    });
  },

  methods: {
    checkDrawerOpen: function checkDrawerOpen() {
      if (window.innerWidth <= this.mobileBreakpointMax) {
        this.navigationDrawerOpen = false;
      }
    },
    checkToolbarShow: function checkToolbarShow() {
      if (window.innerWidth > this.mobileBreakpointMax) {
        this.showToolbar = false;
      } else {
        this.showToolbar = true;
      }
    },
    checkResized: function checkResized() {
      this.checkToolbarShow();
      // console.log(this.$vuetify.application.left)
    },
    changeLang: function changeLang() {
      if (this.lang === 'de') {
        this.$store.commit('setLang', 'en');
        this.$store.commit('switchPagesLang', 'en');
      } else {
        this.$store.commit('setLang', 'de');
        this.$store.commit('switchPagesLang', 'de');
      }
      if (this.$router.history.current.name === 'Seite') {
        this.$router.push({ name: 'Startseite' });
      } else if (this.$router.history.current.name === 'Post' || this.$router.history.current.name === 'Posts') {
        this.$router.push({ name: 'Startseite' });
      }
    },
    getBasePath: function getBasePath(path) {
      // remove string that starts with : (e.g. :id?)
      return path.replace(/\/:[^/]+/, '/');
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.checkResized);
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pageNav', 'lang']), {
    langSwitch: function langSwitch() {
      if (this.lang === 'de') {
        return '<span>DE</span> | <span class="lang-inactive">EN</span>';
      } else {
        return '<span class="lang-inactive">DE</span> | <span>EN</span>';
      }
    },
    displayRoutes: function displayRoutes() {
      return this.routes.filter(function (route) {
        return route.label && route.displayNav;
      }).sort(function (a, b) {
        return a.position - b.position;
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-876e3424","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/Main.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-navigation"},[_c('v-navigation-drawer',{ref:"vNavigationDrawerNavMain",staticClass:"mari-drawer mari",attrs:{"clipped":_vm.clipped,"mobile-break-point":_vm.mobileBreakpointMax + 1,"fixed":"","dark":"","app":""},model:{value:(_vm.navigationDrawerOpen),callback:function ($$v) {_vm.navigationDrawerOpen=$$v},expression:"navigationDrawerOpen"}},[_c('h1',{staticClass:"mari-nav-logo"},[_c('router-link',{attrs:{"to":{ name: 'Startseite' }},domProps:{"innerHTML":_vm._s(_vm.projectTitleLogo)}})],1),_vm._v(" "),_c('v-list',_vm._l((_vm.displayRoutes),function(route,i){return _c('v-list-tile',_vm._b({key:i,class:route.listItemCssClass,attrs:{"value":"true"}},'v-list-tile',{ to: _vm.getBasePath(route.path), href: _vm.getBasePath(route.path) },false),[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(route.label[_vm.lang])}})],1)],1)}),1),_vm._v(" "),_c('v-list',_vm._l((_vm.pageNav),function(page,i){return _c('v-list-tile',_vm._b({key:i,class:'navitem_pid_' + page.parent,attrs:{"value":"true"}},'v-list-tile',{ to: '/page/' + page.slug, href: '/page/' + page.slug },false),[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(page.menu_title)}})],1)],1)}),1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{nativeOn:{"click":function($event){return _vm.changeLang.apply(null, arguments)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"lang-switch",domProps:{"innerHTML":_vm._s(_vm.langSwitch)}})],1)],1)],1),_vm._v(" "),_c('img',{staticClass:"toolbar-logo-closed",attrs:{"src":"/static/img/mari-nav-icon-white.svg","alt":_vm.projectTitle}})],1),_vm._v(" "),(_vm.showToolbar)?_c('v-toolbar',{staticClass:"main-toolbar",attrs:{"color":"mari-toolbar mari","fixed":"","dense":"","flat":"","scroll-off-screen":"","dark":"","app":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.navigationDrawerOpen = !_vm.navigationDrawerOpen}}}),_vm._v(" "),_c('h1',{staticClass:"toolbar-mari-nav-logo",domProps:{"innerHTML":_vm._s(_vm.projectTitleLogo)}}),_vm._v(" "),_c('v-spacer')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var navigation_Main = (esExports);
// CONCATENATED MODULE: ./src/components/navigation/Main.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Main,
  navigation_Main,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_navigation_Main = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
  components: {
    'main-navigation': components_navigation_Main
  },
  created: function created() {
    this.getWpPages();
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['loader', 'lang', 'translate', 'loaderText'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getWpPages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d9c854a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('main-navigation'),_vm._v(" "),_c('v-content',[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),(_vm.loader > 0)?_c('div',{staticClass:"overlay",attrs:{"value":true}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"mari"}}),_vm._v(" "),(_vm.loaderText.length > 0)?_c('div',{staticClass:"loader-text",domProps:{"textContent":_vm._s(_vm.translate[_vm.loaderText][_vm.lang])}}):_vm._e()],1):_vm._e()],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("jU8+")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Startseite.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Startseite = ({
  name: 'Startseite',
  data: function data() {
    return {
      msg: 'Mosse Art Research Initiative',
      cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
      projects: {
        one: {
          de: {
            about: 'Über das Projekt',
            title: 'Die Mosse Art Research Initiative (MARI)',
            excerpt: 'Im März 2017 hat die Mosse-Erbengemeinschaft zusammen mit der Freien Universität Berlin die Mosse Art Research Initiative (MARI) ins Leben gerufen. Das Forschungsvorhaben ist in vielerlei Hinsicht innovativ und von hoher kulturpolitischer Relevanz. Erstmals kooperieren deutsche Institutionen mit Nachfahren von Opfern der rassischen Verfolgung während des NS-Regimes in einer öffentlich-privaten Partnerschaft.',
            excerpt2: 'Die Initiative ging von der Kulturstiftung der Länder und der Stiftung Preußischer Kulturbesitz aus. Darüber hinaus sind zahlreiche Museen und Institutionen in die Forschung eingebunden. Zur Erfassung und Präsentation der komplexen Sachverhalte dient das effizient auf die Bedürfnisse der Provenienzforschung zugeschnittene MARI Online Portal. Als ein Netzwerk von höchster Kompetenz und Transparenz wird MARI wichtige Impulse für die zukünftige Wissensgenerierung zum Themenbereich der NS-verfolgungsbedingt entzogenen Kulturobjekte liefern, und darüber hinaus einen wertvollen Beitrag zur Gestaltung der Erinnerungskultur in Deutschland leisten.',
            slug: 'die-mosse-art-research-initiative-mari'
          },
          en: {
            about: 'About the Project',
            title: 'The Mosse Art Research Initiative (MARI)',
            excerpt: 'In March 2017, the Mosse community of heirs together with the Freie Universität Berlin founded the Mosse Art Research Initiative (MARI). This research project is innovative in many ways and very important in terms of cultural policy. For the first time, German institutions are cooperating with descendants of Nazi persecution in a public-private partnership. Kulturstiftung der Länder and Stiftung Preußischer Kulturbesitz took the initiative here. Furthermore, numerous museums and institutions have been included in the research project.',
            excerpt2: 'In order to examine and present the complex material, MARI Online Portal is efficiently custom-made for the needs of provenance research. As a network of the highest quality and transparency, MARI will provide important impulses for the future generation of knowledge on issues relating to objects that were confiscated under Nazi persecution and furthermore provide an important contribution to the shaping of the German culture of memory.',
            slug: 'the-mosse-art-research-initiative-mari'
          }
        },
        two: {
          de: {
            title: 'Rudolf Mosse<br>und seine Familie',
            slug: 'rudolf-mosse-und-seine-familie'
          },
          en: {
            title: 'Rudolf Mosse<br>and His Family',
            slug: 'rudolf-mosse-and-his-family'
          }
        },
        three: {
          de: {
            title: 'Rudolf Mosses Kunst&shy;sammlung',
            slug: 'rudolf-mosses-kunstsammlung'
          },
          en: {
            title: 'Rudolf Mosse’s Art Collection',
            slug: 'rudolf-mosses-art-collection'
          }
        },
        four: {
          de: {
            title: 'Daten&shy;bank'
          },
          en: {
            title: 'Data&shy;base'
          }
        },
        five: {
          de: {
            title: 'Kooperationspartner',
            links: ['Mosse Foundation (Erben nach Rudolf Mosse),<br>vertreten durch <a href="https://mosseartproject.com/" target="_blank" rel="noopener">MARP</a> und <a href="https://raue.com/" target="_blank" rel="noopener">Raue LLP</a><br>', '<a href="https://www.smb.museum/home.html" target="_blank" rel="noopener">Staatliche Museen zu Berlin / Stiftung Preußischer Kulturbesitz</a><br>', '<a href="https://www.smb.museum/museen-und-einrichtungen/zentralarchiv/home.html" target="_blank" rel="noopener">Zentralarchiv der Staatlichen Museen zu Berlin</a><br>', '<a href="https://www.jmberlin.de/" target="_blank" rel="noopener">Stiftung Jüdisches Museum Berlin</a><br>', '<a href="http://landesarchiv-berlin.de/" target="_blank" rel="noopener">Landesarchiv Berlin</a><br>', '<a href="https://www.kunsthalle-karlsruhe.de/" target="_blank" rel="noopener">Staatliche Kunsthalle Karlsruhe</a><br>', '<a href="https://www.stadt-koeln.de/leben-in-koeln/kultur/provenienzforschung" target="_blank" rel="noopener">Referat für Museumsangelegenheiten der Stadt Köln / Provenienzforschung</a><br>', '<a href="https://museum-wiesbaden.de/" target="_blank" rel="noopener">Museum Wiesbaden</a><br>', '<a href="https://wissenschaft.hessen.de/kultur/die-zentrale-stelle-fuer-provenienzforschung" target="_blank" rel="noopener">Zentralstelle für Provenienzforschung in Hessen</a><br>', '<a href="https://www.worms.de/de/tourismus/museen/museum-der-stadt/" target="_blank" rel="noopener">Museum der Stadt Worms</a><br>', '<a href="https://www.mathildenhoehe.eu/" target="_blank" rel="noopener">Intstitut Mathildenhöhe Darmstadt</a><br>', '<a href="https://www.meeresmuseum.de/" target="_blank" rel="noopener">Stiftung Deutsches Meeresmuseum Stralsund</a>', '<a href="http://www.duesseldorf.de" target="_blank" rel="noopener">Landeshauptstadt Düsseldorf, Kulturdezernat Provenienzforschung</a>']
          },
          en: {
            title: 'Cooperating Institutions',
            links: ['Mosse Foundation (Erben nach Rudolf Mosse),<br>represented by <a href="https://mosseartproject.com/" target="_blank" rel="noopener">MARP</a> and <a href="https://raue.com/" target="_blank" rel="noopener">Raue LLP</a>', '<a href="https://www.smb.museum/home.html" target="_blank" rel="noopener">Staatliche Museen zu Berlin / Stiftung Preußischer Kulturbesitz</a>', '<a href="https://www.smb.museum/museen-und-einrichtungen/zentralarchiv/home.html" target="_blank" rel="noopener">Zentralarchiv der Staatlichen Museen zu Berlin</a>', '<a href="https://www.jmberlin.de/" target="_blank" rel="noopener">Stiftung Jüdisches Museum Berlin</a>', '<a href="http://landesarchiv-berlin.de/" target="_blank" rel="noopener">Landesarchiv Berlin</a>', '<a href="https://www.kunsthalle-karlsruhe.de/" target="_blank" rel="noopener">Staatliche Kunsthalle Karlsruhe</a>', '<a href="https://www.stadt-koeln.de/leben-in-koeln/kultur/provenienzforschung" target="_blank" rel="noopener">Referat für Museumsangelegenheiten der Stadt Köln / Provenienzforschung</a>', '<a href="https://museum-wiesbaden.de/" target="_blank" rel="noopener">Museum Wiesbaden</a>', '<a href="https://wissenschaft.hessen.de/kultur/die-zentrale-stelle-fuer-provenienzforschung" target="_blank" rel="noopener">Zentralstelle für Provenienzforschung in Hessen</a>', '<a href="https://www.worms.de/de/tourismus/museen/museum-der-stadt/" target="_blank" rel="noopener">Museum der Stadt Worms</a>', '<a href="https://www.mathildenhoehe.eu/" target="_blank" rel="noopener">Intstitut Mathildenhöhe Darmstadt</a>', '<a href="https://www.meeresmuseum.de/" target="_blank" rel="noopener">Stiftung Deutsches Meeresmuseum Stralsund</a>', '<a href="http://www.duesseldorf.de" target="_blank" rel="noopener">Landeshauptstadt Düsseldorf, Kulturdezernat Provenienzforschung</a>']
          }
        },
        six: {
          de: {
            title: 'Mosse Art Research Initiative (MARI)',
            content: '<p>Kunst&shy;historisches Institut der Freien Universität Berlin<br>Koserstr. 20 Raum A.186 | 14195 Berlin<br>Tel.: +49 30 838 70338</p><p>Dr. Meike Hoffmann<br><a href="mailto:meike.hoffmann@fu-berlin.de" class="lnk_nodec">meike.hoffmann@fu-berlin.de</a></p>'
          },
          en: {
            title: 'Mosse Art Research Initiative (MARI)',
            content: '<p>Kunst&shy;historisches Institut der Freien Universität Berlin<br>Koserstr. 20 Raum A.186 | 14195 Berlin<br>Tel.: +49 30 838 70338</p>Dr. Meike Hoffmann<p><a href="mailto:meike.hoffmann@fu-berlin.de" class="lnk_nodec">meike.hoffmann@fu-berlin.de</a></p>'
          }
        },
        seven: {
          de: {
            title: 'Gefördert von'
          },
          en: {
            title: 'Funded  by'
          }
        },
        eight: {
          de: {
            title: 'Quellen',
            path: '/page/quellen'
          },
          en: {
            title: 'Sources',
            path: '/page/sources'
          }
        },
        nine: {
          de: {
            title: 'Mosse-Palais',
            path: '/rooms'
          },
          en: {
            title: 'Mosse-Palais',
            path: '/rooms'
          }
        },
        ten: {
          de: {
            title: 'Publikationen und Vorträge',
            path: '/page/vortraege-und-publikationen'
          },
          en: {
            title: 'Publications and Talks',
            path: '/page/talks-and-publikations'
          }
        }
      }
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['posts', 'translate', 'lang']), {
    getQuellenPath: function getQuellenPath() {
      return this.projects.eight[this.lang].path;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d5ab68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Startseite.vue
var Startseite_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssClass},[_c('v-container',{attrs:{"grid-list-sm":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{staticClass:"prim_layout_tile",attrs:{"row":""}},[_c('v-flex',{staticClass:"media_row",attrs:{"md12":"","lg6":""}},[_c('v-img',{attrs:{"src":"/static/img/project.jpg","height":"100%","cover":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":"","lg6":""}},[_c('div',{staticClass:"dpx-3"},[_c('h1',{staticClass:"ntb",domProps:{"textContent":_vm._s(_vm.projects.one[_vm.lang].title)}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"ffs lfs",domProps:{"textContent":_vm._s(_vm.projects.one[_vm.lang].excerpt)}}),_vm._v(" "),_c('div',{staticClass:"excert_second ffs lfs",domProps:{"textContent":_vm._s(_vm.projects.one[_vm.lang].excerpt2)}})]),_vm._v(" "),_c('div',[_c('router-link',{staticClass:"lnk_more",attrs:{"to":{ name: 'Seite', params: { slug: _vm.projects.one[_vm.lang].slug }}}},[_vm._v("\n                      "+_vm._s(_vm.translate['mehr_erfahren'][_vm.lang])+"\n                    ")])],1)])])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":""}},[_c('v-card',[_c('router-link',{staticClass:"lnk_all",attrs:{"to":{ name: 'Seite', params: { slug: _vm.projects.two[_vm.lang].slug }}}},[_c('v-img',{staticClass:"home_title",attrs:{"height":"400px","src":"/static/img/Rudolf_Mosse.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{staticClass:"flex_media_tile_title",attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('div',{staticClass:"media_tile_title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.projects.two[_vm.lang].title)}})])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":""}},[_c('v-card',[_c('router-link',{attrs:{"to":{ name: 'Seite', params: { slug: _vm.projects.three[_vm.lang].slug }}}},[_c('v-img',{staticClass:"a",attrs:{"height":"400px","src":"/static/img/collection.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{staticClass:"flex_media_tile_title",attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('div',{staticClass:"media_tile_title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.projects.three[_vm.lang].title)}})])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":""}},[_c('v-card',[_c('router-link',{attrs:{"to":'/rooms'}},[_c('v-img',{staticClass:"a",attrs:{"height":"400px","src":"/static/img/Mosse-Palais.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{staticClass:"flex_media_tile_title",attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('div',{staticClass:"media_tile_title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.projects.nine[_vm.lang].title)}})])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":""}},[_c('v-card',[_c('router-link',{attrs:{"to":{ name: 'Database'}}},[_c('v-img',{staticClass:"a",attrs:{"height":"400px","src":"/static/img/Kachelbild_Datenbank_01.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{staticClass:"flex_media_tile_title",attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('div',{staticClass:"media_tile_title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.projects.four[_vm.lang].title)}})])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":""}},[_c('v-card',[_c('router-link',{attrs:{"to":_vm.getQuellenPath}},[_c('v-img',{staticClass:"a",attrs:{"height":"400px","src":"/static/img/Startseiten_Kachel_02_edit01.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{staticClass:"flex_media_tile_title",attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('div',{staticClass:"media_tile_title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.projects.eight[_vm.lang].title)}})])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":""}},[_c('v-card',[_c('router-link',{attrs:{"to":_vm.projects.ten[_vm.lang].path}},[_c('v-img',{staticClass:"a",attrs:{"height":"400px","src":"/static/img/Kachelbild_Publikationen_01.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{staticClass:"flex_media_tile_title",attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('div',{staticClass:"media_tile_title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.projects.ten[_vm.lang].title)}})])])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',{staticClass:"last_container",attrs:{"fluid":"","grid-list-lg":"","mb-5":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":""}},[_c('v-card',{attrs:{"height":"100%"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{staticClass:"home_tile_layout",attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('div',{staticClass:"tile_title",domProps:{"innerHTML":_vm._s(_vm.projects.six[_vm.lang].title)}}),_vm._v(" "),_c('div',{staticClass:"tile_content",domProps:{"innerHTML":_vm._s(_vm.projects.six[_vm.lang].content)}}),_vm._v(" "),_c('div',{staticClass:"tile_logo"},[_c('img',{attrs:{"src":"/static/img/logos/Logo_FU.jpg","alt":"Freie Universität Berlin"}})])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","lg4":""}},[_c('v-card',{attrs:{"height":"100%"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{staticClass:"home_tile_layout",attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('div',{staticClass:"tile_title",domProps:{"innerHTML":_vm._s(_vm.projects.seven[_vm.lang].title)}}),_vm._v(" "),_c('div',{staticClass:"tile_logo_container"},[_c('div',{staticClass:"tile_logo"},[_c('a',{attrs:{"href":"https://www.kulturstiftung.de/","target":"_blank","rel":"noopener"}},[_c('img',{attrs:{"src":"/static/img/logos/Logo_KSL.png","alt":"Kulturstiftung der Länder"}})])]),_vm._v(" "),_c('div',{staticClass:"my-4 tile_logo"},[_c('a',{attrs:{"href":"https://www.kulturgutverluste.de/Webs/DE/Start/Index.html","target":"_blank","rel":"noopener"}},[_c('img',{attrs:{"src":"/static/img/logos/Logo_DZK.png","alt":"Deutsches Zentrum für Kulturgutverluste"}})])]),_vm._v(" "),_c('div',{staticClass:"tile_logo"},[_c('a',{attrs:{"href":"http://mosseartproject.com/","target":"_blank","rel":"noopener"}},[_c('img',{attrs:{"src":"/static/img/logos/Logo_MARP.png","alt":"The Mosse Art Restitution Project"}})])])])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":"","lg4":""}},[_c('v-card',{attrs:{"height":"100%"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{staticClass:"home_tile_layout",attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('div',{staticClass:"tile_title",domProps:{"innerHTML":_vm._s(_vm.projects.five[_vm.lang].title)}}),_vm._v(" "),_c('ul',{staticClass:"partner mt-4"},_vm._l((_vm.projects.five[_vm.lang].links),function(link,index){return _c('li',{key:'coop_' + index,domProps:{"innerHTML":_vm._s(link)}})}),0)])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var Startseite_staticRenderFns = []
var Startseite_esExports = { render: Startseite_render, staticRenderFns: Startseite_staticRenderFns }
/* harmony default export */ var pages_Startseite = (Startseite_esExports);
// CONCATENATED MODULE: ./src/components/pages/Startseite.vue
function Startseite_injectStyle (ssrContext) {
  __webpack_require__("kh7F")
}
var Startseite_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Startseite___vue_template_functional__ = false
/* styles */
var Startseite___vue_styles__ = Startseite_injectStyle
/* scopeId */
var Startseite___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Startseite___vue_module_identifier__ = null
var Startseite_Component = Startseite_normalizeComponent(
  Startseite,
  pages_Startseite,
  Startseite___vue_template_functional__,
  Startseite___vue_styles__,
  Startseite___vue_scopeId__,
  Startseite___vue_module_identifier__
)

/* harmony default export */ var components_pages_Startseite = (Startseite_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/map.js
var core_js_map = __webpack_require__("ifoU");
var map_default = /*#__PURE__*/__webpack_require__.n(core_js_map);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/partials/SourcesList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SourcesList = ({
  name: 'SourcesList',
  props: ['sharedObject', 'translate', 'lang', 'metaSources'],
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bab1b10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/partials/SourcesList.vue
var SourcesList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sharedObject.linked_objects && _vm.sharedObject.linked_objects.length > 0)?_c('div',_vm._l((_vm.sharedObject.linked_objects),function(lo){return _c('div',{key:'reltxt' + lo.id,staticClass:"related_list sm_bdmark_off",attrs:{"id":'relo_' + lo.id}},[_c('v-expansion-panel',[_c('v-expansion-panel-content',[(lo['meta']['Quellenangabe'])?_c('div',{attrs:{"slot":"header","id":'list_o_' + lo.id},slot:"header"},[(lo.subject_item_type === 'Bilddokument')?_c('div',{staticClass:"s__cat"},[_vm._v("\n            "+_vm._s(_vm.translate['Bilddokument'][_vm.lang])+"\n          ")]):_c('div',{staticClass:"s__cat"},[_vm._v("\n            "+_vm._s(_vm.translate['Textquelle'][_vm.lang])+"\n          ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s('' + lo['meta']['Quellenangabe'])}})]):(lo['meta']['Sigle Quelle ID'] && _vm.metaSources[lo['meta']['Sigle Quelle ID']].meta['Ausgabe-Format'])?_c('div',{attrs:{"slot":"header","id":'list_o_' + lo.id},slot:"header"},[(lo.subject_item_type === 'Bilddokument')?_c('div',{staticClass:"s__cat"},[_vm._v("\n            "+_vm._s(_vm.translate['Bilddokument'][_vm.lang])+"\n          ")]):_c('div',{staticClass:"s__cat"},[_vm._v("\n            "+_vm._s(_vm.translate['Textquelle'][_vm.lang])+"\n          ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s('' + _vm.metaSources[lo['meta']['Sigle Quelle ID']].meta['Ausgabe-Format'])}})]):(lo['meta']['Sigle Quelle ID'] && _vm.metaSources[lo['meta']['Sigle Quelle ID']].meta['Bezeichnung'])?_c('div',{attrs:{"slot":"header","id":'list_o_' + lo.id},slot:"header"},[(lo.subject_item_type === 'Bilddokument')?_c('div',{staticClass:"s__cat"},[_vm._v("\n            "+_vm._s(_vm.translate['Bilddokument'][_vm.lang])+"\n          ")]):_c('div',{staticClass:"s__cat"},[_vm._v("\n            "+_vm._s(_vm.translate['Textquelle'][_vm.lang])+"\n          ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s('' + _vm.metaSources[lo['meta']['Sigle Quelle ID']].meta['Bezeichnung'])}})]):(lo['meta']['Angabe Online-Quelle, Bezeichnung'])?_c('div',{attrs:{"slot":"header","id":'list_o_' + lo.id},slot:"header"},[(lo.subject_item_type === 'Bilddokument')?_c('div',{staticClass:"s__cat"},[_vm._v("\n            "+_vm._s(_vm.translate['Bilddokument'][_vm.lang])+"\n          ")]):_c('div',{staticClass:"s__cat"},[_vm._v("\n            "+_vm._s(_vm.translate['Textquelle'][_vm.lang])+"\n          ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s('' + lo['meta']['Angabe Online-Quelle, Bezeichnung'])}})]):(lo['meta']['Title'] && lo.subject_item_type !== 'Transaktion')?_c('div',{attrs:{"slot":"header","id":'list_o_' + lo.id},slot:"header"},[_c('div',{staticClass:"s__cat"},[_vm._v("\n            "+_vm._s(_vm.translate['allgemeine Quelle'][_vm.lang])+"\n          ")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s('' + lo['meta']['Title'])}})]):_vm._e(),_vm._v(" "),(lo.subject_item_type === 'Bilddokument' && lo.meta.filename)?_c('div',{staticClass:"list_thn"},[_c('img',{attrs:{"src":'https://www.mari-portal.de/omeka/files/square_thumbnails/' + lo.meta.filename.toLowerCase(),"alt":(lo.meta['Bildlegende']) ? lo.meta['Bildlegende'] : lo.meta['filename']}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dbox"},[(lo['meta']['Seite in Quelle'] || lo['meta']['Nr. in Quelle'])?_c('div',{staticClass:"nos_source"},[(lo['meta']['Seite in Quelle'])?[_c('span',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Seite in Quelle'][_vm.lang]))]),_vm._v(" "),_c('span',{staticClass:"s__value pr-4",domProps:{"innerHTML":_vm._s(lo['meta']['Seite in Quelle'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Nr. in Quelle'])?[_c('span',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Nr. in Quelle'][_vm.lang]))]),_vm._v(" "),_c('span',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Nr. in Quelle'])}})]:_vm._e()],2):_vm._e(),_vm._v(" "),(lo['meta']['Verweis Abbildung'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Verweis Abbildung'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Verweis Abbildung'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Titel'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Titel'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Titel'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Weitere Angaben'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Weitere Angaben'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Weitere Angaben'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Material und Technik'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Material und Technik'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Material und Technik'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Maße'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Maße'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Maße'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Beschreibung'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Beschreibung'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Beschreibung'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Information Zustand, Beschaffenheit'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Information Zustand, Beschaffenheit'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Information Zustand, Beschaffenheit'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Rubrik'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Rubrik'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Rubrik'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Rahmen'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Rahmen'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Rahmen'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Signatur'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Signatur'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Signatur'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Datierung'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Datierung'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Datierung'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Erwerbung durch Mosse'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Erwerbung durch Mosse'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Erwerbung durch Mosse'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Angabe Besitzer/Eigentümer'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Angabe Besitzer/Eigentümer'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Angabe Besitzer/Eigentümer'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Angabe Vorbesitzer'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Angabe Vorbesitzer'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Angabe Vorbesitzer'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Referenz'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Referenz'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Referenz'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Bildlegende'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Bildlegende'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Bildlegende'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Bildrechte-Angabe'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Bildrechte'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Bildrechte-Angabe'])}})]:_vm._e(),_vm._v(" "),(lo['meta']['Angabe Online-Quelle, Bezeichnung']
              && lo['meta']['Angabe Online-Quelle, URL'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Online-Quelle'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value"},[_c('a',{attrs:{"href":lo['meta']['Angabe Online-Quelle, URL'],"target":"_blank"},domProps:{"innerHTML":_vm._s(lo['meta']['Angabe Online-Quelle, Bezeichnung'])}})])]:_vm._e(),_vm._v(" "),(lo['meta']['Nachricht über das Werk'])?[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Nachricht über das Werk'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__value",domProps:{"innerHTML":_vm._s(lo['meta']['Nachricht über das Werk'])}})]:_vm._e()],2)])],1),_vm._v(" "),_c('v-divider')],1)}),0):_vm._e()}
var SourcesList_staticRenderFns = []
var SourcesList_esExports = { render: SourcesList_render, staticRenderFns: SourcesList_staticRenderFns }
/* harmony default export */ var partials_SourcesList = (SourcesList_esExports);
// CONCATENATED MODULE: ./src/components/pages/partials/SourcesList.vue
var SourcesList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SourcesList___vue_template_functional__ = false
/* styles */
var SourcesList___vue_styles__ = null
/* scopeId */
var SourcesList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SourcesList___vue_module_identifier__ = null
var SourcesList_Component = SourcesList_normalizeComponent(
  SourcesList,
  partials_SourcesList,
  SourcesList___vue_template_functional__,
  SourcesList___vue_styles__,
  SourcesList___vue_scopeId__,
  SourcesList___vue_module_identifier__
)

/* harmony default export */ var pages_partials_SourcesList = (SourcesList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/DBNew.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DBNew = ({
  name: 'DatabaseNew',
  components: {
    SourcesList: pages_partials_SourcesList
  },
  data: function data() {
    return {
      // cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase() + ' database',
      cssClass: 'database',
      searchTerm: '',
      foo: '',
      searchFulltext: true,
      searchArtists: true,
      searchWorks: true,
      searchResults: null,
      filterElement: null,
      filter2Element: null,
      expansionPanelAllWorks: [true],
      activeObjectId: null,
      siCarousel: null,
      lightboxImage: null,
      expansionPanelMetadataFromSources: [true],
      transactionHeaders: [{
        align: 'left',
        sortable: false,
        text: 'Datum',
        value: 'Datum Transaktion Ausgabe',
        value_en: 'Date Transaction Issue',
        class: 'hidden'
      }, {
        sortable: false,
        align: 'left',
        text: 'Vorbesitzer',
        value: 'Vorbesitzer',
        value_en: 'Previous Owner'
      }, {
        sortable: false,
        align: 'left',
        text: 'Ort Vorbesitzer',
        value: 'Ort Vorbesitzer',
        value_en: 'Location Previous Owner'
      }, {
        sortable: false,
        align: 'left',
        text: 'Erwerber/Besitzer ',
        value: 'Erwerber/Besitzer',
        value_en: 'Acquirer/Owner'
      }, {
        sortable: false,
        align: 'left',
        text: 'Ort Erwerber',
        value: 'Ort Erwerber',
        value_en: 'Location Acquirer'
      }, {
        sortable: false,
        align: 'left',
        text: 'Transaktion',
        value: 'Transaktion Ausgabe',
        value_en: 'Transaction Issue',
        class: 'wide_cell hidden'
      }],
      error: null,
      noimg: 'noimg.svg'
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getDbIndex', 'fetchSharedObject']), {
    search: function search() {
      this.searchResults = null;
      var searchResults = [];
      if (this.searchTerm && this.searchTerm.length > 2) {
        var searchTerm = this.searchTerm.toLowerCase();
        var map = new map_default.a();
        for (var i = 0; i < this.dbIndex.length; i++) {
          if (this.searchFulltext) {
            if (typeof this.dbIndex[i].meta !== 'undefined' && this.dbIndex[i].meta !== null && typeof this.dbIndex[i].cmsg_meta !== 'undefined' && this.dbIndex[i].cmsg_meta !== null && (this.dbIndex[i].meta['Sigle'] && this.dbIndex[i].meta['Sigle'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].meta['Autor___Normansetzung'] && this.dbIndex[i].meta['Autor___Normansetzung'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].meta['Titel - Normansetzung'] && this.dbIndex[i].meta['Titel - Normansetzung'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].meta['Basisrecherche_(Hausarbeit)_von'] && this.dbIndex[i].meta['Basisrecherche_(Hausarbeit)_von'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].meta['Forschungsstand'] && this.dbIndex[i].meta['Forschungsstand'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].meta['state_of_research'] && this.dbIndex[i].meta['state_of_research'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Sigle'] && this.dbIndex[i].cmsg_meta['Sigle'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Titel'] && this.dbIndex[i].cmsg_meta['Titel'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Urheber'] && this.dbIndex[i].cmsg_meta['Urheber'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Material_und_Technik'] && this.dbIndex[i].cmsg_meta['Material_und_Technik'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Ma\xDFe'] && this.dbIndex[i].cmsg_meta['Ma\xDFe'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Rahmen'] && this.dbIndex[i].cmsg_meta['Rahmen'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Rahmen'] && this.dbIndex[i].cmsg_meta['Rahmen'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Rubrik'] && this.dbIndex[i].cmsg_meta['Rubrik'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Implizite_Orstangabe'] && this.dbIndex[i].cmsg_meta['Implizite_Orstangabe'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Chronologische_Kategorie'] && this.dbIndex[i].cmsg_meta['Chronologische_Kategorie'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Urheber___Normalformat'] && this.dbIndex[i].cmsg_meta['Urheber___Normalformat'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Urheber___Normalformat_Display'] && this.dbIndex[i].cmsg_meta['Urheber___Normalformat_Display'].toLowerCase().indexOf(searchTerm) > -1)) {
              searchResults.push({
                id: this.dbIndex[i].id,
                title: this.getTitle(this.dbIndex[i]),
                creator: this.getCreator(this.dbIndex[i]),
                creator_sort: this.getSortByCreator(this.dbIndex[i])
              });
            }
          } else {
            if (this.searchArtists && !map.has(this.dbIndex[i].id) && typeof this.dbIndex[i].meta !== 'undefined' && this.dbIndex[i].meta !== null && typeof this.dbIndex[i].cmsg_meta !== 'undefined' && this.dbIndex[i].cmsg_meta !== null && (this.dbIndex[i].meta['Autor___Normansetzung'] && this.dbIndex[i].meta['Autor___Normansetzung'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Urheber'] && this.dbIndex[i].cmsg_meta['Urheber'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Urheber___Normalformat'] && this.dbIndex[i].cmsg_meta['Urheber___Normalformat'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Urheber___Normalformat_Display'] && this.dbIndex[i].cmsg_meta['Urheber___Normalformat_Display'].toLowerCase().indexOf(searchTerm) > -1)) {
              map.set(this.dbIndex[i].id, true);
              searchResults.push({
                id: this.dbIndex[i].id,
                title: this.getTitle(this.dbIndex[i]),
                creator: this.getCreator(this.dbIndex[i]),
                creator_sort: this.getSortByCreator(this.dbIndex[i])
              });
            }
            if (this.searchWorks && !map.has(this.dbIndex[i].id) && typeof this.dbIndex[i].meta !== 'undefined' && this.dbIndex[i].meta !== null && typeof this.dbIndex[i].cmsg_meta !== 'undefined' && this.dbIndex[i].cmsg_meta !== null && (this.dbIndex[i].meta['Titel - Normansetzung'] && this.dbIndex[i].meta['Titel - Normansetzung'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Titel'] && this.dbIndex[i].cmsg_meta['Titel'].toLowerCase().indexOf(searchTerm) > -1 || this.dbIndex[i].cmsg_meta['Beschreibung'] && this.dbIndex[i].cmsg_meta['Beschreibung'].toLowerCase().indexOf(searchTerm) > -1)) {
              map.set(this.dbIndex[i].id, true);
              searchResults.push({
                id: this.dbIndex[i].id,
                title: this.getTitle(this.dbIndex[i]),
                creator: this.getCreator(this.dbIndex[i]),
                creator_sort: this.getSortByCreator(this.dbIndex[i])
              });
            }
          }
        }
        if (searchResults.length > 0) {
          searchResults.sort(function (a, b) {
            if (a.creator_sort < b.creator_sort) {
              return -1;
            }
            if (a.creator_sort > b.creator_sort) {
              return 1;
            }
            if (a.creator_sort === b.creator_sort) {
              if (a.title < b.title) {
                return -1;
              }
              if (a.title > b.title) {
                return 1;
              }
            }
            return 0;
          });
        }
        this.searchResults = searchResults;
        // console.log(searchResults)
      }
    },
    getCreator: function getCreator(item) {
      if (item.meta['Autor___Normansetzung']) {
        return item.meta['Autor___Normansetzung'];
      } else if (item.cmsg_meta['Urheber___Normalformat_Display']) {
        return item.cmsg_meta['Urheber___Normalformat_Display'];
      } else if (item.cmsg_meta['Urheber']) {
        return item.cmsg_meta['Urheber'];
      } else {
        return '';
      }
    },
    getSortByCreator: function getSortByCreator(item) {
      if (item.meta['Autor___Normansetzung___Sortierung']) {
        return item.meta['Autor___Normansetzung___Sortierung'];
      } else if (item.cmsg_meta['Urheber___Normalformat']) {
        return item.cmsg_meta['Urheber___Normalformat'];
      } else {
        return this.getCreator(item);
      }
    },
    getTitle: function getTitle(item) {
      if (item.meta['Titel___Normansetzung']) {
        return item.meta['Titel___Normansetzung'];
      } else if (item.cmsg_meta['Titel']) {
        return item.cmsg_meta['Titel'];
      } else if (item.cmsg_meta['Beschreibung']) {
        return item.cmsg_meta['Beschreibung'];
      } else {
        return '';
      }
    },
    getTitleWithDate: function getTitleWithDate(item) {
      var title = this.getTitle(item);
      if (item.meta['Datierung___Normansetzung']) {
        return title + ', ' + item.meta['Datierung___Normansetzung'];
      } else if (item.cmsg_meta['Datierung']) {
        return title + ', ' + item.cmsg_meta['Datierung'];
      } else {
        return title;
      }
    },
    getMaterialAndTech: function getMaterialAndTech(item) {
      if (item.meta['Material_und_Technik___Normansetzung']) {
        return item.meta['Material_und_Technik___Normansetzung'];
      } else if (item.cmsg_meta['Material_und_Technik']) {
        return item.cmsg_meta['Material_und_Technik'];
      } else {
        return '';
      }
    },
    getImageTitle: function getImageTitle(img) {
      if (img.meta['Bildlegende']) {
        return img.meta['Bildlegende'];
      } else if (img.meta['Title']) {
        return img.meta['Title'];
      } else if (img.meta['filename']) {
        return img.meta['filename'];
      } else if (img['id']) {
        return img['id'];
      } else {
        return '';
      }
    },
    selectSharedObject: function selectSharedObject(id) {
      var _this = this;

      id = parseInt(id);
      var prescrollElement = document.getElementById('xselected_object');
      if (prescrollElement) {
        prescrollElement.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
      this.siCarousel = null;
      this.fetchSharedObject(id).then(function (result) {
        _this.activeObjectId = id;
        if (_this.$route.params.oid !== id) {
          _this.$router.push({ name: 'Database', params: { oid: id } }).catch(function () {});
        }
        _this.expansionPanelMetadataFromSources = [true];
        _this.$nextTick(function () {
          var el = document.getElementById('selected_object');
          if (el) {
            setTimeout(function () {
              el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
          }
        });
      }).catch(function (error) {
        _this.error = error;
      });
    },
    openPanel: function openPanel(id, event) {
      event.preventDefault();
      event.stopPropagation();
      var parent = document.getElementById('relo_' + id);
      if (parent) {
        var check = parent.firstChild.firstChild.classList.contains('v-expansion-panel__container--active');
        if (!check) {
          var el = document.getElementById('list_o_' + id);
          el.click();
        }
        var alle = document.getElementsByClassName('related_list');
        for (var i = 0; i < alle.length; i++) {
          alle[i].classList.remove('sm_bdmark_on');
        }
        parent.classList.add('sm_bdmark_on');
        setTimeout(function () {
          parent.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    },
    getImgPath: function getImgPath(img) {
      return img.meta.filename && img.meta.filename !== this.noimg ? 'https://www.mari-portal.de/omeka/files/fullsize/' + img.meta.filename : 'https://www.mari-portal.de/omeka/files/assets/' + this.noimg;
    },
    openLightbox: function openLightbox(img, event) {
      img.meta.filename = img.meta.filename ? img.meta.filename.toLowerCase() : this.noimg;
      this.lightboxImage = img;
    },
    closeLightbox: function closeLightbox(event) {
      this.lightboxImage = null;
    },
    getMetadataLinkText: function getMetadataLinkText(linkedObject) {
      if (linkedObject.meta['Quellenangabe']) {
        return linkedObject.meta['Quellenangabe'];
      } else if (linkedObject.meta['Sigle Quelle ID'] && this.metaSources[linkedObject.meta['Sigle Quelle ID']]['meta']['Ausgabe-Format']) {
        return this.metaSources[linkedObject.meta['Sigle Quelle ID']]['meta']['Ausgabe-Format'];
      } else if (linkedObject.meta['Sigle Quelle ID'] && this.metaSources[linkedObject.meta['Sigle Quelle ID']]['meta']['Bezeichnung']) {
        return this.metaSources[linkedObject.meta['Sigle Quelle ID']]['meta']['Bezeichnung'];
      } else if (linkedObject.meta['Angabe Online-Quelle, Bezeichnung']) {
        return linkedObject.meta['Angabe Online-Quelle, Bezeichnung'];
      } else if (linkedObject.meta['Title']) {
        return linkedObject.meta['Title'];
      } else {
        return '';
      }
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    this.getDbIndex().then(function () {
      if (_this2.$route.params.oid) {
        _this2.selectSharedObject(_this2.$route.params.oid);
      }
    });
  },

  watch: {
    $route: function $route(to, from) {
      if (to.params.oid) {
        this.selectSharedObject(to.params.oid);
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['translate', 'lang', 'dbIndex', 'sharedObject', 'sharedObjectLoader', 'metaSources']), {
    filterItems: function filterItems() {
      return [{ text: this.translate['alle'][this.lang], value: 'all' }, { text: this.translate['von MARI bearbeitet'][this.lang], value: 'edited' }, { text: this.translate['von MARI lokalisiert'][this.lang], value: 'mariLocalized' }, { text: this.translate['lokalisiert vor MARI'][this.lang], value: 'pre'
        // { text: this.translate['nur Buchobjekte'][this.lang], value: 'booksonly' }
      }];
    },
    filter2Items: function filter2Items() {
      return [{ text: this.translate['alle Quellen'][this.lang], value: 'all' }, { text: 'Lepke 1934', value: 'lepke' }, { text: 'Union 1934', value: 'union' }, { text: this.translate['andere Quellen'][this.lang], value: 'others' }];
    },
    listInfo: function listInfo() {
      var _this3 = this;

      var infos = { titles: [], creators: {}, sortedNames: [], authors: {}, sortedAuthors: [] };
      var filter = this.filterElement || 'all';
      var filter2 = this.filter2Element || 'all';
      var statusEditing = void 0,
          statusResearch = void 0,
          statusSigle = void 0,
          creator = void 0,
          creatorSort = void 0,
          title = void 0,
          author = void 0;

      this.dbIndex.forEach(function (item) {
        statusEditing = item.meta['Status_Bearbeitung'] || '';
        statusResearch = item.meta['Status_Recherche'] || '';
        statusSigle = item.meta['Sigle_konstituierende_Nachricht'] || '';
        if ((filter === 'all' || filter === 'edited' && (statusEditing === 'Forschung begonnen' || statusEditing === 'vorläufig abgeschlossen') || filter === 'pre' && statusEditing === 'Claim vor oder außerhalb von MARI' || filter === 'mariLocalized' && statusResearch === 'lokalisiert'
        //   ||
        // (filter === 'booksonly' &&
        //   item.meta.Bibliotheksobjekt && item.meta.Bibliotheksobjekt === 'ja')
        ) && (filter2 === 'all' || filter2 === 'lepke' && statusSigle && !statusSigle.indexOf('Lepke 1934') || filter2 === 'union' && statusSigle && !statusSigle.indexOf('Union 1934') || filter2 === 'others' && (!statusSigle || statusSigle.indexOf('Lepke 1934') && statusSigle.indexOf('Union 1934')))) {
          if (item['cmsg_meta']) {
            title = _this3.getTitle(item);
            creatorSort = _this3.getSortByCreator(item);
            if (item.meta.Bibliotheksobjekt && item.meta.Bibliotheksobjekt === 'ja') {
              if (!creatorSort) {
                creatorSort = 'ohne Autorenangabe';
                author = creatorSort;
              } else {
                author = _this3.getCreator(item);
              }
              if (infos.authors[creatorSort]) {
                infos.authors[creatorSort].titles.push({ id: item.id, title: title });
              } else {
                infos.authors[creatorSort] = { name: author, titles: [{ id: item.id, title: title }] };
                infos.sortedAuthors.push(creatorSort);
              }
            } else {
              if (creatorSort) {
                creator = _this3.getCreator(item);
                if (infos.creators[creatorSort]) {
                  infos.creators[creatorSort].titles.push({ id: item.id, title: title });
                } else {
                  infos.creators[creatorSort] = { name: creator, titles: [{ id: item.id, title: title }] };
                  infos.sortedNames.push(creatorSort);
                }
                infos.titles.push({ id: item.id, title: title, creator: creator });
              } else {
                infos.titles.push({ id: item.id, title: title, creator: '' });
              }
            }
          }
        }
      });
      infos.sortedNames.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
      infos.sortedAuthors.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
      infos.titles.sort(function (a, b) {
        a = a.title.match(/[A-Za-z0-9]+.+/)[0].toLowerCase();
        b = b.title.match(/[A-Za-z0-9]+.+/)[0].toLowerCase();
        return a > b ? 1 : b > a ? -1 : 0;
      });
      return infos;
    },
    listInfoTitles: function listInfoTitles() {
      return this.listInfo.titles;
    },
    listInfoCreators: function listInfoCreators() {
      return this.listInfo.creators;
    },
    listInfoSortedNames: function listInfoSortedNames() {
      return this.listInfo.sortedNames;
    },
    listInfoAuthors: function listInfoAuthors() {
      return this.listInfo.authors;
    },
    listInfoSortedAuthors: function listInfoSortedAuthors() {
      return this.listInfo.sortedAuthors;
    },
    imgCaption: function imgCaption() {
      var _this4 = this;

      if (this.siCarousel !== null && this.sharedObject && this.sharedObject.imageIds && this.sharedObject.imageIds[this.siCarousel] && this.sharedObject.linked_objects) {
        var img = this.sharedObject.linked_objects.find(function (e) {
          return e.id === _this4.sharedObject.imageIds[_this4.siCarousel];
        });
        if (img && img.meta['Bildlegende']) {
          return img.meta['Bildlegende'];
        }
      }
      return '';
    },
    imgCopyright: function imgCopyright() {
      var _this5 = this;

      if (this.siCarousel !== null && this.sharedObject && this.sharedObject.imageIds && this.sharedObject.imageIds[this.siCarousel] && this.sharedObject.linked_objects) {
        var img = this.sharedObject.linked_objects.find(function (e) {
          return e.id === _this5.sharedObject.imageIds[_this5.siCarousel];
        });
        if (img && img.meta['Bildrechte-Angabe']) {
          return img.meta['Bildrechte-Angabe'];
        }
      }
      return '';
    },
    permLink: function permLink() {
      return 'MARI (Freie Universit\xE4t Berlin) https://mari-portal.de/object/' + this.$route.params.oid;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59666943","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/DBNew.vue
var DBNew_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssClass},[_c('v-container',{staticClass:"database-container",attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{staticClass:"main_layout_db",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","md6":"","lg4":""}},[(_vm.dbIndex.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"db-list",attrs:{"sm12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"search",attrs:{"xs12":""}},[_c('v-card',{attrs:{"tile":"","flat":""}},[_c('div',{staticClass:"col-inner col-highlight"},[_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm9":""}},[_c('v-text-field',{attrs:{"label":_vm.translate['Suche'][_vm.lang],"id":"search_term","color":"secondary","value":_vm.searchTerm},on:{"change":function (v) { return _vm.searchTerm = v; }}})],1),_vm._v(" "),_c('v-flex',{staticClass:"search_btn_col",attrs:{"sm3":""}},[_c('v-btn',{staticClass:"search_btn",attrs:{"flat":"","color":"mari"},on:{"click":_vm.search}},[_c('v-icon',[_vm._v("search")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"search__extended",attrs:{"sm12":""}},[_c('v-checkbox',{attrs:{"dense":"","label":_vm.translate['Volltextsuche'][_vm.lang]},on:{"change":_vm.search},model:{value:(_vm.searchFulltext),callback:function ($$v) {_vm.searchFulltext=$$v},expression:"searchFulltext"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"dense":"","label":_vm.translate['Künstler'][_vm.lang]},on:{"change":_vm.search},model:{value:(_vm.searchArtists),callback:function ($$v) {_vm.searchArtists=$$v},expression:"searchArtists"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"dense":"","label":_vm.translate['Werke'][_vm.lang]},on:{"change":_vm.search},model:{value:(_vm.searchWorks),callback:function ($$v) {_vm.searchWorks=$$v},expression:"searchWorks"}})],1)],1)],1),_vm._v(" "),(_vm.searchResults !== null)?[_c('h4',{staticClass:"search_results_title"},[_vm._v(_vm._s(_vm.translate['search_results'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"s__cat",domProps:{"textContent":_vm._s(_vm.searchResults.length + ' ' + _vm.translate['num_search_results'][_vm.lang])}}),_vm._v(" "),_c('v-list',_vm._l((_vm.searchResults),function(searchResult,index){return _c('div',{key:searchResult.id},[_c('v-list-tile',{attrs:{"ripple":"","id":'searchResult' + searchResult.id},on:{"click":function($event){return _vm.selectSharedObject(searchResult.id)}}},[_c('v-list-tile-content',[(searchResult.creator)?_c('v-list-tile-title',{staticClass:"list_small_item"},[_vm._v("\n                                "+_vm._s(searchResult.creator)+"\n                              ")]):_vm._e(),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(searchResult.title))])],1)],1),_vm._v(" "),(index + 1 < _vm.searchResults.length)?_c('v-divider',{key:index}):_vm._e()],1)}),0)]:_vm._e()],2)])],1),_vm._v(" "),_c('v-flex',{staticClass:"filter",attrs:{"xs12":""}},[_c('div',{staticClass:"col-inner col-highlight"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"color":"mari","items":_vm.filterItems,"single-line":"","hint":_vm.translate['Anzeigen alle Objekte'][_vm.lang],"label":_vm.translate['Anzeigen alle Objekte'][_vm.lang],"id":"filter_select1"},model:{value:(_vm.filterElement),callback:function ($$v) {_vm.filterElement=$$v},expression:"filterElement"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"color":"mari","items":_vm.filter2Items,"single-line":"","hint":_vm.translate['Nachgewiesen in'][_vm.lang],"label":_vm.translate['Nachgewiesen in'][_vm.lang]},model:{value:(_vm.filter2Element),callback:function ($$v) {_vm.filter2Element=$$v},expression:"filter2Element"}})],1)],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-tabs',{staticClass:"gws_tabs"},[_c('v-tab',[_c('v-card',[_c('v-card-title',[_c('h3',[_vm._v(_vm._s(_vm.translate['Künstler'][_vm.lang]))])])],1)],1),_vm._v(" "),_c('v-tab',[_c('v-card',[_c('v-card-title',[_c('h3',[_vm._v(_vm._s(_vm.translate['Kunstwerke'][_vm.lang]))])])],1)],1),_vm._v(" "),_c('v-tab',[_c('v-card',[_c('v-card-title',[_c('h3',[_vm._v(_vm._s(_vm.translate['Bibliotheksobjekte'][_vm.lang]))])])],1)],1),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',_vm._l((_vm.listInfoSortedNames),function(sortedName,idx){return _c('v-expansion-panel',{key:'list_info_sorted_names_' + idx,attrs:{"expand":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',[_vm._v(_vm._s(sortedName))])]),_vm._v(" "),_c('v-list',_vm._l((_vm.listInfoCreators[sortedName]['titles']),function(work,work_idx){return _c('div',{key:'list_info_sorted_names_titles_' + idx + '_title_' + work_idx},[_c('v-list-tile',{attrs:{"ripple":"","id":'aso' + work.id},on:{"click":function($event){return _vm.selectSharedObject(work.id)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"artist_list_work_title"},[_vm._v("\n                                    "+_vm._s(work.title)+"\n                                  ")])],1)],1),_vm._v(" "),_c('v-divider')],1)}),0)],1)],1)}),1),_vm._v(" "),_c('v-tab-item',[_c('v-expansion-panel',{attrs:{"expand":""},model:{value:(_vm.expansionPanelAllWorks),callback:function ($$v) {_vm.expansionPanelAllWorks=$$v},expression:"expansionPanelAllWorks"}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',[_vm._v(_vm._s(_vm.translate['Alle Werke'][_vm.lang]))])]),_vm._v(" "),_c('v-list',_vm._l((_vm.listInfoTitles),function(listInfoTitle,idx){return _c('div',{key:'list_info_titles_' + listInfoTitle.id,staticClass:"gws_list_tiles_with_sub_title"},[_c('v-list-tile',{attrs:{"ripple":"","id":'oso' + listInfoTitle.id},on:{"click":function($event){return _vm.selectSharedObject(listInfoTitle.id)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                                    "+_vm._s(listInfoTitle.title)+"\n                                    "),(listInfoTitle.creator)?_c('div',{staticClass:"gws_tile_sub_title"},[_vm._v("\n                                      "+_vm._s(listInfoTitle.creator)+"\n                                    ")]):_vm._e()])],1)],1),_vm._v(" "),(idx + 1 < _vm.listInfoTitles.length)?_c('v-divider'):_vm._e()],1)}),0)],1)],1)],1),_vm._v(" "),_c('v-tab-item',_vm._l((_vm.listInfoSortedAuthors),function(sortedName,idx){return _c('v-expansion-panel',{key:'list_info_sorted_authors_' + idx,attrs:{"expand":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',[_vm._v(_vm._s((sortedName === 'ohne Autorenangabe') ? _vm.translate['ohne Autorenangabe'][_vm.lang] : sortedName))])]),_vm._v(" "),_c('v-list',_vm._l((_vm.listInfoAuthors[sortedName]['titles']),function(work,work_idx){return _c('div',{key:'list_info_sorted_authors_titles_' + idx + '_title_' + work_idx},[_c('v-list-tile',{attrs:{"ripple":"","id":'aso' + work.id},on:{"click":function($event){return _vm.selectSharedObject(work.id)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"artist_list_work_title"},[_vm._v("\n                                    "+_vm._s(work.title)+"\n                                  ")])],1)],1),_vm._v(" "),_c('v-divider')],1)}),0)],1)],1)}),1)],1)],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),(_vm.error)?_c('v-flex',{attrs:{"d-flex":"","xs12":"","md6":"","lg8":"","child-flex":"","id":"error_object"}},[_c('v-card',{staticClass:"trbg",attrs:{"flat":""}},[_c('div',{staticClass:"main_o_list"},[_c('div',{staticClass:"selection_main error"},[_c('div',{staticClass:"s__error"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.translate['404'][_vm.lang])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.error)}})])])])])],1):_vm._e(),_vm._v(" "),(_vm.activeObjectId)?_c('v-flex',{attrs:{"d-flex":"","xs12":"","md6":"","lg8":"","child-flex":"","xselected_object":"","id":"xselected_object"}},[(_vm.sharedObjectLoader > 0)?_c('v-card',{staticClass:"trbg shared-object-loader-container",attrs:{"flat":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"mari"}})],1):_c('v-card',{staticClass:"trbg nbg selected-object-card",attrs:{"flat":""}},[_c('div',{staticClass:"selected_object",attrs:{"id":"selected_object"}},[(_vm.sharedObject.hasImage)?_c('div',[_c('v-carousel',{attrs:{"hide-delimiters":"","cycle":false,"hide-controls":(_vm.sharedObject.imageCount === 1) ? true : false},model:{value:(_vm.siCarousel),callback:function ($$v) {_vm.siCarousel=$$v},expression:"siCarousel"}},[_vm._l((_vm.sharedObject.linked_objects.filter(function (e) { return e.subject_item_type === 'Bilddokument' && e.meta['Primärabbildung'] === 'ja' && typeof e.meta.filename !== 'undefined' && e.meta.filename !== ''; })),function(image,idx){return _c('v-carousel-item',{key:'img_prim_' + idx,attrs:{"src":_vm.getImgPath(image)},nativeOn:{"click":function($event){return _vm.openLightbox(image, $event)}}},[_c('div',{staticClass:"img_meta"},[_c('a',{attrs:{"href":'#relo_' + image.id},on:{"click":function($event){return _vm.openPanel(image.id, $event)}}},[_c('v-icon',{staticClass:"info-icon",attrs:{"medium":"","color":"primary"}},[_vm._v("info")])],1)])])}),_vm._v(" "),_vm._l((_vm.sharedObject.linked_objects.filter(function (e) { return e.subject_item_type === 'Bilddokument' && (!e.meta['Primärabbildung'] || e.meta['Primärabbildung'] !== 'ja') && typeof e.meta.filename !== 'undefined' && e.meta.filename !== ''; })),function(image,idx){return _c('v-carousel-item',{key:'img_' + idx,attrs:{"src":_vm.getImgPath(image)},nativeOn:{"click":function($event){return _vm.openLightbox(image, $event)}}},[_c('div',{staticClass:"img_meta"},[_c('a',{attrs:{"href":'#relo_' + image.id},on:{"click":function($event){return _vm.openPanel(image.id, $event)}}},[_c('v-icon',{staticClass:"info-icon",attrs:{"medium":"","color":"primary"}},[_vm._v("info")])],1)])])})],2),_vm._v(" "),(_vm.imgCaption || _vm.imgCopyright)?_c('div',{staticClass:"img-caption-and-copyright"},[(_vm.imgCaption)?_c('div',{staticClass:"img-caption",domProps:{"innerHTML":_vm._s(_vm.imgCaption)}}):_vm._e(),_vm._v(" "),(_vm.imgCopyright)?_c('div',{staticClass:"img-copyright",domProps:{"innerHTML":_vm._s('&copy; ' + _vm.imgCopyright)}}):_vm._e()]):_vm._e()],1):_c('div',{staticClass:"no_img",domProps:{"textContent":_vm._s(_vm.translate['Keine Abbildung vorhanden'][_vm.lang])}})]),_vm._v(" "),_c('div',{staticClass:"main_o_list"},[_c('div',{staticClass:"selection_main"},[_c('div',{staticClass:"s__author",domProps:{"innerHTML":_vm._s(_vm.getCreator(_vm.sharedObject))}}),_vm._v(" "),_c('div',{staticClass:"s__title",domProps:{"innerHTML":_vm._s(_vm.getTitleWithDate(_vm.sharedObject))}}),_vm._v(" "),_c('div',{staticClass:"s__tech"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getMaterialAndTech(_vm.sharedObject))}}),(_vm.getMaterialAndTech(_vm.sharedObject) && _vm.sharedObject.cmsg_meta['Maße'])?_c('span',[_vm._v(",")]):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.sharedObject.cmsg_meta['Maße'])}})]),_vm._v(" "),(_vm.sharedObject.meta.Lost_Art_Permalink)?_c('div',[_c('a',{attrs:{"href":_vm.sharedObject.meta.Lost_Art_Permalink,"target":"_blank","rel":"noopener"},domProps:{"textContent":_vm._s(_vm.translate['lost_art_link'][_vm.lang])}})]):_vm._e(),_vm._v(" "),(_vm.sharedObject.meta.Forschungsstand && _vm.lang === 'de')?_c('div',{staticClass:"my-4"},[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Forschungsstand'][_vm.lang]))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.sharedObject.meta.Forschungsstand)}})]):_vm._e(),_vm._v(" "),(_vm.sharedObject.meta.state_of_research && _vm.lang === 'en')?_c('div',{staticClass:"my-4"},[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Forschungsstand'][_vm.lang]))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.sharedObject.meta.state_of_research)}})]):_vm._e(),_vm._v(" "),(_vm.sharedObject.meta['Basisrecherche_(Hausarbeit)_von'])?_c('div',{staticClass:"my-4"},[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Basisrecherche (Hausarbeit) von'][_vm.lang]))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.sharedObject.meta['Basisrecherche_(Hausarbeit)_von'])}})]):_vm._e(),_vm._v(" "),(_vm.sharedObject.meta['Danksagung___DE'] && _vm.lang === 'de')?_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Danksagung'][_vm.lang]))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.sharedObject.meta['Danksagung___DE'])}})]):_vm._e(),_vm._v(" "),(_vm.sharedObject.meta['Danksagung___EN'] && _vm.lang === 'en')?_c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate['Danksagung'][_vm.lang]))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.sharedObject.meta['Danksagung___EN'])}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"citation-hint"},[_c('div',{staticClass:"citation-hint__header"},[_vm._v("\n                  "+_vm._s(_vm.translate['Zitierhinweis'][_vm.lang])+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"citation-hint__body"},[_vm._v("\n                  "+_vm._s(_vm.translate['Forschungsdatenbank'][_vm.lang])+" "+_vm._s(_vm.permLink)+"\n                ")])])])]),_vm._v(" "),(_vm.sharedObject && _vm.sharedObject.transactions.length > 0)?_c('v-flex',{staticClass:"transactions",attrs:{"d-flex":"","xs12":"","child-flex":"","id":"transactions"}},[_c('div',{staticClass:"transactions_list_wrapper"},[_c('h2',{staticClass:"transactions_list_header"},[_vm._v(_vm._s(_vm.translate['transactions'][_vm.lang]))]),_vm._v(" "),[_c('v-data-table',{staticClass:"elevation-1 transaction_table",attrs:{"headers":_vm.transactionHeaders,"items":_vm.sharedObject.transactions,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{class:{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }},[_c('span',{domProps:{"innerHTML":_vm._s(props.item['Datum Transaktion Ausgabe'])}})]),_vm._v(" "),_c('td',{class:{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }},[_c('span',{domProps:{"innerHTML":_vm._s(props.item.Vorbesitzer)}})]),_vm._v(" "),_c('td',{class:{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }},[_c('span',{domProps:{"innerHTML":_vm._s(props.item['Ort Vorbesitzer'])}})]),_vm._v(" "),_c('td',{class:{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }},[_c('span',{domProps:{"innerHTML":_vm._s(props.item['Erwerber'])}})]),_vm._v(" "),_c('td',{class:{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }},[_c('span',{domProps:{"innerHTML":_vm._s(props.item['Ort Erwerber'])}})]),_vm._v(" "),_c('td',{class:{ 'context-transaction': props.item['Kontext'], 'source-transaction': !props.item['Kontext'] }},[_c('span',{domProps:{"innerHTML":_vm._s(props.item['Transaktion Ausgabe'])}})])]}}],null,false,3290316440)})]],2)]):_vm._e(),_vm._v(" "),_c('v-expansion-panel',{staticClass:"metadata_from_sources",attrs:{"expand":""},model:{value:(_vm.expansionPanelMetadataFromSources),callback:function ($$v) {_vm.expansionPanelMetadataFromSources=$$v},expression:"expansionPanelMetadataFromSources"}},[_c('v-expansion-panel-content',[_c('div',{staticClass:"fsi",attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.translate['mehr'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"dbox px_sm small"},_vm._l((_vm.sharedObject.linked_objects_num_fields),function(linked_objects_num_field,linked_objects_num_field_name,idx_lofn){return _c('div',{key:idx_lofn,staticClass:"mb-4"},[_c('div',{staticClass:"s__cat"},[_vm._v(_vm._s(_vm.translate[linked_objects_num_field_name][_vm.lang]))]),_vm._v(" "),_vm._l((linked_objects_num_field),function(field,idx_f){return _c('v-expansion-panel',{key:idx_f,staticClass:"sub_expansion"},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                          "+_vm._s(field['text'])+"\n                          "),(field['count'] > 1)?_c('span',[_vm._v("("+_vm._s(field['count'])+")")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.sharedObject.linked_objects),function(linked_object,idx_lo){return _c('div',{key:idx_lo},[(linked_object['meta'][linked_objects_num_field_name] && linked_object['meta'][linked_objects_num_field_name] === field['text'])?_c('a',{staticClass:"linked display-block sm_lh_mb",attrs:{"href":'#relo_' + linked_object.id},domProps:{"innerHTML":_vm._s(_vm.getMetadataLinkText(linked_object))},on:{"click":function($event){return _vm.openPanel(linked_object.id, $event)}}}):_vm._e()])})],2)],1)})],2)}),0)])],1),_vm._v(" "),_c('v-flex',{staticClass:"linked_metas",attrs:{"d-flex":"","xs12":"","child-flex":"","id":"linked_metas"}},[_c('v-card',{staticClass:"trbg",attrs:{"flat":""}},[_c('h2',{staticClass:"linked_object_list_header header_top"},[_vm._v(_vm._s(_vm.translate['beziehungen_zu_diesem_werk'][_vm.lang]))]),_vm._v(" "),(_vm.sharedObject)?_c('SourcesList',{attrs:{"sharedObject":_vm.sharedObject,"translate":_vm.translate,"lang":_vm.lang,"metaSources":_vm.metaSources}}):_vm._e()],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),(_vm.lightboxImage !== null && _vm.lightboxImage.meta.filename)?_c('div',{staticClass:"lightbox",on:{"click":function($event){return _vm.closeLightbox()}}},[_c('img',{attrs:{"src":_vm.getImgPath(_vm.lightboxImage),"alt":_vm.getImageTitle(_vm.lightboxImage)}})]):_vm._e()],1)}
var DBNew_staticRenderFns = []
var DBNew_esExports = { render: DBNew_render, staticRenderFns: DBNew_staticRenderFns }
/* harmony default export */ var pages_DBNew = (DBNew_esExports);
// CONCATENATED MODULE: ./src/components/pages/DBNew.vue
function DBNew_injectStyle (ssrContext) {
  __webpack_require__("tRYF")
}
var DBNew_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DBNew___vue_template_functional__ = false
/* styles */
var DBNew___vue_styles__ = DBNew_injectStyle
/* scopeId */
var DBNew___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DBNew___vue_module_identifier__ = null
var DBNew_Component = DBNew_normalizeComponent(
  DBNew,
  pages_DBNew,
  DBNew___vue_template_functional__,
  DBNew___vue_styles__,
  DBNew___vue_scopeId__,
  DBNew___vue_module_identifier__
)

/* harmony default export */ var components_pages_DBNew = (DBNew_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/static/Collection-catalogues.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Collection_catalogues = ({
  data: function data() {
    return {
      pdfUrl: ''
    };
  },

  props: {
    lang: {
      type: String
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36d41e19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/static/Collection-catalogues.vue
var Collection_catalogues_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collection-catalogues"},[_c('div',{class:{ open: _vm.pdfUrl },attrs:{"id":"pdf-viewer"}},[_c('v-btn',{staticClass:"btn-close",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.pdfUrl = ''}}},[_c('img',{staticClass:"close",attrs:{"src":"/static/img/icons/close.svg","alt":"close"}})]),_vm._v(" "),_c('iframe',{attrs:{"src":_vm.pdfUrl,"frameborder":"0"}})],1),_vm._v(" "),(_vm.lang === 'de')?[_c('h3',[_vm._v("Sammlungskataloge")]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_c('div',{staticClass:"mari-catalogue-listing",on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K00_1900_Verzeichniss-der-Kunst-Sammlung_Mainz.pdf'}}},[_c('em',[_vm._v("Verzeichnis der Rudolf Mosse'schen Kunst-Sammlung")]),_vm._v(", Berlin 1900"),_c('br'),_vm._v("\n            Gutenberg-Museum Mainz, Bibliothek (1900 Ha 8)\n        ")]),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2019/10/Katalog_Mosse_1900_Thumbnail-e1572016559548.jpg"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K00_1900_Verzeichniss-der-Kunst-Sammlung_Mainz.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_c('div',{staticClass:"mari-catalogue-listing",on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K08_KBB_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1908-Leo-Baeck.pdf'}}},[_c('em',[_vm._v("Katalog der Rudolf Mosse'schen Kunstsammlung")]),_vm._v(", Berlin 1908"),_c('br'),_vm._v("\n            Leo Baeck Institute New York / Berlin"),_c('br'),_vm._v("Staatsbibliothek zu Berlin (Ns 10680)\n        ")]),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K_1908_Cover_thumbnail.jpg"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K08_KBB_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1908-Leo-Baeck.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_c('div',{staticClass:"mari-catalogue-listing",on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1912_UB-Marburg.pdf'}}},[_c('em',[_vm._v("Katalog der Kunstsammlung Rudolf Mosse")]),_vm._v(", Berlin 1912"),_c('br'),_vm._v("\n          Universitätsbibliothek Marburg, Bibliothek Kunst und Kulturwissenschaften, Kunstgeschichte (R 447)\n        ")]),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1912_UB-Marburg-Thn.png"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1912_UB-Marburg.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1913_UB-Marburg-Thn.png"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1913_UB-Marburg.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_c('div',{staticClass:"mari-catalogue-listing",on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K15_Florenz_Katalog_der_Sammlung_-Mosse.pdf'}}},[_c('em',[_vm._v("Katalog der Kunstsammlung Rudolf Mosse")]),_vm._v(", Berlin 1915"),_c('br'),_vm._v("\n          Kunsthistorisches Institut Florenz (Z 5434)\n        ")]),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2025/04/katalog-der-kunstsammlung-rudolf-mosse-berlin-1915-cover.jpg"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K15_Florenz_Katalog_der_Sammlung_-Mosse.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_c('div',{staticClass:"mari-catalogue-listing",on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K21_LBI_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1921-Leo-Baeck.pdf'}}},[_c('em',[_vm._v("Katalog der Kunstsammlung Rudolf Mosse")]),_vm._v(", Berlin 1921"),_c('br'),_vm._v("\n          Leo Baeck Institute New York / Berlin, Mosse Family Collection, AR 25184, Box 2, Folder 23\n        ")]),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2025/04/katalog-der-kunstsammlung-rudolf-mosse-berlin-1921-cover.jpg"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K21_LBI_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1921-Leo-Baeck.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_c('div',{staticClass:"mari-catalogue-listing",on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K32_1932-Haus-der-Sammlungen-Rudolf-Mosse-1929_1932.pdf'}}},[_vm._v("\n        [Katalog] "),_c('em',[_vm._v("Haus der Sammlungen Rudolf Mosse")]),_vm._v(", [Berlin] 1932"),_c('br'),_vm._v("\n      Leo Baeck Institute New York / Berlin, Mosse Family Collection, AR 25184, Box 2, Folder 23"),_c('br'),_vm._v("\n      Staatsbibliothek zu Berlin, Signatur: 4“ Ns 10681\n        ")]),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2025/04/haus-der-sammlungen-rudolf-mosse-berlin-1932-cover.jpg"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K32_1932-Haus-der-Sammlungen-Rudolf-Mosse-1929_1932.pdf'}}})])])]:[_c('h3',[_vm._v("Collection Catalogs")]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2019/10/Katalog_Mosse_1900_Thumbnail-e1572016559548.jpg"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K00_1900_Verzeichniss-der-Kunst-Sammlung_Mainz.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K_1908_Cover_thumbnail.jpg"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2019/10/K08_KBB_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1908-Leo-Baeck.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1912_UB-Marburg-Thn.png"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1912_UB-Marburg.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1913_UB-Marburg-Thn.png"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Katalog-der-Kunstsammlung-Rudolf-Mosse-1913_UB-Marburg.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_c('div',{staticClass:"mari-catalogue-listing",on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K15_Florenz_Katalog_der_Sammlung_-Mosse.pdf'}}},[_c('em',[_vm._v("Katalog der Kunstsammlung Rudolf Mosse")]),_vm._v(", Berlin 1915"),_c('br'),_vm._v("\n          Kunsthistorisches Institut Florenz (Z 5434)\n        ")]),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2025/04/katalog-der-kunstsammlung-rudolf-mosse-berlin-1915-cover.jpg"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K15_Florenz_Katalog_der_Sammlung_-Mosse.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_c('div',{staticClass:"mari-catalogue-listing",on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K21_LBI_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1921-Leo-Baeck.pdf'}}},[_c('em',[_vm._v("Katalog der Kunstsammlung Rudolf Mosse")]),_vm._v(", Berlin 1921"),_c('br'),_vm._v("\n          Leo Baeck Institute New York / Berlin, Mosse Family Collection, AR 25184, Box 2, Folder 23\n        ")]),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2025/04/katalog-der-kunstsammlung-rudolf-mosse-berlin-1921-cover.jpg"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K21_LBI_1-Katalog-Der-Kunstsammlung-Rudolf-Mosse-Berlin-1921-Leo-Baeck.pdf'}}})])]),_vm._v(" "),_c('div',{staticClass:"mari-catalogue-item"},[_c('div',{staticClass:"mari-catalogue-listing",on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K32_1932-Haus-der-Sammlungen-Rudolf-Mosse-1929_1932.pdf'}}},[_vm._v("\n        Katalog "),_c('em',[_vm._v("Haus der Sammlungen Rudolf Mosse")]),_vm._v(", Berlin 1932"),_c('br'),_vm._v("\n      Leo Baeck Institute New York / Berlin, Mosse Family Collection, AR 25184, Box 2, Folder 23"),_c('br'),_vm._v("\n      Staatsbibliothek zu Berlin, Signatur: 4“ Ns 10681\n        ")]),_vm._v(" "),_c('div',{staticClass:"wp-block-image mari-catalogue-thumb"},[_c('img',{staticClass:"mari-catalogue",attrs:{"src":"https://www.mari-portal.de/wp/wp-content/uploads/2025/04/haus-der-sammlungen-rudolf-mosse-berlin-1932-cover.jpg"},on:{"click":function($event){_vm.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/K32_1932-Haus-der-Sammlungen-Rudolf-Mosse-1929_1932.pdf'}}})])])]],2)}
var Collection_catalogues_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mari-catalogue-listing"},[_c('em',[_vm._v("Katalog der Kunstsammlung Rudolf Mosse")]),_vm._v(", Berlin 1913"),_c('br'),_vm._v("\n          Universitätsbibliothek Marburg, Bibliothek Kunst und Kulturwissenschaften, Kunstgeschichte (R 447/1)\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mari-catalogue-listing"},[_c('em',[_vm._v("Verzeichnis der Rudolf Mosse'schen Kunst-Sammlung")]),_vm._v(", Berlin 1900"),_c('br'),_vm._v("Gutenberg-Museum Mainz, Bibliothek (1900 Ha 8)\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mari-catalogue-listing"},[_c('em',[_vm._v("Katalog der Rudolf Mosse'schen Kunstsammlung")]),_vm._v(", Berlin 1908"),_c('br'),_vm._v("Leo Baeck Institute New York / Berlin"),_c('br'),_vm._v("Staatsbibliothek zu Berlin (Ns 10680)\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mari-catalogue-listing"},[_c('em',[_vm._v("Katalog der Kunstsammlung Rudolf Mosse")]),_vm._v(", Berlin 1912"),_c('br'),_vm._v("\n          Universitätsbibliothek Marburg, Bibliothek Kunst und Kulturwissenschaften, Kunstgeschichte (R 447)\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mari-catalogue-listing"},[_c('em',[_vm._v("Katalog der Kunstsammlung Rudolf Mosse")]),_vm._v(", Berlin 1913"),_c('br'),_vm._v("\n          Universitätsbibliothek Marburg, Bibliothek Kunst und Kulturwissenschaften, Kunstgeschichte (R 447/1)\n        ")])}]
var Collection_catalogues_esExports = { render: Collection_catalogues_render, staticRenderFns: Collection_catalogues_staticRenderFns }
/* harmony default export */ var static_Collection_catalogues = (Collection_catalogues_esExports);
// CONCATENATED MODULE: ./src/static/Collection-catalogues.vue
function Collection_catalogues_injectStyle (ssrContext) {
  __webpack_require__("qAEK")
}
var Collection_catalogues_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Collection_catalogues___vue_template_functional__ = false
/* styles */
var Collection_catalogues___vue_styles__ = Collection_catalogues_injectStyle
/* scopeId */
var Collection_catalogues___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Collection_catalogues___vue_module_identifier__ = null
var Collection_catalogues_Component = Collection_catalogues_normalizeComponent(
  Collection_catalogues,
  static_Collection_catalogues,
  Collection_catalogues___vue_template_functional__,
  Collection_catalogues___vue_styles__,
  Collection_catalogues___vue_scopeId__,
  Collection_catalogues___vue_module_identifier__
)

/* harmony default export */ var src_static_Collection_catalogues = (Collection_catalogues_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/partials/Archivbestand.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Archivbestand = ({
  props: {
    lang: {
      type: String
    }
  },
  data: function data() {
    return {
      expanded: false,
      expandButton: {
        state: 'expand',
        expand: {
          de: 'Alle ausklappen',
          en: 'Expand all'
        },
        collapse: {
          de: 'Alle einklappen',
          en: 'Collapse all'
        }
      },
      archive_collections: {
        de: 'Archivbestände',
        en: 'Archive collections'
      },
      loading: {
        de: 'Lade Archivbestand ...',
        en: 'Loading archive collection ...'
      },
      collection: {
        de: 'Bestand',
        en: 'Collection'
      },
      files: {
        de: 'Akten',
        en: 'Files'
      }
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['fetchArchivbestandObjekts']), {
    toggleOpen: function toggleOpen(event) {
      event.stopPropagation();
      var ul = event.target.querySelector('ul');
      if (ul) {
        event.target.classList.toggle('open');
        ul.classList.toggle('open');
      }
    },
    toggleAll: function toggleAll() {
      var _this = this;

      this.expanded = !this.expanded;
      this.expandButton.state = this.expanded ? 'collapse' : 'expand';
      document.querySelectorAll('.archivbestaende li').forEach(function (li) {
        var ul = li.querySelector('ul');
        if (ul) {
          li.classList.toggle('open', _this.expanded);
          ul.classList.toggle('open', _this.expanded);
        }
      });
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['loader', 'translate', 'archivbestandObjekts'])),
  mounted: function mounted() {
    this.fetchArchivbestandObjekts();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-780b8644","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/partials/Archivbestand.vue
var Archivbestand_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loader)?_c('div',{staticClass:"loader"},[_vm._v(_vm._s(_vm.loading[_vm.lang]))]):_c('div',{staticClass:"archivbestaende"},[_c('div',{staticClass:"controls mt-3"},[_c('button',{on:{"click":_vm.toggleAll}},[_vm._v(_vm._s(_vm.expandButton[_vm.expandButton.state][_vm.lang]))])]),_vm._v(" "),_c('ul',_vm._l((_vm.archivbestandObjekts),function(cities,county,idx){return _c('li',{key:'archivbestand_county' + idx,on:{"click":function($event){return _vm.toggleOpen($event)}}},[_vm._v(_vm._s(county)+"\n      "),_c('ul',_vm._l((cities),function(institutions,city,idx){return _c('li',{key:'archivbestand_city' + idx,staticClass:"city",on:{"click":function($event){return _vm.toggleOpen($event)}}},[_c('span',{staticClass:"city-name",domProps:{"innerHTML":_vm._s(city ? city : 'Stadt unbekannt')}}),_vm._v(" "),_c('ul',_vm._l((institutions),function(archives,institution){return _c('li',[_vm._v(_vm._s(institution)+"\n              "),_c('ul',_vm._l((archives),function(archive){return _c('li',{key:'archivbestand_institution' + archive.id,class:'institution' + (archive.Archiv___Bestand ? '' : ' d-none'),attrs:{"id":'archive-' + archive.id}},[(archive.Archiv___Bestand)?_c('span',[_vm._v(_vm._s(_vm.collection[_vm.lang])+": "+_vm._s(archive.Archiv___Bestand))]):_vm._e(),(!archive.Archiv___Bestand)?_c('span',{staticClass:"missing"},[_c('a',{attrs:{"href":'https://www.mari-portal.de/omeka/admin/items/edit/' + archive.id,"target":"_blank"}},[_vm._v("Archivbestand fehlt")]),(archive.Sigle)?_c('span',{staticClass:"small"},[_vm._v(" (Sigle: "+_vm._s(archive.Sigle)+")")]):_vm._e()]):_vm._e(),(archive.Archiv___Bestand && archive.Archiv___Akten)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(" "),(archive.Archiv___Akten)?_c('span',[_vm._v(_vm._s(_vm.files[_vm.lang])+": "+_vm._s(archive.Archiv___Akten))]):_vm._e()])}),0)])}),0)])}),0)])}),0)])}
var Archivbestand_staticRenderFns = []
var Archivbestand_esExports = { render: Archivbestand_render, staticRenderFns: Archivbestand_staticRenderFns }
/* harmony default export */ var partials_Archivbestand = (Archivbestand_esExports);
// CONCATENATED MODULE: ./src/components/pages/partials/Archivbestand.vue
function Archivbestand_injectStyle (ssrContext) {
  __webpack_require__("Fh1t")
}
var Archivbestand_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Archivbestand___vue_template_functional__ = false
/* styles */
var Archivbestand___vue_styles__ = Archivbestand_injectStyle
/* scopeId */
var Archivbestand___vue_scopeId__ = "data-v-780b8644"
/* moduleIdentifier (server only) */
var Archivbestand___vue_module_identifier__ = null
var Archivbestand_Component = Archivbestand_normalizeComponent(
  Archivbestand,
  partials_Archivbestand,
  Archivbestand___vue_template_functional__,
  Archivbestand___vue_styles__,
  Archivbestand___vue_scopeId__,
  Archivbestand___vue_module_identifier__
)

/* harmony default export */ var pages_partials_Archivbestand = (Archivbestand_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Page.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Page = ({
  name: 'Page',
  components: {
    CollectionCatalogues: src_static_Collection_catalogues,
    Archivbestand: pages_partials_Archivbestand
  },
  data: function data() {
    return {
      msg: 'Rudolf Mosse und seine Familie',
      cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
      page: {},
      sections: [],
      loading: true
    };
  },
  created: function created() {
    if (this.$route.params.slug === 'sources' || this.$route.params.slug === 'talks-and-publikations' || this.$route.params.slug === 'rudolf-mosse-and-his-family' || this.$route.params.slug === 'rudolf-mosses-art-collection' || this.$route.params.slug === 'the-dispossession-of-the-lachmann-mosse-family' || this.$route.params.slug === 'the-mosse-art-research-initiative-mari' || this.$route.params.slug === 'infos' || this.$route.params.slug === 'press' || this.$route.params.slug === 'imprint' || this.$route.params.slug === 'contact-information') {
      this.$store.commit('setLang', 'en');
      this.$store.commit('switchPagesLang', 'en');
    }
  },
  mounted: function mounted() {
    var sum = document.querySelector('.sum-fixed');
    var isScrolling = void 0;

    if (this.pages.length > 0) {
      this.loading = false;
      this.setPage(this.$route.params.slug);
      this.setSections();
      this.handleSubNav(document.querySelector('.sum-fixed'));
      this.selectedFootnote();
    }

    this.handleSubNav(sum);

    window.addEventListener('scroll', function (event) {
      window.clearTimeout(isScrolling);
      isScrolling = setTimeout(function () {
        var offset = document.documentElement.scrollTop || window.pageYOffset;
        sum.style.top = offset + 'px';
      }, 30);
    }, false);
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'translate', 'lang']), {
    pageName: function pageName() {
      return this.$route.params.slug || '';
    }
  }),
  watch: {
    pages: function pages() {
      if (this.pages.length > 0) {
        this.loading = false;
        this.setPage(this.$route.params.slug);
        this.setSections();
        this.handleSubNav(document.querySelector('.sum-fixed'));
        this.selectedFootnote();
      } else {
        this.loading = true;
      }
    },
    '$route': function $route(to, from) {
      this.setPage(to.params.slug);
      this.setSections();
      this.handleSubNav(document.querySelector('.sum-fixed'));
      this.selectedFootnote();
    }
  },
  methods: {
    selectedFootnote: function selectedFootnote() {
      this.$nextTick(function () {
        var fns = document.querySelectorAll('.footnote_link');
        fns.forEach(function (fn) {
          fn.addEventListener('click', function (event) {
            event.preventDefault();
            var id = event.target.hash.substr(1);
            if (id && id.length > 0) {
              var target = document.getElementById(id);
              target.scrollIntoView({
                block: 'start',
                inline: 'nearest',
                behavior: 'smooth'
              });
            }
          });
        });
      });
    },
    selectedSection: function selectedSection(event) {
      event.preventDefault();
      var id = event.target.hash.substr(1);
      if (id && id.length > 0) {
        var target = document.getElementById(id);
        target.scrollIntoView({
          block: 'start',
          inline: 'nearest',
          behavior: 'smooth'
        });
      }
    },
    setPage: function setPage(slug) {
      var _this = this;

      this.page = this.pages.find(function (page) {
        return page.slug === _this.$route.params.slug;
      });
    },
    setSections: function setSections() {
      var el = document.createElement('html');
      if (this.page) {
        el.innerHTML = this.page.content.rendered;
      }
      this.sections = el.getElementsByTagName('h2');
    },
    handleSubNav: function handleSubNav(sum) {
      function setSubnav() {
        var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
        var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;

        if (windowWidth >= 600) {
          sum.style.display = 'block';
        } else {
          sum.style.display = 'none';
        }
        sum.style.height = windowHeight - 48 + 'px';
      }
      if (sum) {
        setSubnav();
      }
      window.onresize = function (event) {
        setSubnav();
        sum.style.top = document.documentElement.scrollTop + 'px';
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5f38b5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Page.vue
var Page_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('v-container',{attrs:{"grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.page && _vm.page.hide_section_list !== 'ja')?_c('v-flex',{staticClass:"sum-fixed__wrapper",attrs:{"sm4":""}},[_c('div',{staticClass:"sum-fixed"},[(!_vm.loading)?_c('div',{staticClass:"col-inner col-highlight sum sum-active"},[_c('div',{staticClass:"sum-type"},[_vm._v(_vm._s(_vm.translate['Einleitung'][_vm.lang]))]),_vm._v(" "),_c('h3',{staticClass:"ffs sum-title h3pad"},[(_vm.page)?_c('a',{attrs:{"href":"#g-main-content-title"},domProps:{"innerHTML":_vm._s(_vm.page.title.rendered)},on:{"click":_vm.selectedSection}}):_vm._e()]),_vm._v(" "),(_vm.page.hide_excerpt !== 'ja')?_c('div',{staticClass:"ffs sum-excerpt",domProps:{"innerHTML":_vm._s(_vm.page.excerpt.rendered)}}):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.sections),function(section){return (_vm.sections)?_c('div',{key:section.id,staticClass:"col-inner col-highlight sum"},[_c('div',{staticClass:"sum-type-section"},[_vm._v(_vm._s(_vm.translate['Abschnitt'][_vm.lang]))]),_vm._v(" "),_c('a',{attrs:{"href":'#' + section.id},on:{"click":_vm.selectedSection}},[_vm._v(_vm._s(section.textContent))])]):_vm._e()})],2)]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"max-width--960 sec_col flex-grow-1 flex-shrink-0",attrs:{"sm8":""}},[(!_vm.loading)?_c('div',{staticClass:"col-inner col-highlight"},[(_vm.page)?_c('h1',{attrs:{"id":"g-main-content-title"},domProps:{"innerHTML":_vm._s(_vm.page.title.rendered)}}):_vm._e(),_vm._v(" "),(_vm.page && _vm.page.hide_excerpt !== 'ja')?_c('div',{staticClass:"excerpt",domProps:{"innerHTML":_vm._s(_vm.page.excerpt.rendered)}}):_vm._e(),_vm._v(" "),(_vm.pageName === 'quellen' || _vm.pageName === 'sources')?_c('CollectionCatalogues',{attrs:{"lang":_vm.lang}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.page)?_c('div',{staticClass:"ffs",domProps:{"innerHTML":_vm._s(_vm.page.content.rendered)}}):_vm._e(),_vm._v(" "),((_vm.pageName === 'quellen' || _vm.pageName === 'sources'))?_c('Archivbestand',{attrs:{"lang":_vm.lang}}):_vm._e()],1):_vm._e()])],1)],1)],1)}
var Page_staticRenderFns = []
var Page_esExports = { render: Page_render, staticRenderFns: Page_staticRenderFns }
/* harmony default export */ var pages_Page = (Page_esExports);
// CONCATENATED MODULE: ./src/components/pages/Page.vue
function Page_injectStyle (ssrContext) {
  __webpack_require__("3Gzn")
}
var Page_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Page___vue_template_functional__ = false
/* styles */
var Page___vue_styles__ = Page_injectStyle
/* scopeId */
var Page___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Page___vue_module_identifier__ = null
var Page_Component = Page_normalizeComponent(
  Page,
  pages_Page,
  Page___vue_template_functional__,
  Page___vue_styles__,
  Page___vue_scopeId__,
  Page___vue_module_identifier__
)

/* harmony default export */ var components_pages_Page = (Page_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Posts.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Posts = ({
  firstSum: 0,
  name: 'Posts',
  data: function data() {
    return {
      msg: 'Posts',
      cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
      loading: true,
      currentPost: null,
      sum: null,
      isScrolling: null,
      scrollHasListener: false
    };
  },
  created: function created() {
    if (this.posts.length === 0) {
      this.getPosts();
    }
  },
  mounted: function mounted() {
    if (this.posts.length > 0) {
      this.loading = false;
      if (this.$route.params.pid) {
        this.setCurrentPost(Number(this.$route.params.pid));
      }
      this.sum = document.querySelector('.sum-fixed-posts');
      this.addScrollListener();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll, false);
  },

  watch: {
    posts: function posts() {
      if (this.posts.length > 0 && this.$route.params.pid) {
        this.setCurrentPost(Number(this.$route.params.pid));
      }
      if (this.posts.length > 0) {
        this.sum = document.querySelector('.sum-fixed-posts');
        this.addScrollListener();
      }
    },
    '$route': function $route(to, from) {
      this.setCurrentPost(to.params.pid);
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getPosts']), {
    setCurrentPost: function setCurrentPost(id, event) {
      var _this = this;

      if (event) {
        event.preventDefault();
      }
      this.posts.forEach(function (post) {
        if (post.id === id) {
          _this.currentPost = post;
          if (Number(_this.$route.params.pid) !== id) {
            _this.$router.push({ name: 'Post', params: { pid: id } });
          }
        }
      });
      var alle = document.getElementsByClassName('sum');
      for (var i = 0; i < alle.length; i++) {
        alle[i].classList.remove('sum-active');
      }
      var callerElement = document.getElementById('sum_' + id);
      if (callerElement) {
        callerElement.classList.add('sum-active');
      }
      var el = document.getElementById('g-main-content-title');
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },
    getActiveClass: function getActiveClass(id) {
      if (this.$route.params.pid) {
        if (Number(this.$route.params.pid) === id) {
          return 'col-inner col-highlight sum sum-active';
        } else {
          return 'col-inner col-highlight sum';
        }
      } else {
        if (this.$options.firstSum === 0) {
          this.$options.firstSum = this.$options.firstSum + 1;
          return 'col-inner col-highlight sum sum-active';
        } else {
          return 'col-inner col-highlight sum';
        }
      }
    },
    onScroll: function onScroll(event) {
      var sum = this.sum;
      window.clearTimeout(this.isScrolling);
      this.isScrolling = setTimeout(function () {
        var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
        var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
        if (windowWidth >= 600) {
          var offset = document.documentElement.scrollTop;
          if (offset > 48 && sum.offsetHeight < windowHeight) {
            sum.style.top = offset + 'px';
          } else {
            sum.style.top = '0';
          }
        } else {
          sum.style.top = '0';
        }
      }, 60);
    },
    addScrollListener: function addScrollListener() {
      if (!this.scrollHasListener) {
        window.addEventListener('scroll', this.onScroll, false);
        this.scrollHasListener = true;
      }
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['posts', 'firstpost', 'translate', 'lang']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3402b65a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Posts.vue
var Posts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"posts"},[_c('v-container',{attrs:{"grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.posts)?_c('v-flex',{staticClass:"sum-fixed__wrapper",attrs:{"sm4":""}},[_c('div',{staticClass:"sum-fixed-posts"},_vm._l((_vm.posts),function(post){return _c('div',{key:post.id},[((_vm.lang === 'de' && post.post_language !== 'en') || (_vm.lang === 'en' && post.post_language === 'en'))?_c('div',{class:_vm.getActiveClass(post.id),attrs:{"id":'sum_' + post.id}},[_c('div',{staticClass:"sum-type-section"},[_vm._v(_vm._s(_vm.translate['Beitrag'][_vm.lang]))]),_vm._v(" "),_c('a',{staticClass:"lnk_nostyle",attrs:{"href":'/posts/' + post.id},domProps:{"innerHTML":_vm._s(post.title.rendered)},on:{"click":function($event){return _vm.setCurrentPost(post.id, $event)}}})]):_vm._e()])}),0)]):_c('v-flex',{staticClass:"progress-wrapper",attrs:{"sm4":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey"}})],1),_vm._v(" "),(_vm.currentPost)?[_c('v-flex',{attrs:{"sm7":""}},[_c('div',{staticClass:"col-inner col-highlight"},[_c('h1',{attrs:{"id":"g-main-content-title"},domProps:{"innerHTML":_vm._s(_vm.currentPost.title.rendered)}}),_vm._v(" "),_c('div',{staticClass:"ffs",domProps:{"innerHTML":_vm._s(_vm.currentPost.content.rendered)}})])])]:(_vm.firstpost.hasOwnProperty(_vm.lang))?[_c('v-flex',{attrs:{"sm7":""}},[_c('div',{staticClass:"col-inner col-highlight"},[_c('h1',{attrs:{"id":"g-main-content-title"},domProps:{"innerHTML":_vm._s(_vm.firstpost[_vm.lang].title.rendered)}}),_vm._v(" "),_c('div',{staticClass:"ffs",domProps:{"innerHTML":_vm._s(_vm.firstpost[_vm.lang].content.rendered)}})])])]:_vm._e()],2)],1)],1)}
var Posts_staticRenderFns = []
var Posts_esExports = { render: Posts_render, staticRenderFns: Posts_staticRenderFns }
/* harmony default export */ var pages_Posts = (Posts_esExports);
// CONCATENATED MODULE: ./src/components/pages/Posts.vue
function Posts_injectStyle (ssrContext) {
  __webpack_require__("DS8o")
}
var Posts_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Posts___vue_template_functional__ = false
/* styles */
var Posts___vue_styles__ = Posts_injectStyle
/* scopeId */
var Posts___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Posts___vue_module_identifier__ = null
var Posts_Component = Posts_normalizeComponent(
  Posts,
  pages_Posts,
  Posts___vue_template_functional__,
  Posts___vue_styles__,
  Posts___vue_scopeId__,
  Posts___vue_module_identifier__
)

/* harmony default export */ var components_pages_Posts = (Posts_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/News.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var News = ({
  firstSum: 0,
  name: 'News',
  data: function data() {
    return {
      msg: 'News',
      cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase(),
      loading: true,
      currentPost: null
    };
  },
  created: function created() {
    if (this.aktuelles.length === 0) {
      this.getWpAktuelles();
    }
  },
  mounted: function mounted() {
    if (this.aktuelles.length > 0) {
      this.loading = false;
      if (this.$route.params.pid) {
        this.setCurrentPost(Number(this.$route.params.pid));
      } else {
        this.setCurrentPost();
      }
    }
  },

  watch: {
    aktuelles: function aktuelles() {
      if (this.aktuelles.length > 0 && this.$route.params.pid) {
        this.setCurrentPost(Number(this.$route.params.pid));
      } else if (this.aktuelles.length > 0) {
        this.setCurrentPost();
      }
    },
    '$route': function $route(to, from) {
      this.setCurrentPost(to.params.pid);
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getWpAktuelles']), {
    setCurrentPost: function setCurrentPost(id, event) {
      var _this = this;

      if (event) {
        event.preventDefault();
      }
      if (id) {
        this.aktuelles.forEach(function (post) {
          if (post.id === id) {
            _this.currentPost = post;
            if (Number(_this.$route.params.pid) !== id) {
              _this.$router.push({ name: 'News', params: { pid: id } });
            }
          }
        });
      } else if (this.aktuelles.length > 0) {
        this.currentPost = this.aktuelles_chronologically[0];
      }
      var alle = document.getElementsByClassName('sum');
      for (var i = 0; i < alle.length; i++) {
        alle[i].classList.remove('sum-active');
      }
      var callerElement = document.getElementById('sum_' + id);
      if (callerElement) {
        callerElement.classList.add('sum-active');
      }
      var el = document.getElementById('g-main-content-title');
      if (el) {
        setTimeout(function () {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
      }
    },
    getActiveClass: function getActiveClass(id) {
      if (this.$route.params.pid) {
        if (Number(this.$route.params.pid) === id) {
          return 'col-inner col-highlight sum sum-active';
        } else {
          return 'col-inner col-highlight sum';
        }
      } else {
        if (this.$options.firstSum === 0) {
          this.$options.firstSum = this.$options.firstSum + 1;
          return 'col-inner col-highlight sum sum-active';
        } else {
          return 'col-inner col-highlight sum';
        }
      }
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['aktuelles', 'firstpost', 'translate', 'lang']), {
    aktuelles_chronologically: function aktuelles_chronologically() {
      var aktuelles = this.aktuelles;
      if (aktuelles && aktuelles.length) {
        return [].concat(toConsumableArray_default()(aktuelles)).sort(function (a, b) {
          var aTime = new Date(a.date).getTime();
          var bTime = new Date(b.date).getTime();
          return aTime < bTime ? 1 : aTime > bTime ? -1 : 0;
        });
      }
    },
    title: function title() {
      var result = '';
      if (this.currentPost) {
        if (this.lang === 'de') {
          result = this.currentPost.titel_de;
        } else {
          result = this.currentPost.titel_en;
        }
      }
      return result;
    },
    content: function content() {
      var result = '';
      if (this.currentPost) {
        if (this.lang === 'de') {
          result = this.currentPost.deutsch;
        } else {
          result = this.currentPost.english;
        }
      }
      return result;
    },
    display_date: function display_date() {
      var result = '';
      if (this.currentPost) {
        var date = new Date(this.currentPost.display_date);
        result = date.toLocaleDateString(this.lang);
      }
      return result;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-418a3bd5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/News.vue
var News_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aktuelles"},[_c('v-container',{attrs:{"grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"sum-fixed__wrapper",attrs:{"md4":""}},[(_vm.aktuelles)?_vm._l((_vm.aktuelles_chronologically),function(post){return _c('div',{key:post.id,class:_vm.getActiveClass(post.id),attrs:{"id":'sum_' + post.id}},[_c('div',{staticClass:"sum-type-section"},[_vm._v(_vm._s(_vm.translate['Aktuelles'][_vm.lang]))]),_vm._v(" "),(_vm.lang === 'de')?_c('router-link',{staticClass:"lnk_nostyle",attrs:{"to":{ name: 'NewsId', params: { pid: post.id } }},domProps:{"innerHTML":_vm._s(post.titel_de)}}):_c('router-link',{staticClass:"lnk_nostyle",attrs:{"to":{ name: 'NewsId', params: { pid: post.id } }},domProps:{"innerHTML":_vm._s(post.titel_en)}})],1)}):_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey"}})],2),_vm._v(" "),(_vm.currentPost)?[_c('v-flex',{staticClass:"max-width--960 flex-grow-1 flex-shrink-0",attrs:{"md8":""}},[_c('div',{staticClass:"col-inner col-highlight"},[_c('h1',{attrs:{"id":"g-main-content-title"},domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"ffs display_date",domProps:{"innerHTML":_vm._s(_vm.display_date)}}),_vm._v(" "),_c('div',{staticClass:"ffs",domProps:{"innerHTML":_vm._s(_vm.content)}})])])]:_vm._e()],2)],1)],1)}
var News_staticRenderFns = []
var News_esExports = { render: News_render, staticRenderFns: News_staticRenderFns }
/* harmony default export */ var pages_News = (News_esExports);
// CONCATENATED MODULE: ./src/components/pages/News.vue
function News_injectStyle (ssrContext) {
  __webpack_require__("sh8n")
}
var News_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var News___vue_template_functional__ = false
/* styles */
var News___vue_styles__ = News_injectStyle
/* scopeId */
var News___vue_scopeId__ = "data-v-418a3bd5"
/* moduleIdentifier (server only) */
var News___vue_module_identifier__ = null
var News_Component = News_normalizeComponent(
  News,
  pages_News,
  News___vue_template_functional__,
  News___vue_styles__,
  News___vue_scopeId__,
  News___vue_module_identifier__
)

/* harmony default export */ var components_pages_News = (News_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Rooms.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'
// import BootstrapVue from 'bootstrap-vue'


/* harmony default export */ var Rooms = ({
  name: 'Rooms',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['plans', 'roomListings', 'roomIds', 'roomPeriods', 'markers1908', 'translate', 'lang'])),
  data: function data() {
    return {
      pdfUrl: '',
      // provisorische Jahresangaben
      provPeriods: [1900, 1908, 1912, 1913, 1915, 1921],
      akPeriod: 1908,
      akLevel: 'OG1',
      planSVGs: {
        p1908: {
          EG: '\n            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 636.3936 777.683" class="plan">\n              <title>1908_EG_01</title>\n              <g>\n                  <line x1="294.6446" y1="741.4804" x2="337.6231" y2="741.4804" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="371.4717" y1="744.8173" x2="427.6275" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="202.6875" y1="744.8173" x2="236.2896" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="127.8086" y1="744.8173" x2="161.4107" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="53.8604" y1="744.8173" x2="87.4625" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="466.8868" y1="744.8173" x2="503.6114" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="543.397" y1="744.8173" x2="575.3912" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M378.3654,757.2743v9.5879H352.6s.7974,6.6084-29.5791,6.6084-33.1714-6.6084-33.1714-6.6084H267.6784v-9.5879" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 1.5px"/>\n                  <path d="M363.1735,562.9531c0,11.3369,13.3653,15.0537,13.3653,15.0537h46.5488s3.6357.3183,3.6079-2.6534-.0029-31.0273,0-31.5634c.0054-.9219-.3423-3.4737-2.9976-3.4561-3.1186.0195-45.311,0-45.311,0s-15.2134.9209-15.2134,13.0967" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M374.4294,512.8769l-.2041,24.4375a3.0308,3.0308,0,0,0,1.86,3.1709" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M374.4294,604.0058l-.2041-22.6192a3.5456,3.5456,0,0,1,1.86-3.5625" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="373.2378" y1="509.415" x2="373.2378" y2="536.4267" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="378.7945" y1="509.415" x2="378.7945" y2="536.4267" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="384.3023" y1="509.415" x2="384.3023" y2="536.4267" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="389.8589" y1="509.415" x2="389.8589" y2="536.4267" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="395.563" y1="509.415" x2="395.563" y2="536.4267" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="401.1197" y1="509.415" x2="401.1197" y2="536.4267" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="406.0923" y1="509.415" x2="406.0923" y2="536.4267" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="411.649" y1="509.415" x2="411.649" y2="536.4267" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="415.9869" y1="509.415" x2="415.9869" y2="536.4267" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M424.5388,540.0478a3.1656,3.1656,0,0,0,3.07-2.7735V512.8769H369.0759l-.2041,25.8418a4.0243,4.0243,0,0,0,2.3008,3.4131" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M451.7175,539.8046H429.1027a3.0454,3.0454,0,0,0-2.5722,3.07" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M451.7863,578.9579H429.718a3.0107,3.0107,0,0,1-2.5093-3.07" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="373.2378" y1="574.956" x2="373.2378" y2="600.5439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="378.7945" y1="574.956" x2="378.7945" y2="600.5439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="384.3023" y1="574.956" x2="384.3023" y2="600.5439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="389.8589" y1="574.956" x2="389.8589" y2="600.5439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="395.563" y1="574.956" x2="395.563" y2="600.5439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="401.1197" y1="574.956" x2="401.1197" y2="600.5439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="406.0923" y1="574.956" x2="406.0923" y2="600.5439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="411.649" y1="574.956" x2="411.649" y2="600.5439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="415.9869" y1="574.956" x2="415.9869" y2="600.5439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M427.8259,577.8241v26.1817h-58.75l-.2041-24.6533a4.7511,4.7511,0,0,1,2.3008-3.87" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="419.9693" y1="569.4443" x2="444.8355" y2="569.4443" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="419.9693" y1="563.9365" x2="444.8355" y2="563.9365" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="419.9693" y1="558.3798" x2="444.8355" y2="558.3798" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="419.9693" y1="552.6757" x2="444.8355" y2="552.6757" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="419.9693" y1="547.1191" x2="444.8355" y2="547.1191" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="419.9693" y1="542.1464" x2="444.8355" y2="542.1464" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <circle cx="460.9932" cy="630.8173" r="3.1206" style="fill: #1d1d1b"/>\n                  <path d="M519.2629,634.2792a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,519.2629,634.2792Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M547.635,634.2792a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,547.635,634.2792Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <circle cx="460.9932" cy="737.4013" r="3.1206" style="fill: #1d1d1b"/>\n                  <path d="M519.2629,740.8632a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,519.2629,740.8632Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M547.635,740.8632a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,547.635,740.8632Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <rect x="452.4683" y="622.6992" width="15.7359" height="6.3447" style="fill: #1d1d1b"/>\n                  <rect x="501.1377" y="622.6992" width="25.2378" height="6.3447" style="fill: #1d1d1b"/>\n                  <polygon points="535.225 40.423 533.419 40.423 533.419 32.483 541.738 32.483 541.738 35.051 558.629 35.051 558.629 40.556 549.491 40.556 549.491 49.075 543.358 49.075 543.358 56.263 535.292 56.263 535.225 40.423" style="fill: #1d1d1b"/>\n                  <polygon points="543.231 88.984 543.231 96.616 548.698 96.616 548.698 105.005 558.04 105.005 558.04 111.56 540.598 111.56 537.603 119.175 533.707 117.294 534.904 113.294 533.303 113.363 533.303 104.803 536.271 104.803 536.271 88.984 543.231 88.984" style="fill: #1d1d1b"/>\n                  <polygon points="622.256 32.483 617.835 32.483 617.835 34.974 592.454 34.974 592.384 40.895 601.922 40.864 601.922 49.637 606.038 49.637 606.038 55.585 615.593 55.585 615.593 89.234 605.968 89.234 605.968 96.569 601.781 96.569 601.781 105.396 593.506 105.396 593.506 111.95 622.256 111.95 622.256 32.483" style="fill: #1d1d1b"/>\n                  <line x1="514.3736" y1="167.3354" x2="514.3736" y2="136.2519" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="514.3736" y1="212.7729" x2="514.3736" y2="180.5976" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="529.3741" y1="344.3398" x2="529.3741" y2="309.0126" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="529.3741" y1="412.3876" x2="529.3741" y2="380.2109" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="529.3741" y1="490.9941" x2="529.3741" y2="458.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="514.3736" y1="258.5732" x2="514.3736" y2="226.3979" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M562.8625,34.1586a2.3194,2.3194,0,1,1-2.32-2.32A2.3193,2.3193,0,0,1,562.8625,34.1586Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M585.3474,76.8041a4.1182,4.1182,0,1,1-4.1192-4.12A4.1182,4.1182,0,0,1,585.3474,76.8041Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M561.9274,90.8354a23.8589,23.8589,0,1,1,38.6094-.0122" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M564.2028,34.1586a3.6594,3.6594,0,1,1-3.6591-3.6611A3.6609,3.6609,0,0,1,564.2028,34.1586Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M605.9807,34.1586a2.3191,2.3191,0,1,1-2.3194-2.32A2.3192,2.3192,0,0,1,605.9807,34.1586Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M607.3215,34.1586a3.66,3.66,0,1,1-3.66-3.6611A3.6614,3.6614,0,0,1,607.3215,34.1586Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M607.9006,38.8119V16.4848h-8.0425s-9.1426-4.7578-17.5034-4.7578c-9.4116,0-18.5064,4.9341-18.5064,4.9341h-7.6416V34.7377h-17.84V49.8412h-12.38v52.1656h17.1778" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M564.8356,39.8173V20.6156a40.279,40.279,0,0,1,16.8824-4.3208c8.9975-.0444,17.5952,4.6778,17.5952,4.6778V39.8173" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="539.1241" y1="54.7504" x2="539.1241" y2="89.5029" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="558.629" y1="36.3159" x2="593.9185" y2="36.3159" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="521.6646" y1="128.7524" x2="536.2706" y2="118.1523" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polyline points="535.292 55.586 524.319 55.586 524.319 89.503 536.271 89.503" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M543.88,98.77a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,543.88,98.77Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M543.88,54.77a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,543.88,54.77Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M519.88,177.081a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,519.88,177.081Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M520.88,130.3808a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,520.88,130.3808Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <polygon points="511.748 126.919 521.415 126.919 522.998 130.085 519.623 130.627 519.623 132.477 516.873 132.477 516.873 136.669 511.748 136.669 511.748 126.919" style="fill: #1d1d1b"/>\n                  <path d="M518.6418,170.1723" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polygon points="511.748 166.71 516.915 166.71 516.915 170.523 519.727 170.523 519.727 178.21 516.852 178.21 516.852 181.335 511.748 181.335 511.748 166.71" style="fill: #1d1d1b"/>\n                  <path d="M519.88,223.1435a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,519.88,223.1435Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M519.88,267.5185a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,519.88,267.5185Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <polygon points="511.748 212.773 516.915 212.773 516.915 216.585 519.727 216.585 519.727 224.273 516.852 224.273 516.852 227.398 511.748 227.398 511.748 212.773" style="fill: #1d1d1b"/>\n                  <rect x="511.1021" y="257.2729" width="6" height="6.3125" style="fill: #1d1d1b"/>\n                  <path d="M522.0368,265.0619s12.9375,2.2354,13.125,14.11" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <polyline points="557.04 279.21 530.295 279.21 530.295 309.71" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="530.2945" y1="343.2104" x2="530.2945" y2="380.2109" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="530.2945" y1="410.9609" x2="530.2945" y2="458.9609" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="530.2945" y1="361.7109" x2="554.7896" y2="361.7109" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="581.2945" y1="361.7109" x2="614.5396" y2="361.7109" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="587.5396" y1="279.2104" x2="614.5396" y2="279.2104" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="530.2945" y1="442.4609" x2="554.7896" y2="442.4609" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="580.5445" y1="442.4609" x2="614.5396" y2="442.4609" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="618.2896" y1="108.7104" x2="618.2896" y2="749.8652" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="574.3287" y1="49.4643" x2="574.3287" y2="69.2221" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="581.7076" y1="50.6308" x2="575.6021" y2="69.4208" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="588.3648" y1="54.0204" x2="576.7515" y2="70.0038" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="593.6485" y1="59.3017" x2="577.6646" y2="70.913" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="597.0416" y1="65.957" x2="578.2525" y2="72.0605" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="598.212" y1="73.3349" x2="578.4566" y2="73.3329" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="597.0455" y1="80.7128" x2="578.2574" y2="74.6064" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="593.6558" y1="87.3701" x2="577.6744" y2="75.7568" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="566.9507" y1="50.6347" x2="573.0562" y2="69.4252" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="560.2945" y1="54.0283" x2="571.9078" y2="70.0117" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="555.0132" y1="59.312" x2="570.9976" y2="70.9247" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="551.6236" y1="65.9697" x2="570.4136" y2="72.0742" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="550.4566" y1="73.3486" x2="570.2134" y2="73.3481" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="551.6275" y1="80.727" x2="570.4166" y2="74.621" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="555.021" y1="87.3823" x2="571.0035" y2="75.769" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M572.1916,87.7153s-5.2617-2.3228-5.0034-13.34,13.3779-11.9414,14.041-11.9663c5.6191-.2109,14.0293,4.1934,13.999,12.2842-.039,10.3867-6.6269,13.6553-6.6269,13.6553s-7.0249,4.3759-7.0777,8.6465c-.0688,5.5883,0,10.5468,0,10.5468" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <polyline points="420.715 505.647 448.432 505.647 448.432 603.878 418.715 603.878" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <path d="M371.6926,505.4531h-4.8081s.91-11.4737-4.919-15.15-9.2343-3.959-9.2343-3.959v-6.93h14.0117v6.5049h4.95Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M276.9475,505.4531h4.8081s-.91-11.4737,4.9189-15.15,9.2344-3.959,9.2344-3.959v-6.93H281.8972v6.5049h-4.95Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <line x1="288.8013" y1="480.4833" x2="345.8375" y2="480.4833" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="530.2945" y1="489.7021" x2="530.2945" y2="514.5244" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <polygon points="455.369 500.311 460.777 503.569 455.924 510.364 448.783 510.364 455.369 500.311" style="fill: #1d1d1b"/>\n                  <polygon points="522.223 500.311 516.815 503.569 522.813 511.415 531.22 511.415 522.223 500.311" style="fill: #1d1d1b"/>\n                  <polygon points="470.207 478.679 477.348 478.679 477.348 484.642 474.367 484.642 473.327 486.514 467.919 483.116 470.207 478.679" style="fill: #1d1d1b"/>\n                  <polygon points="506.844 478.679 499.703 478.679 499.703 484.642 502.684 484.642 503.724 486.514 509.132 483.116 506.844 478.679" style="fill: #1d1d1b"/>\n                  <line x1="386.7896" y1="505.6601" x2="422.4698" y2="505.6601" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="212.7896" y1="505.6601" x2="248.4698" y2="505.6601" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="122.7847" y1="620.2939" x2="147.0635" y2="620.2939" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="206.4869" y1="620.2939" x2="230.7657" y2="620.2939" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="299.4795" y1="505.6601" x2="335.1597" y2="505.6601" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="476.4566" y1="481.5439" x2="500.6231" y2="481.5439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="386.7896" y1="603.8779" x2="422.4698" y2="603.8779" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="457.6573" y1="502.1132" x2="470.7613" y2="484.2255" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="506.399" y1="484.2255" x2="520.127" y2="502.5292" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="387.7896" y1="505.6474" x2="334.2896" y2="505.6474" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="300.9561" y1="505.6474" x2="247.4561" y2="505.6474" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="294.9556" y1="602.5439" x2="274.2056" y2="602.5439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="213.6231" y1="505.8632" x2="180.4561" y2="505.8632" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="387.1231" y1="603.8779" x2="337.6231" y2="603.8779" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <rect x="280.2896" y="508.0439" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="342.9566" y="508.0439" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="354.3116" y="508.0439" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="280.2896" y="598.3769" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="342.9566" y="598.3769" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="354.3116" y="598.3769" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="280.2896" y="605.2109" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="342.9566" y="605.2109" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="354.3116" y="605.2109" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="280.2896" y="638.3779" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="342.9566" y="638.3779" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="354.3116" y="638.3779" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="351.775" y="550.0527" width="9.5834" height="9.3222" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M366.5812,558.1777a3.1209,3.1209,0,1,1-3.121-3.12A3.1207,3.1207,0,0,1,366.5812,558.1777Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <rect x="341.0108" y="550.0527" width="9.5835" height="9.3222" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M355.8171,558.1777a3.1209,3.1209,0,1,1-3.1211-3.12A3.1207,3.1207,0,0,1,355.8171,558.1777Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <rect x="279.3599" y="550.0527" width="9.5835" height="9.3222" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M294.1662,558.1777a3.1209,3.1209,0,1,1-3.1211-3.12A3.1207,3.1207,0,0,1,294.1662,558.1777Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <polyline points="18.828 105.467 17.954 744.817 53.861 744.817" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <polygon points="14.535 33.313 14.535 112.574 48.07 112.574 48.07 106.546 43.166 106.546 43.166 103.684 35.028 103.684 35.028 95.395 30.205 95.395 30.205 89.519 21.015 89.519 21.015 53.656 30.056 53.656 30.056 47.477 34.878 47.477 34.878 38.437 48.07 38.437 48.07 33.313 14.535 33.313" style="fill: #1d1d1b"/>\n                  <polygon points="95.505 88.739 102.412 88.739 102.412 105.03 104.456 105.03 104.456 113.769 96.279 113.769 96.279 111.654 78.802 111.654 78.802 107.145 81.482 107.145 81.482 104.396 89.374 104.396 89.374 96.08 95.434 96.08 95.505 88.739" style="fill: #1d1d1b"/>\n                  <polygon points="104.22 31.829 95.658 31.829 95.658 33.313 79.815 33.313 79.815 38.437 89.888 38.437 89.888 47.477 95.706 47.477 95.706 55.178 102.281 55.178 102.281 40.342 104.22 40.342 104.22 31.829" style="fill: #1d1d1b"/>\n                  <path d="M94.6584,32.4941a2.8123,2.8123,0,1,1-2.812-2.813A2.8129,2.8129,0,0,1,94.6584,32.4941Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M112.152,53.0361a2.8118,2.8118,0,1,1-2.8115-2.8116A2.8121,2.8121,0,0,1,112.152,53.0361Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M112.152,98.0829a2.8118,2.8118,0,1,1-2.8115-2.8115A2.8126,2.8126,0,0,1,112.152,98.0829Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M96.2834,32.4941a4.4373,4.4373,0,1,1-4.436-4.4385A4.438,4.438,0,0,1,96.2834,32.4941Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M52.1687,32.4941a2.8121,2.8121,0,1,1-2.8121-2.813A2.813,2.813,0,0,1,52.1687,32.4941Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M53.7951,32.4941a4.438,4.438,0,1,1-4.4375-4.4385A4.4393,4.4393,0,0,1,53.7951,32.4941Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M108.0939,101.311h18.2588V92.5649h-2.186V58.2328h2.186V49.5937H112.905V34.2875H97.8171V15.1523H87.4089S78.8747,10.71,71.07,10.71c-8.7851,0-17.2744,4.6059-17.2744,4.6059H43.7629V33.4115H21.4289v3.3638" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polyline points="102.281 54.771 113.009 54.771 113.009 89.103 102.447 89.103" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="46.9014" y1="35.3784" x2="81.4502" y2="35.3784" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="99.0884" y1="54.7709" x2="99.0884" y2="89.103" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M54.715,36.9325V19.0082a37.6082,37.6082,0,0,1,15.76-4.0342C78.8747,14.9325,86.9,19.34,86.9,19.34V36.9325" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="100.5445" y1="112.5737" x2="100.5445" y2="279.2104" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 7px"/>\n                  <path d="M115.0915,132.1078a3.0608,3.0608,0,1,1-3.06-3.061A3.0612,3.0612,0,0,1,115.0915,132.1078Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M115.0915,178.3207a3.0608,3.0608,0,1,1-3.06-3.061A3.062,3.062,0,0,1,115.0915,178.3207Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M115.0915,225.2631a3.0608,3.0608,0,1,1-3.06-3.0615A3.0619,3.0619,0,0,1,115.0915,225.2631Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <line x1="104.3018" y1="273.9604" x2="104.3018" y2="295.4604" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="104.3028" y1="319.4604" x2="104.3028" y2="345.6757" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="104.3018" y1="371.4609" x2="104.3018" y2="396.8261" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="104.3028" y1="416.4609" x2="104.3028" y2="458.7109" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="21.5357" y1="277.1664" x2="100.5445" y2="277.1664" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 7px"/>\n                  <line x1="21.5357" y1="322.7353" x2="78.3428" y2="322.7353" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 7px"/>\n                  <line x1="41.1431" y1="426.9609" x2="104.3028" y2="426.9609" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 7px"/>\n                  <line x1="104.3028" y1="294.2104" x2="104.3028" y2="322.7353" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="104.3028" y1="344.9604" x2="104.3028" y2="372.3359" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="104.3028" y1="395.7704" x2="104.3028" y2="421.6259" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="104.3028" y1="456.873" x2="104.3028" y2="486.9423" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polyline points="517.102 260.429 531.602 260.429 531.602 275.427" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polygon points="96.478 489.136 102.383 489.136 102.383 486.942 105.928 486.942 105.928 503.395 109.028 498.342 114.378 502.706 109.176 509.764 106.539 509.764 106.539 517.175 101.941 517.632 101.941 516.17 95.224 509.521 95.224 507.548 96.627 507.548 96.478 489.136" style="fill: #1d1d1b"/>\n                  <polygon points="120.435 483.639 124.01 479.609 124.01 476.661 133.444 476.661 133.444 483.053 128.776 483.053 125.598 487.669 120.435 483.639" style="fill: #1d1d1b"/>\n                  <polygon points="165.815 483.639 162.24 479.609 162.24 476.661 152.806 476.661 152.806 483.053 157.474 483.053 160.651 487.669 165.815 483.639" style="fill: #1d1d1b"/>\n                  <polygon points="177.036 498.186 172.37 502.287 178.21 509.764 181.008 509.764 181.008 502.891 177.036 498.186" style="fill: #1d1d1b"/>\n                  <line x1="132.5167" y1="479.9277" x2="153.73" y2="479.9277" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="162.8873" y1="484.1884" x2="176.0118" y2="501.2626" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="124.1226" y1="484.1884" x2="110.6919" y2="502.287" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polyline points="122.963 620.294 92.851 620.294 92.851 609.137" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="52.0235" y1="531.579" x2="52.0235" y2="581.2285" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="52.0235" y1="512.7958" x2="52.0235" y2="517.2128" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="40.3545" y1="581.2285" x2="60.6617" y2="581.2285" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="84.4419" y1="581.2285" x2="94.5958" y2="581.2285" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="53.211" y1="536.8329" x2="91.1827" y2="536.8329" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="53.211" y1="540.9247" x2="91.1827" y2="540.9247" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="53.211" y1="545.0146" x2="91.1827" y2="545.0146" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="53.211" y1="549.1064" x2="91.1827" y2="549.1064" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="53.211" y1="553.1972" x2="91.1827" y2="553.1972" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="53.211" y1="557.288" x2="91.1827" y2="557.288" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="53.211" y1="561.3788" x2="91.1827" y2="561.3788" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <polyline points="118.663 617.853 118.663 599.361 94.596 599.361" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 2px"/>\n                  <polyline points="92.851 601.985 92.851 518.62 84.442 510.764 80.078 510.764" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="60.6617" y1="510.7636" x2="41.6065" y2="510.7636" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="146.4107" y1="620.2939" x2="207.4869" y2="620.2939" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="146.4107" y1="643.6025" x2="207.4869" y2="643.6025" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="230.3316" y1="643.6025" x2="303.8921" y2="643.6025" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="326.9756" y1="643.6025" x2="391.9595" y2="643.6025" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="414.1202" y1="643.6025" x2="448.7833" y2="643.6025" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="68.563" y1="643.6025" x2="123.5298" y2="643.6025" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="21.379" y1="643.6025" x2="45.7959" y2="643.6025" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <polyline points="230.121 620.294 271.417 620.294 271.417 508.613" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="184.2916" y1="505.8632" x2="184.2916" y2="517.0995" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="184.2916" y1="533.2792" x2="184.2916" y2="619.4999" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <rect x="274.2056" y="550.705" width="2.7573" height="8.1465" style="fill: #1d1d1b"/>\n                  <line x1="44.5152" y1="429.7744" x2="44.5152" y2="466.2841" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 3px"/>\n                  <line x1="44.5152" y1="473.414" x2="44.5152" y2="493.6669" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 3px"/>\n                  <path d="M597.4294,740.6288a2.7793,2.7793,0,1,1-2.78-2.7783A2.78,2.78,0,0,1,597.4294,740.6288Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M597.4294,634.622a2.7793,2.7793,0,1,1-2.78-2.7783A2.78,2.78,0,0,1,597.4294,634.622Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M621.3547,659.6093a2.7791,2.7791,0,1,1-2.78-2.7783A2.78,2.78,0,0,1,621.3547,659.6093Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M621.3547,721.1513a2.7791,2.7791,0,1,1-2.78-2.7783A2.7792,2.7792,0,0,1,621.3547,721.1513Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M609.322,634.0234a9.9889,9.9889,0,0,0-9.2285,6.17c.1777-.0078.352-.0264.5322-.0264a11.6,11.6,0,0,1,11.539,13.4151,9.9856,9.9856,0,0,0-2.8427-19.5586Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M619.4807,732.4843a9.9889,9.9889,0,0,0-6.17-9.2295c.0078.1777.0263.3525.0263.5322a11.6,11.6,0,0,1-13.415,11.5391,9.9858,9.9858,0,0,0,19.5591-2.8418Z" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="616.483" y1="744.8173" x2="574.0064" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="543.397" y1="744.8173" x2="501.3067" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="468.2779" y1="744.8173" x2="426.1875" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="204.8052" y1="744.8173" x2="160.4107" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="261.9537" y1="744.8173" x2="234.9654" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="128.8516" y1="744.8173" x2="86.4644" y2="744.8173" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <polygon points="260.09 739.809 260.09 754.812 275.386 754.812 275.386 748.36 282.755 748.36 282.755 752.185 289.778 752.185 289.778 748.291 294.645 748.291 294.645 739.809 260.09 739.809" style="fill: #1d1d1b"/>\n                  <polygon points="372.178 739.809 372.178 754.812 356.882 754.812 356.882 748.36 349.512 748.36 349.512 752.185 342.49 752.185 342.49 748.291 337.623 748.291 337.623 739.809 372.178 739.809" style="fill: #1d1d1b"/>\n                  <line x1="364.7803" y1="643.498" x2="364.7803" y2="675.8193" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="174.2647" y1="643.498" x2="174.2647" y2="675.8193" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="174.2647" y1="704.0429" x2="174.2647" y2="739.9462" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="264.8067" y1="643.498" x2="264.8067" y2="675.8193" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="264.8067" y1="704.0429" x2="264.8067" y2="741.4804" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="364.7803" y1="705.8271" x2="364.7803" y2="742.3691" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="579.0694" y1="533.8701" x2="616.71" y2="533.8701" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="575.2359" y1="624.6953" x2="617.1861" y2="624.6953" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <path d="M533.0852,543.3388H539.79l18.1285-10.9863s5.7666,1.7822,3.8921,6.6943c-.7955,2.084-4.2217,1.92-6.3614,1.8535a24.4483,24.4483,0,0,0-8.2578.835c-2.3613.7939-6.7309,2.9443-6.8647,5.7607s0,67.1846,0,69.33,5.4985,8.7373,8.9848,8.8613,5.3643,0,5.3643,0v6.4365h-21.59Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <line x1="448.4317" y1="622.6992" x2="448.4317" y2="679.0224" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="448.4317" y1="708.5527" x2="448.4317" y2="741.4804" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <path d="M545.9654,552.6757h22.602a2.8345,2.8345,0,0,1,2.8345,2.8345v50.1157a2.835,2.835,0,0,1-2.835,2.835h-22.602a2.8345,2.8345,0,0,1-2.8345-2.8345V555.5107A2.835,2.835,0,0,1,545.9654,552.6757Z" style="fill: none;stroke: #b1b1b1;stroke-miterlimit: 10"/>\n                  <line x1="581.7359" y1="537.8779" x2="581.7359" y2="599.2978" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 2px"/>\n                  <path d="M582.13,613.1728s15.8037,3.2988,15.8037-10.4131.125-45.2119,0-45.7119a7.8858,7.8858,0,0,1,8-6.75c6.625,0,7.4375,6.375,7.4375,7.4375v54.1875" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M605.5583,558.1728s-.7749,48.125-.7749,50.875-1.3325,15.125-22.6538,15.125" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="581.7359" y1="558.8359" x2="614.4615" y2="558.8359" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="581.7359" y1="563.7294" x2="614.4615" y2="563.7294" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="581.7359" y1="568.624" x2="614.4615" y2="568.624" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="581.7359" y1="573.5175" x2="614.4615" y2="573.5175" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="581.7359" y1="578.4111" x2="614.4615" y2="578.4111" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="581.7359" y1="583.3056" x2="614.4615" y2="583.3056" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="581.7359" y1="588.1992" x2="614.4615" y2="588.1992" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <circle cx="600.2896" cy="552.0859" r="2.625" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M607.1833,541.9228A13.625,13.625,0,1,1,596.06,563.42" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="582.2896" y1="591.0859" x2="598.0987" y2="594.0859" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="582.2896" y1="594.7109" x2="597.8897" y2="603.2109" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="582.2896" y1="598.3359" x2="597.025" y2="610.0585" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <polyline points="592.503 616.114 581.736 598.961 585.838 619.38" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="600.7896" y1="549.4609" x2="602.9146" y2="538.7138" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="601.814" y1="549.8915" x2="608.1265" y2="540.9374" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="602.5748" y1="550.7011" x2="611.983" y2="545.0888" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="602.94" y1="551.7509" x2="613.8179" y2="550.4501" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="602.8472" y1="552.8583" x2="613.313" y2="556.0937" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="602.3121" y1="553.832" x2="610.5572" y2="561.0439" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="601.4273" y1="554.5038" x2="606.0259" y2="564.4453" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="600.3453" y1="554.7578" x2="600.5025" y2="565.7099" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="599.2535" y1="554.5497" x2="594.9424" y2="564.6181" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="598.3404" y1="553.915" x2="590.3072" y2="561.3603" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n              </g>\n              <g>\n                  <rect x="506.6989" y="6.248" width="124.0671" height="369.4078" style="fill: #fff"/>\n                  <polygon points="0 0 178.233 0 178.233 378.023 636.394 378.023 636.394 777.683 0 777.683 0 0" style="fill: #fff;opacity: 0.7000000000000001"/>\n              </g>\n              <g>\n                  <g>\n                  <path d="M512.9724,43.1877h-5.2207v4.8608h5.8408V49.509h-7.6016V36.0261h7.3018v1.46h-5.541v4.2608h5.2207Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M526.1335,48.9089a12.1988,12.1988,0,0,1-4.1611.74,6.3327,6.3327,0,0,1-6.9219-6.8017c0-4.0206,2.7812-6.9615,7.3017-6.9615a8.4584,8.4584,0,0,1,3.3809.62l-.44,1.42a6.6971,6.6971,0,0,0-2.9805-.58,5.0427,5.0427,0,0,0-5.4209,5.4214c0,3.42,2.04,5.4409,5.2012,5.4409a5.6812,5.6812,0,0,0,2.32-.36v-4.021h-2.7207v-1.4h4.4414Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  </g>\n                  <line x1="531.34" y1="315.6472" x2="531.34" y2="297.364" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="531.34" y1="368.9743" x2="531.34" y2="347.447" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M525.841,177.2873a3.1616,3.1616,0,1,1-3.1616-3.1616A3.1615,3.1615,0,0,1,525.841,177.2873Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M525.841,223.4543a3.1616,3.1616,0,1,1-3.1616-3.1616A3.1615,3.1615,0,0,1,525.841,223.4543Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <line x1="531.34" y1="313.9802" x2="531.34" y2="348.6472" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="531.34" y1="368.9743" x2="531.34" y2="375.7468" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <polyline points="618.063 281.313 531.34 281.313 531.34 297.364" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="618.3703" y1="114.3132" x2="618.3703" y2="375.7468" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <polygon points="533.494 53.48 533.494 31.48 622.161 31.48 622.161 116.98 604.161 116.98 604.161 118.98 597.661 118.98 597.661 110.313 605.661 110.313 605.661 102.647 609.494 102.647 609.494 94.147 616.161 94.147 616.161 52.98 609.661 52.98 609.661 45.813 605.161 45.813 605.161 40.647 547.994 40.647 547.994 44.98 543.494 44.98 543.494 53.573 533.494 53.48" style="fill: #1d1d1b"/>\n                  <path d="M540.3874,96.7751h9.167v8.8335h5.6665v6.6665h7.6665v10.1665h-7.5v-2.333h-6.6665s-6.333,16-20.6665,16.333v2.3335h-8v-3.1665l-1.667-2,4.667-4.8335,2.5,2.1411s9.666,1.5259,17.333-10.3076a18.0438,18.0438,0,0,1-2.5-1.7334Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <line x1="539.2023" y1="53.5324" x2="539.2023" y2="93.3132" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M586.1794,78.2658a4.1182,4.1182,0,1,1-4.1191-4.12A4.1182,4.1182,0,0,1,586.1794,78.2658Z" transform="translate(-6.8936 -3.4619)" style="fill: #1d1d1b"/>\n                  <path d="M562.76,92.2971a23.859,23.859,0,1,1,38.6093-.0122" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="575.1608" y1="50.926" x2="575.1608" y2="70.6838" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="582.5397" y1="52.0925" x2="576.4342" y2="70.8825" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="589.1969" y1="55.4821" x2="577.5836" y2="71.4655" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="594.4806" y1="60.7634" x2="578.4967" y2="72.3747" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="597.8737" y1="67.4187" x2="579.0846" y2="73.5222" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="599.0441" y1="74.7966" x2="579.2887" y2="74.7946" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="597.8776" y1="82.1745" x2="579.0895" y2="76.0681" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="594.4879" y1="88.8317" x2="578.5065" y2="77.2185" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="567.7829" y1="52.0964" x2="573.8883" y2="70.8869" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="561.1266" y1="55.4899" x2="572.7399" y2="71.4733" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="555.8454" y1="60.7736" x2="571.8297" y2="72.3864" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="552.4557" y1="67.4313" x2="571.2458" y2="73.5358" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="551.2887" y1="74.8103" x2="571.0456" y2="74.8098" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="552.4596" y1="82.1887" x2="571.2487" y2="76.0827" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="555.8532" y1="88.8439" x2="571.8356" y2="77.2307" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M573.0236,89.1769s-5.2617-2.3227-5.0034-13.34,13.3779-11.9414,14.041-11.9663c5.6192-.2109,14.0293,4.1934,13.9991,12.2842-.0391,10.3867-6.627,13.6553-6.627,13.6553s-7.0249,4.3759-7.0776,8.6464c-.0689,5.5884,0,10.5469,0,10.5469" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <polyline points="517.671 261.647 532.171 261.647 532.171 278.144" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 2px"/>\n                  <g>\n                  <line x1="515.7853" y1="134.3347" x2="515.7853" y2="135.3347" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="515.7853" y1="137.3053" x2="515.7853" y2="258.4939" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-dasharray: 1.9705476760864258,1.9705476760864258"/>\n                  <line x1="515.7853" y1="259.4792" x2="515.7853" y2="260.4792" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  </g>\n                  <path d="M524.0178,267.1491s11.8628,4.4487,11.8628,14.6856" transform="translate(-6.8936 -3.4619)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 3px"/>\n                  <polygon points="510.523 263.305 513.536 259.239 517.671 259.239 519.564 261.647 515.354 267.323 510.523 263.305" style="fill: #1d1d1b"/>\n                  <line x1="533.442" y1="322.7009" x2="554.0797" y2="322.7009" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="567.6232" y1="322.7009" x2="615.1862" y2="322.7009" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n              </g>\n            </svg>\n          ',
          OG1: '\n            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 609.3427 764.0107" class="plan">\n              <title>1908_0G_01_01</title>\n              <g>\n                  <line x1="281.6977" y1="734.7324" x2="324.6762" y2="734.7324" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="358.5248" y1="738.0693" x2="414.6806" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="189.7406" y1="738.0693" x2="223.3427" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="114.8617" y1="738.0693" x2="148.4638" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="40.9135" y1="738.0693" x2="74.5156" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="453.9399" y1="738.0693" x2="490.6645" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="530.4501" y1="738.0693" x2="562.4443" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M378.3654,757.2743v9.5879H352.6s.7974,6.6084-29.5791,6.6084-33.1714-6.6084-33.1714-6.6084H267.6784v-9.5879" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 1.5px"/>\n                  <path d="M363.1735,562.9531c0,11.3369,13.3653,15.0537,13.3653,15.0537h46.5488s3.6357.3183,3.6079-2.6534-.0029-31.0273,0-31.5634c.0054-.9219-.3423-3.4737-2.9976-3.4561-3.1186.0195-45.311,0-45.311,0s-15.2134.9209-15.2134,13.0967" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M374.4294,512.8769l-.2041,24.4375a3.0308,3.0308,0,0,0,1.86,3.1709" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M374.4294,604.0058l-.2041-22.6192a3.5456,3.5456,0,0,1,1.86-3.5625" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="360.2909" y1="502.667" x2="360.2909" y2="529.6787" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="365.8476" y1="502.667" x2="365.8476" y2="529.6787" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="371.3554" y1="502.667" x2="371.3554" y2="529.6787" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="376.912" y1="502.667" x2="376.912" y2="529.6787" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="382.6161" y1="502.667" x2="382.6161" y2="529.6787" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="388.1728" y1="502.667" x2="388.1728" y2="529.6787" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="393.1454" y1="502.667" x2="393.1454" y2="529.6787" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="398.7021" y1="502.667" x2="398.7021" y2="529.6787" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="403.04" y1="502.667" x2="403.04" y2="529.6787" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M424.5388,540.0478a3.1656,3.1656,0,0,0,3.07-2.7735V512.8769H369.0759l-.2041,25.8418a4.0243,4.0243,0,0,0,2.3008,3.4131" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M451.7175,539.8046H429.1027a3.0454,3.0454,0,0,0-2.5722,3.07" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M451.7863,578.9579H429.718a3.0107,3.0107,0,0,1-2.5093-3.07" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="360.2909" y1="568.208" x2="360.2909" y2="593.7959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="365.8476" y1="568.208" x2="365.8476" y2="593.7959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="371.3554" y1="568.208" x2="371.3554" y2="593.7959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="376.912" y1="568.208" x2="376.912" y2="593.7959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="382.6161" y1="568.208" x2="382.6161" y2="593.7959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="388.1728" y1="568.208" x2="388.1728" y2="593.7959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="393.1454" y1="568.208" x2="393.1454" y2="593.7959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="398.7021" y1="568.208" x2="398.7021" y2="593.7959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="403.04" y1="568.208" x2="403.04" y2="593.7959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M427.8259,577.8241v26.1817h-58.75l-.2041-24.6533a4.7511,4.7511,0,0,1,2.3008-3.87" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="407.0224" y1="562.6963" x2="431.8886" y2="562.6963" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="407.0224" y1="557.1885" x2="431.8886" y2="557.1885" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="407.0224" y1="551.6318" x2="431.8886" y2="551.6318" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="407.0224" y1="545.9277" x2="431.8886" y2="545.9277" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="407.0224" y1="540.3711" x2="431.8886" y2="540.3711" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="407.0224" y1="535.3984" x2="431.8886" y2="535.3984" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <circle cx="448.0463" cy="624.0693" r="3.1206" style="fill: #1d1d1b"/>\n                  <path d="M519.2629,634.2792a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,519.2629,634.2792Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M547.635,634.2792a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,547.635,634.2792Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <circle cx="448.0463" cy="730.6533" r="3.1206" style="fill: #1d1d1b"/>\n                  <path d="M519.2629,740.8632a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,519.2629,740.8632Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M547.635,740.8632a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,547.635,740.8632Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <rect x="439.5214" y="615.9512" width="15.7359" height="6.3447" style="fill: #1d1d1b"/>\n                  <rect x="488.1908" y="615.9512" width="25.2378" height="6.3447" style="fill: #1d1d1b"/>\n                  <polygon points="522.278 33.675 520.472 33.675 520.472 25.735 528.791 25.735 528.791 28.303 545.682 28.303 545.682 33.808 536.544 33.808 536.544 42.327 530.411 42.327 530.411 49.515 522.345 49.515 522.278 33.675" style="fill: #1d1d1b"/>\n                  <polygon points="530.284 82.236 530.284 89.868 535.751 89.868 535.751 98.257 545.093 98.257 545.093 104.812 527.651 104.812 524.656 112.427 520.76 110.546 521.957 106.546 520.356 106.615 520.356 98.055 523.324 98.055 523.324 82.236 530.284 82.236" style="fill: #1d1d1b"/>\n                  <polygon points="609.309 25.735 604.888 25.735 604.888 28.226 579.507 28.226 579.437 34.146 588.975 34.116 588.975 42.889 593.091 42.889 593.091 48.837 602.646 48.837 602.646 82.486 593.021 82.486 593.021 89.821 588.834 89.821 588.834 98.648 580.559 98.648 580.559 105.202 609.309 105.202 609.309 25.735" style="fill: #1d1d1b"/>\n                  <line x1="501.4267" y1="160.5874" x2="501.4267" y2="129.5039" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="501.4267" y1="206.0249" x2="501.4267" y2="173.8496" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="516.4272" y1="337.5918" x2="516.4272" y2="302.2646" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="516.4272" y1="405.6396" x2="516.4272" y2="373.4629" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="516.4272" y1="484.2461" x2="516.4272" y2="452.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="501.4267" y1="251.8252" x2="501.4267" y2="219.6499" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M562.8625,34.1586a2.3194,2.3194,0,1,1-2.32-2.32A2.3193,2.3193,0,0,1,562.8625,34.1586Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M585.3474,76.8041a4.1182,4.1182,0,1,1-4.1192-4.12A4.1182,4.1182,0,0,1,585.3474,76.8041Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M561.9274,90.8354a23.8589,23.8589,0,1,1,38.6094-.0122" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M564.2028,34.1586a3.6594,3.6594,0,1,1-3.6591-3.6611A3.6609,3.6609,0,0,1,564.2028,34.1586Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M605.9807,34.1586a2.3191,2.3191,0,1,1-2.3194-2.32A2.3192,2.3192,0,0,1,605.9807,34.1586Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M607.3215,34.1586a3.66,3.66,0,1,1-3.66-3.6611A3.6614,3.6614,0,0,1,607.3215,34.1586Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M607.9006,38.8119V16.4848h-8.0425s-9.1426-4.7578-17.5034-4.7578c-9.4116,0-18.5064,4.9341-18.5064,4.9341h-7.6416V34.7377h-17.84V49.8412h-12.38v52.1656h17.1778" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M564.8356,39.8173V20.6156a40.279,40.279,0,0,1,16.8824-4.3208c8.9975-.0444,17.5952,4.6778,17.5952,4.6778V39.8173" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="526.1772" y1="48.0024" x2="526.1772" y2="82.7549" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="545.6821" y1="29.5679" x2="580.9716" y2="29.5679" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="508.7177" y1="122.0044" x2="523.3237" y2="111.4043" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polyline points="522.345 48.838 511.372 48.838 511.372 82.755 523.324 82.755" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M543.88,98.77a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,543.88,98.77Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M543.88,54.77a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,543.88,54.77Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M519.88,177.081a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,519.88,177.081Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M520.88,130.3808a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,520.88,130.3808Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <polygon points="498.801 120.171 508.468 120.171 510.051 123.337 506.676 123.879 506.676 125.729 503.926 125.729 503.926 129.921 498.801 129.921 498.801 120.171" style="fill: #1d1d1b"/>\n                  <path d="M518.6418,170.1723" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polygon points="498.801 159.962 503.968 159.962 503.968 163.775 506.78 163.775 506.78 171.462 503.905 171.462 503.905 174.587 498.801 174.587 498.801 159.962" style="fill: #1d1d1b"/>\n                  <path d="M519.88,223.1435a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,519.88,223.1435Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M519.88,267.5185a3.2378,3.2378,0,1,1-3.2378-3.2378A3.2378,3.2378,0,0,1,519.88,267.5185Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <polygon points="498.801 206.025 503.968 206.025 503.968 209.837 506.78 209.837 506.78 217.525 503.905 217.525 503.905 220.65 498.801 220.65 498.801 206.025" style="fill: #1d1d1b"/>\n                  <rect x="498.1552" y="250.5249" width="6" height="6.3125" style="fill: #1d1d1b"/>\n                  <path d="M522.0368,265.0619s12.9375,2.2354,13.125,14.11" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <polyline points="544.093 272.462 517.348 272.462 517.348 302.962" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="517.3476" y1="336.4624" x2="517.3476" y2="373.4629" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="517.3476" y1="404.2129" x2="517.3476" y2="452.2129" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="517.3476" y1="354.9629" x2="541.8427" y2="354.9629" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="568.3476" y1="354.9629" x2="601.5927" y2="354.9629" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="574.5927" y1="272.4624" x2="601.5927" y2="272.4624" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="517.3476" y1="435.7129" x2="541.8427" y2="435.7129" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="567.5976" y1="435.7129" x2="601.5927" y2="435.7129" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="605.3427" y1="101.9624" x2="605.3427" y2="743.1172" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="561.3818" y1="42.7163" x2="561.3818" y2="62.4741" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="568.7607" y1="43.8828" x2="562.6552" y2="62.6728" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="575.4179" y1="47.2724" x2="563.8046" y2="63.2558" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="580.7016" y1="52.5537" x2="564.7177" y2="64.165" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="584.0947" y1="59.209" x2="565.3056" y2="65.3125" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="585.2651" y1="66.5869" x2="565.5097" y2="66.5849" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="584.0986" y1="73.9648" x2="565.3105" y2="67.8584" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="580.7089" y1="80.6221" x2="564.7275" y2="69.0088" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="554.0038" y1="43.8867" x2="560.1093" y2="62.6772" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="547.3476" y1="47.2803" x2="558.9609" y2="63.2637" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="542.0663" y1="52.564" x2="558.0507" y2="64.1767" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="538.6767" y1="59.2217" x2="557.4667" y2="65.3262" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="537.5097" y1="66.6006" x2="557.2665" y2="66.6001" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="538.6806" y1="73.979" x2="557.4697" y2="67.873" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="542.0741" y1="80.6343" x2="558.0566" y2="69.021" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M572.1916,87.7153s-5.2617-2.3228-5.0034-13.34,13.3779-11.9414,14.041-11.9663c5.6191-.2109,14.0293,4.1934,13.999,12.2842-.039,10.3867-6.6269,13.6553-6.6269,13.6553s-7.0249,4.3759-7.0777,8.6465c-.0688,5.5883,0,10.5468,0,10.5468" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <polyline points="407.769 498.899 435.485 498.899 435.485 597.13 405.769 597.13" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <path d="M371.6926,505.4531h-4.8081s.91-11.4737-4.919-15.15-9.2343-3.959-9.2343-3.959v-6.93h14.0117v6.5049h4.95Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M276.9475,505.4531h4.8081s-.91-11.4737,4.9189-15.15,9.2344-3.959,9.2344-3.959v-6.93H281.8972v6.5049h-4.95Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <line x1="275.8544" y1="473.7353" x2="332.8906" y2="473.7353" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="517.3476" y1="482.9541" x2="517.3476" y2="507.7764" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <polygon points="442.422 493.562 447.831 496.821 442.977 503.616 435.836 503.616 442.422 493.562" style="fill: #1d1d1b"/>\n                  <polygon points="509.276 493.562 503.868 496.821 509.866 504.667 518.273 504.667 509.276 493.562" style="fill: #1d1d1b"/>\n                  <polygon points="457.26 471.931 464.401 471.931 464.401 477.893 461.42 477.893 460.38 479.766 454.972 476.368 457.26 471.931" style="fill: #1d1d1b"/>\n                  <polygon points="493.897 471.931 486.756 471.931 486.756 477.893 489.737 477.893 490.777 479.766 496.186 476.368 493.897 471.931" style="fill: #1d1d1b"/>\n                  <line x1="373.8427" y1="498.9121" x2="409.5229" y2="498.9121" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="199.8427" y1="498.9121" x2="235.5229" y2="498.9121" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="109.8378" y1="613.5459" x2="134.1166" y2="613.5459" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="193.54" y1="613.5459" x2="217.8188" y2="613.5459" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="286.5326" y1="498.9121" x2="322.2128" y2="498.9121" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="463.5097" y1="474.7959" x2="487.6762" y2="474.7959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="373.8427" y1="597.1299" x2="409.5229" y2="597.1299" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="444.7104" y1="495.3652" x2="457.8144" y2="477.4775" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="493.4521" y1="477.4775" x2="507.1801" y2="495.7812" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="374.8427" y1="498.8994" x2="321.3427" y2="498.8994" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="288.0092" y1="498.8994" x2="234.5092" y2="498.8994" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="282.0087" y1="595.7959" x2="261.2587" y2="595.7959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="200.6762" y1="499.1152" x2="167.5092" y2="499.1152" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="374.1762" y1="597.1299" x2="324.6762" y2="597.1299" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <rect x="267.3427" y="501.2959" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="330.0097" y="501.2959" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="341.3647" y="501.2959" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="267.3427" y="591.6289" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="330.0097" y="591.6289" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="341.3647" y="591.6289" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="267.3427" y="598.4629" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="330.0097" y="598.4629" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="341.3647" y="598.4629" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="267.3427" y="631.6299" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="330.0097" y="631.6299" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="341.3647" y="631.6299" width="7.6665" height="4.5" style="fill: #1d1d1b"/>\n                  <rect x="338.8281" y="543.3047" width="9.5834" height="9.3222" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M366.5812,558.1777a3.1209,3.1209,0,1,1-3.121-3.12A3.1207,3.1207,0,0,1,366.5812,558.1777Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <rect x="328.0639" y="543.3047" width="9.5835" height="9.3222" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M355.8171,558.1777a3.1209,3.1209,0,1,1-3.1211-3.12A3.1207,3.1207,0,0,1,355.8171,558.1777Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <rect x="266.413" y="543.3047" width="9.5835" height="9.3222" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M294.1662,558.1777a3.1209,3.1209,0,1,1-3.1211-3.12A3.1207,3.1207,0,0,1,294.1662,558.1777Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <polyline points="5.881 98.719 5.007 738.069 40.914 738.069" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <polygon points="1.588 26.565 1.588 105.826 35.123 105.826 35.123 99.798 30.219 99.798 30.219 96.935 22.082 96.935 22.082 88.647 17.258 88.647 17.258 82.771 8.068 82.771 8.068 46.908 17.109 46.908 17.109 40.729 21.931 40.729 21.931 31.689 35.123 31.689 35.123 26.565 1.588 26.565" style="fill: #1d1d1b"/>\n                  <polygon points="82.559 81.991 89.465 81.991 89.465 98.282 91.509 98.282 91.509 107.021 83.332 107.021 83.332 104.906 65.855 104.906 65.855 100.397 68.535 100.397 68.535 97.648 76.427 97.648 76.427 89.332 82.487 89.332 82.559 81.991" style="fill: #1d1d1b"/>\n                  <polygon points="91.273 25.081 82.711 25.081 82.711 26.565 66.868 26.565 66.868 31.689 76.941 31.689 76.941 40.729 82.759 40.729 82.759 48.43 89.334 48.43 89.334 33.594 91.273 33.594 91.273 25.081" style="fill: #1d1d1b"/>\n                  <path d="M94.6584,32.4941a2.8123,2.8123,0,1,1-2.812-2.813A2.8129,2.8129,0,0,1,94.6584,32.4941Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M112.152,53.0361a2.8118,2.8118,0,1,1-2.8115-2.8116A2.8121,2.8121,0,0,1,112.152,53.0361Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M112.152,98.0829a2.8118,2.8118,0,1,1-2.8115-2.8115A2.8126,2.8126,0,0,1,112.152,98.0829Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M96.2834,32.4941a4.4373,4.4373,0,1,1-4.436-4.4385A4.438,4.438,0,0,1,96.2834,32.4941Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M52.1687,32.4941a2.8121,2.8121,0,1,1-2.8121-2.813A2.813,2.813,0,0,1,52.1687,32.4941Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M53.7951,32.4941a4.438,4.438,0,1,1-4.4375-4.4385A4.4393,4.4393,0,0,1,53.7951,32.4941Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M108.0939,101.311h18.2588V92.5649h-2.186V58.2328h2.186V49.5937H112.905V34.2875H97.8171V15.1523H87.4089S78.8747,10.71,71.07,10.71c-8.7851,0-17.2744,4.6059-17.2744,4.6059H43.7629V33.4115H21.4289v3.3638" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polyline points="89.334 48.023 100.062 48.023 100.062 82.355 89.5 82.355" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="33.9545" y1="28.6304" x2="68.5033" y2="28.6304" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="86.1415" y1="48.0229" x2="86.1415" y2="82.355" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <path d="M54.715,36.9325V19.0082a37.6082,37.6082,0,0,1,15.76-4.0342C78.8747,14.9325,86.9,19.34,86.9,19.34V36.9325" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="87.5976" y1="105.8257" x2="87.5976" y2="272.4624" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 7px"/>\n                  <path d="M115.0915,132.1078a3.0608,3.0608,0,1,1-3.06-3.061A3.0612,3.0612,0,0,1,115.0915,132.1078Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M115.0915,178.3207a3.0608,3.0608,0,1,1-3.06-3.061A3.062,3.062,0,0,1,115.0915,178.3207Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M115.0915,225.2631a3.0608,3.0608,0,1,1-3.06-3.0615A3.0619,3.0619,0,0,1,115.0915,225.2631Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <line x1="91.3549" y1="267.2124" x2="91.3549" y2="288.7124" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="91.3559" y1="312.7124" x2="91.3559" y2="338.9277" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="91.3549" y1="364.7129" x2="91.3549" y2="390.0781" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="91.3559" y1="409.7129" x2="91.3559" y2="451.9629" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="8.5888" y1="270.4184" x2="87.5976" y2="270.4184" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 7px"/>\n                  <line x1="8.5888" y1="315.9873" x2="65.3959" y2="315.9873" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 7px"/>\n                  <line x1="28.1962" y1="420.2129" x2="91.3559" y2="420.2129" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 7px"/>\n                  <line x1="91.3559" y1="287.4624" x2="91.3559" y2="315.9873" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="91.3559" y1="338.2124" x2="91.3559" y2="365.5879" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="91.3559" y1="389.0224" x2="91.3559" y2="414.8779" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="91.3559" y1="450.125" x2="91.3559" y2="480.1943" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polyline points="504.155 253.681 518.655 253.681 518.655 268.679" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polygon points="83.531 482.388 89.436 482.388 89.436 480.194 92.981 480.194 92.981 496.646 96.082 491.594 101.431 495.958 96.229 503.016 93.592 503.016 93.592 510.427 88.994 510.884 88.994 509.422 82.277 502.773 82.277 500.8 83.68 500.8 83.531 482.388" style="fill: #1d1d1b"/>\n                  <polygon points="107.488 476.891 111.063 472.861 111.063 469.913 120.497 469.913 120.497 476.305 115.83 476.305 112.651 480.921 107.488 476.891" style="fill: #1d1d1b"/>\n                  <polygon points="152.868 476.891 149.293 472.861 149.293 469.913 139.859 469.913 139.859 476.305 144.527 476.305 147.705 480.921 152.868 476.891" style="fill: #1d1d1b"/>\n                  <polygon points="164.089 491.437 159.423 495.539 165.263 503.016 168.061 503.016 168.061 496.143 164.089 491.437" style="fill: #1d1d1b"/>\n                  <line x1="119.5698" y1="473.1797" x2="140.7831" y2="473.1797" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="149.9404" y1="477.4404" x2="163.0649" y2="494.5146" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <line x1="111.1757" y1="477.4404" x2="97.745" y2="495.539" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                  <polyline points="110.016 613.546 79.904 613.546 79.904 602.389" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="39.0766" y1="524.831" x2="39.0766" y2="574.4805" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="39.0766" y1="506.0478" x2="39.0766" y2="510.4648" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="27.4076" y1="574.4805" x2="47.7148" y2="574.4805" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="71.495" y1="574.4805" x2="81.6489" y2="574.4805" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="40.2641" y1="530.0849" x2="78.2358" y2="530.0849" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="40.2641" y1="534.1767" x2="78.2358" y2="534.1767" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="40.2641" y1="538.2666" x2="78.2358" y2="538.2666" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="40.2641" y1="542.3584" x2="78.2358" y2="542.3584" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="40.2641" y1="546.4492" x2="78.2358" y2="546.4492" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="40.2641" y1="550.54" x2="78.2358" y2="550.54" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="40.2641" y1="554.6308" x2="78.2358" y2="554.6308" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <polyline points="105.716 611.104 105.716 592.613 81.649 592.613" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 2px"/>\n                  <polyline points="79.904 595.237 79.904 511.872 71.495 504.016 67.131 504.016" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="47.7148" y1="504.0156" x2="28.6596" y2="504.0156" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="133.4638" y1="613.5459" x2="194.54" y2="613.5459" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="133.4638" y1="636.8545" x2="194.54" y2="636.8545" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="217.3847" y1="636.8545" x2="290.9452" y2="636.8545" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="314.0287" y1="636.8545" x2="379.0126" y2="636.8545" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="401.1733" y1="636.8545" x2="435.8364" y2="636.8545" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="55.6161" y1="636.8545" x2="110.5829" y2="636.8545" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="8.4321" y1="636.8545" x2="32.849" y2="636.8545" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <polyline points="217.174 613.546 258.47 613.546 258.47 501.865" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="171.3447" y1="499.1152" x2="171.3447" y2="510.3515" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <line x1="171.3447" y1="526.5312" x2="171.3447" y2="612.7519" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 6px"/>\n                  <rect x="261.2587" y="543.957" width="2.7573" height="8.1465" style="fill: #1d1d1b"/>\n                  <line x1="31.5683" y1="423.0264" x2="31.5683" y2="459.5361" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 3px"/>\n                  <line x1="31.5683" y1="466.666" x2="31.5683" y2="486.9189" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 3px"/>\n                  <path d="M597.4294,740.6288a2.7793,2.7793,0,1,1-2.78-2.7783A2.78,2.78,0,0,1,597.4294,740.6288Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M597.4294,634.622a2.7793,2.7793,0,1,1-2.78-2.7783A2.78,2.78,0,0,1,597.4294,634.622Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M621.3547,659.6093a2.7791,2.7791,0,1,1-2.78-2.7783A2.78,2.78,0,0,1,621.3547,659.6093Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M621.3547,721.1513a2.7791,2.7791,0,1,1-2.78-2.7783A2.7792,2.7792,0,0,1,621.3547,721.1513Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <path d="M609.322,634.0234a9.9889,9.9889,0,0,0-9.2285,6.17c.1777-.0078.352-.0264.5322-.0264a11.6,11.6,0,0,1,11.539,13.4151,9.9856,9.9856,0,0,0-2.8427-19.5586Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M619.4807,732.4843a9.9889,9.9889,0,0,0-6.17-9.2295c.0078.1777.0263.3525.0263.5322a11.6,11.6,0,0,1-13.415,11.5391,9.9858,9.9858,0,0,0,19.5591-2.8418Z" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="603.5361" y1="738.0693" x2="561.0595" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="530.4501" y1="738.0693" x2="488.3598" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="455.331" y1="738.0693" x2="413.2406" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="191.8583" y1="738.0693" x2="147.4638" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="249.0068" y1="738.0693" x2="222.0185" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <line x1="115.9047" y1="738.0693" x2="73.5175" y2="738.0693" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 10px"/>\n                  <polygon points="247.143 733.06 247.143 748.064 262.439 748.064 262.439 741.612 269.809 741.612 269.809 745.436 276.831 745.436 276.831 741.543 281.698 741.543 281.698 733.06 247.143 733.06" style="fill: #1d1d1b"/>\n                  <polygon points="359.231 733.06 359.231 748.064 343.935 748.064 343.935 741.612 336.565 741.612 336.565 745.436 329.543 745.436 329.543 741.543 324.676 741.543 324.676 733.06 359.231 733.06" style="fill: #1d1d1b"/>\n                  <line x1="351.8334" y1="636.75" x2="351.8334" y2="669.0713" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="161.3178" y1="636.75" x2="161.3178" y2="669.0713" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="161.3178" y1="697.2949" x2="161.3178" y2="733.1982" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="251.8598" y1="636.75" x2="251.8598" y2="669.0713" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="251.8598" y1="697.2949" x2="251.8598" y2="734.7324" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="351.8334" y1="699.0791" x2="351.8334" y2="735.6211" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                  <line x1="566.1225" y1="527.1221" x2="603.7631" y2="527.1221" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="562.289" y1="617.9473" x2="604.2392" y2="617.9473" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <path d="M533.0852,543.3388H539.79l18.1285-10.9863s5.7666,1.7822,3.8921,6.6943c-.7955,2.084-4.2217,1.92-6.3614,1.8535a24.4483,24.4483,0,0,0-8.2578.835c-2.3613.7939-6.7309,2.9443-6.8647,5.7607s0,67.1846,0,69.33,5.4985,8.7373,8.9848,8.8613,5.3643,0,5.3643,0v6.4365h-21.59Z" transform="translate(-19.8405 -10.2099)" style="fill: #1d1d1b"/>\n                  <line x1="435.4848" y1="615.9512" x2="435.4848" y2="672.2744" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <line x1="435.4848" y1="701.8047" x2="435.4848" y2="734.7324" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                  <path d="M533.0185,545.9277h22.602a2.8345,2.8345,0,0,1,2.8345,2.8345v50.1157a2.835,2.835,0,0,1-2.835,2.835H533.018a2.8345,2.8345,0,0,1-2.8345-2.8345V548.7627A2.835,2.835,0,0,1,533.0185,545.9277Z" style="fill: none;stroke: #b1b1b1;stroke-miterlimit: 10"/>\n                  <line x1="568.789" y1="531.1299" x2="568.789" y2="592.5498" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 2px"/>\n                  <path d="M582.13,613.1728s15.8037,3.2988,15.8037-10.4131.125-45.2119,0-45.7119a7.8858,7.8858,0,0,1,8-6.75c6.625,0,7.4375,6.375,7.4375,7.4375v54.1875" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M605.5583,558.1728s-.7749,48.125-.7749,50.875-1.3325,15.125-22.6538,15.125" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="568.789" y1="552.0879" x2="601.5146" y2="552.0879" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="568.789" y1="556.9814" x2="601.5146" y2="556.9814" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="568.789" y1="561.876" x2="601.5146" y2="561.876" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="568.789" y1="566.7695" x2="601.5146" y2="566.7695" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="568.789" y1="571.6631" x2="601.5146" y2="571.6631" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="568.789" y1="576.5576" x2="601.5146" y2="576.5576" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="568.789" y1="581.4512" x2="601.5146" y2="581.4512" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <circle cx="587.3427" cy="545.3379" r="2.625" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <path d="M607.1833,541.9228A13.625,13.625,0,1,1,596.06,563.42" transform="translate(-19.8405 -10.2099)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="569.3427" y1="584.3379" x2="585.1518" y2="587.3379" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="569.3427" y1="587.9629" x2="584.9428" y2="596.4629" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="569.3427" y1="591.5879" x2="584.0781" y2="603.3105" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <polyline points="579.556 609.366 568.789 592.213 572.892 612.632" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="587.8427" y1="542.7129" x2="589.9677" y2="531.9658" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="588.8671" y1="543.1435" x2="595.1796" y2="534.1894" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="589.6279" y1="543.9531" x2="599.0361" y2="538.3408" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="589.9931" y1="545.0029" x2="600.871" y2="543.7021" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="589.9003" y1="546.1103" x2="600.3661" y2="549.3457" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="589.3652" y1="547.084" x2="597.6103" y2="554.2959" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="588.4804" y1="547.7558" x2="593.079" y2="557.6973" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="587.3984" y1="548.0098" x2="587.5556" y2="558.9619" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="586.3066" y1="547.8017" x2="581.9955" y2="557.8701" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                  <line x1="585.3935" y1="547.167" x2="577.3603" y2="554.6123" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n              </g>\n              </svg>\n          ',
          OG2: '\n            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 650.1489 789.1853" class="plan">\n            <title>1908_0G_02_02</title>\n            <rect x="0.5" y="0.5" width="649.1489" height="788.1853" style="fill: #fff;"/>\n            <g>\n                <polyline points="625.06 521.227 625.06 290.272 537.849 290.272 537.849 323.132" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="537.8492" y1="351.3859" x2="537.8492" y2="393.4435" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="537.8492" y1="419.8615" x2="537.8492" y2="471.3263" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="537.8492" y1="499.9718" x2="537.8492" y2="529.0627" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="537.8492" y1="452.3107" x2="563.3248" y2="452.3107" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="588.7174" y1="452.3107" x2="624.8956" y2="452.3107" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="537.8492" y1="371.3351" x2="563.3248" y2="371.3351" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="588.7174" y1="371.3351" x2="624.8956" y2="371.3351" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="537.4664" y1="322.0588" x2="537.4664" y2="353.2258" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="537.4664" y1="390.4435" x2="537.4664" y2="421.6105" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="537.4664" y1="469.9435" x2="537.4664" y2="501.1105" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="473.3341" y1="517.9728" x2="510.7735" y2="517.9728" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="398.1798" y1="517.9728" x2="431.1432" y2="517.9728" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="309.148" y1="517.9728" x2="342.1109" y2="517.9728" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="219.5533" y1="517.9728" x2="252.5157" y2="517.9728" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="134.1217" y1="517.9728" x2="163.8526" y2="517.9728" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="474.4698" y1="749.3097" x2="510.7735" y2="749.3097" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="404.7623" y1="749.3097" x2="438.3341" y2="749.3097" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="210.1236" y1="749.0793" x2="244.6412" y2="749.0793" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="134.3346" y1="749.0793" x2="168.8517" y2="749.0793" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="57.525" y1="749.0793" x2="92.0421" y2="749.0793" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="301.2418" y1="738.1095" x2="346.6773" y2="738.1095" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <line x1="549.1432" y1="749.3097" x2="586.5826" y2="749.3097" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <polyline points="624.896 521.013 624.896 749.31 585.965 749.31" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="551.7848" y1="749.3097" x2="509.3082" y2="749.3097" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="406.1607" y1="749.3097" x2="366.1329" y2="749.3097" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="476.5836" y1="749.3097" x2="436.6085" y2="749.3097" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="458.7564" y1="749.3097" x2="458.7564" y2="713.9269" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="191.9518" y1="634.2922" x2="191.9518" y2="545.2638" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <polyline points="458.498 689.699 458.498 517.76 481.726 517.76" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="510.7735" y1="517.7599" x2="553.6446" y2="517.7599" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="588.7174" y1="517.7599" x2="624.4195" y2="517.7599" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="586.7789" y1="544.7306" x2="624.4195" y2="544.7306" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="582.9454" y1="635.5558" x2="624.8956" y2="635.5558" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="399.7335" y1="517.7599" x2="342.2608" y2="517.7599" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="309.1485" y1="517.7599" x2="251.6754" y2="517.7599" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="219.5533" y1="517.7599" x2="162.0797" y2="517.7599" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="135.1031" y1="517.7599" x2="108.6334" y2="517.7599" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="458.7564" y1="517.7599" x2="424.3116" y2="517.7599" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <polyline points="112.15 304.691 112.15 283.913 25.387 283.913 25.387 748.849 58.839 748.849" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <polyline points="112.15 353.356 112.15 329.602 27.162 329.602" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="112.15" y1="377.9797" x2="112.15" y2="405.4914" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <polyline points="112.15 490.462 112.15 519.719 48.662 519.719" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="112.15" y1="430.34" x2="112.15" y2="467.3888" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="112.15" y1="303.5378" x2="112.15" y2="491.9689" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10"/>\n                <polyline points="50.716 474.645 50.716 439.198 112.15 439.198" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <line x1="50.7159" y1="490.4621" x2="50.7159" y2="517.7599" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <polyline points="278.855 517.76 278.855 631.292 237.27 631.292" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="213.544" y1="631.2922" x2="151.5934" y2="631.2922" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <polyline points="141.678 631.292 92.155 631.292 92.155 622.822" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="213.544" y1="653.8127" x2="151.5934" y2="653.8127" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="315.3756" y1="653.8127" x2="237.1476" y2="653.8127" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="407.0772" y1="653.8127" x2="337.8082" y2="653.8127" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="391.0709" y1="614.5295" x2="343.2164" y2="614.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="458.7564" y1="614.5295" x2="424.2164" y2="614.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="305.3726" y1="614.5295" x2="278.8551" y2="614.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="458.7564" y1="653.8127" x2="430.4347" y2="653.8127" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="130.963" y1="653.8127" x2="73.5924" y2="653.8127" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="135.6119" y1="748.6183" x2="91.1671" y2="748.6183" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="211.2545" y1="748.6183" x2="168.3111" y2="748.6183" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="273.1109" y1="749.0793" x2="243.6612" y2="749.0793" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="50.1822" y1="653.8127" x2="25.3868" y2="653.8127" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <line x1="373.0846" y1="656.1808" x2="373.0846" y2="688.5021" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <line x1="182.5689" y1="656.1808" x2="182.5689" y2="688.5021" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <line x1="182.5689" y1="716.7258" x2="182.5689" y2="746.5246" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <line x1="273.1109" y1="656.1808" x2="273.1109" y2="688.5021" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <line x1="273.1109" y1="716.7258" x2="273.1109" y2="752.3742" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <line x1="373.0846" y1="718.5099" x2="373.0846" y2="755.0519" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <path d="M304.1456,737.175h-2.5815v-4.86H272.6109v22.2373h-4.9043v10.753h15.1866v-2.15h3.3554v-7.0537h-2.1079s.0235-5.1319,2.1079-8.3868c2.2368-3.4951,7.0127-4.7744,7.0127-4.7744h.1406a2.9814,2.9814,0,0,0-.1767.9785,3.0279,3.0279,0,0,0,6.0557,0,2.9811,2.9811,0,0,0-.1763-.9785h5.041Z" transform="translate(0.5 0.5)" style="fill: #1d1d1b"/>\n                <path d="M343.5958,737.175h2.5815v-4.86h27.9532v22.2373h6.9765v10.753H364.8477v-2.15h-3.3549v-7.0537h2.1084s-.0244-5.1319-2.1084-8.3868c-2.2373-3.4951-7.0127-4.7744-7.0127-4.7744h-.14a2.991,2.991,0,0,1,.1753.9785,3.0276,3.0276,0,0,1-6.0551,0,2.9817,2.9817,0,0,1,.1772-.9785h-5.0415Z" transform="translate(0.5 0.5)" style="fill: #1d1d1b"/>\n                <line x1="55.3277" y1="545.2638" x2="55.3277" y2="590.6633" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <line x1="43.6588" y1="591.5812" x2="63.9659" y2="591.5812" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <line x1="83.7462" y1="591.5812" x2="93.9" y2="591.5812" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <line x1="56.692" y1="546.4269" x2="90.4869" y2="546.4269" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="56.692" y1="550.5177" x2="90.4869" y2="550.5177" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="56.692" y1="554.6095" x2="90.4869" y2="554.6095" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="56.692" y1="558.6994" x2="90.4869" y2="558.6994" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="56.692" y1="562.7912" x2="90.4869" y2="562.7912" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="56.692" y1="566.882" x2="90.4869" y2="566.882" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="56.692" y1="570.9728" x2="90.4869" y2="570.9728" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="56.692" y1="575.0636" x2="90.4869" y2="575.0636" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <polyline points="123.827 630.292 123.827 610.003 93.9 610.003" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 4px"/>\n                <line x1="191.9518" y1="519.7189" x2="191.9518" y2="530.214" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <polyline points="92.155 615.67 92.155 529.305 88.823 519.719" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <path d="M380.401,755.9093v12.3184H354.4268s.8042,8.49-29.8178,8.49-33.44-8.49-33.44-8.49H268.818V755.9093" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 1.5px"/>\n                <circle cx="469.7091" cy="640.5021" r="3.1206" style="fill: #1d1d1b"/>\n                <circle cx="469.7091" cy="743.5021" r="3.1206" style="fill: #1d1d1b"/>\n                <path d="M520.5851,640.0021a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,520.5851,640.0021Z" transform="translate(0.5 0.5)" style="fill: #1d1d1b"/>\n                <path d="M548.6432,640.0021a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,548.6432,640.0021Z" transform="translate(0.5 0.5)" style="fill: #1d1d1b"/>\n                <path d="M520.5851,743.0021a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,520.5851,743.0021Z" transform="translate(0.5 0.5)" style="fill: #1d1d1b"/>\n                <path d="M548.6432,743.0021a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,548.6432,743.0021Z" transform="translate(0.5 0.5)" style="fill: #1d1d1b"/>\n                <path d="M596.0182,743.0021a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,596.0182,743.0021Z" transform="translate(0.5 0.5)" style="fill: #1d1d1b"/>\n                <path d="M596.0182,640.0021a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,596.0182,640.0021Z" transform="translate(0.5 0.5)" style="fill: #1d1d1b"/>\n                <path d="M621.7613,667.7453a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,621.7613,667.7453Z" transform="translate(0.5 0.5)" style="fill: #1d1d1b"/>\n                <path d="M621.7613,721.13a3.1209,3.1209,0,1,1-3.1216-3.12A3.1214,3.1214,0,0,1,621.7613,721.13Z" transform="translate(0.5 0.5)" style="fill: #1d1d1b"/>\n                <rect x="460.3453" y="665.3586" width="6.2427" height="10.124" style="fill: #1d1d1b"/>\n                <rect x="460.3453" y="718.5099" width="6.2427" height="10.1241" style="fill: #1d1d1b"/>\n                <rect x="362.1412" y="561.2863" width="9.5835" height="9.3223" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M369.5538,565.4494a3.1211,3.1211,0,1,1-3.1216-3.12A3.1211,3.1211,0,0,1,369.5538,565.4494Z" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <rect x="349.6412" y="561.2863" width="9.5835" height="9.3223" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M357.0538,565.4494a3.1211,3.1211,0,1,1-3.1216-3.12A3.1211,3.1211,0,0,1,357.0538,565.4494Z" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <rect x="286.8683" y="562.2863" width="9.5835" height="9.3223" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M294.2809,566.4494a3.1209,3.1209,0,1,1-3.1211-3.12A3.1207,3.1207,0,0,1,294.2809,566.4494Z" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M365.1417,560.8029c0-11.9189,14.3784-12.8223,14.3784-12.8223s39.876.02,42.8237,0c2.51-.0175,2.8384,2.4825,2.833,3.3838-.0024.5254-.0263,27.9932,0,30.9033s-3.41,2.5987-3.41,2.5987H377.7735s-12.6318-3.4014-12.6318-14.5" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M375.356,519.5129l-.1855,25.6025a3.3443,3.3443,0,0,0,1.6885,3.3223" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M375.356,610.03l-.1855-21.9571a3.5406,3.5406,0,0,1,1.6885-3.458" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="381.0304" y1="521.5129" x2="381.0304" y2="548.3117" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="386.0728" y1="521.5129" x2="386.0728" y2="548.3117" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="391.0709" y1="521.5129" x2="391.0709" y2="548.3117" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="396.1139" y1="521.5129" x2="396.1139" y2="548.3117" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="401.2896" y1="521.5129" x2="401.2896" y2="548.3117" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="406.3321" y1="521.5129" x2="406.3321" y2="548.3117" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="410.8443" y1="521.5129" x2="410.8443" y2="548.3117" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="415.8873" y1="521.5129" x2="415.8873" y2="548.3117" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="419.8233" y1="521.5129" x2="419.8233" y2="548.3117" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M421.2779,547.9806c2.4507,0,2.3369-3.6572,2.3369-3.6572V521.0207H370.4976l-.185,25.7422a4.0232,4.0232,0,0,0,2.0879,3.3994" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M454.0348,546.2306H427.4874s-3.0195.5186-3.0195,2.6534" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M454.1143,580.0549H429.2184s-4.0416.3369-4.1041-2.6524" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="381.0304" y1="585.3859" x2="381.0304" y2="610.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="386.0728" y1="585.3859" x2="386.0728" y2="610.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="391.0709" y1="585.3859" x2="391.0709" y2="610.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="396.1139" y1="585.3859" x2="396.1139" y2="610.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="401.2896" y1="585.3859" x2="401.2896" y2="610.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="406.3321" y1="585.3859" x2="406.3321" y2="610.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="410.8443" y1="585.3859" x2="410.8443" y2="610.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="415.8873" y1="585.3859" x2="415.8873" y2="610.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="419.8233" y1="585.3859" x2="419.8233" y2="610.5295" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M372.4005,582.4308a4.723,4.723,0,0,0-2.0879,3.7608l.185,23.9541h53.314v-22.084c0-1.583-1.1865-3.22-2.0444-3.1953" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="425.6046" y1="575.3263" x2="454.7911" y2="575.3263" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="425.6046" y1="570.5685" x2="454.7911" y2="570.5685" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="425.6046" y1="565.7687" x2="454.7911" y2="565.7687" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="425.6046" y1="560.841" x2="454.7911" y2="560.841" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="425.6046" y1="556.0402" x2="454.7911" y2="556.0402" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="425.6046" y1="551.7443" x2="454.7911" y2="551.7443" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M537.3492,288.95" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 8px"/>\n                <polygon points="118.284 514.332 135.103 487.634 135.103 484.348 170.859 484.348 170.859 488.455 187.289 514.332 182.569 514.332 167.162 489.277 138.616 489.277 123.827 514.332 118.284 514.332" style="fill: #1d1d1b"/>\n                <polygon points="461.927 514.332 478.046 488.914 478.046 485.785 512.312 485.785 512.312 489.696 528.058 514.332 523.534 514.332 508.769 490.478 481.412 490.478 467.24 514.332 461.927 514.332" style="fill: #1d1d1b"/>\n                <rect x="461.1842" y="632.384" width="15.7358" height="6.3447" style="fill: #1d1d1b"/>\n                <rect x="509.8536" y="632.384" width="25.2378" height="6.3447" style="fill: #1d1d1b"/>\n                <path d="M533.401,550.7072H540.01l17.87-10.83s5.6845,1.7569,3.8369,6.5987c-.7842,2.0546-4.1616,1.8925-6.271,1.8271a24.12,24.12,0,0,0-8.14.8232c-2.3276.7832-6.6352,2.9024-6.767,5.6788s0,66.2285,0,68.3437,5.42,8.6133,8.8569,8.7354,5.2881,0,5.2881,0v6.3447H533.401Z" transform="translate(0.5 0.5)" style="fill: #1d1d1b"/>\n                <path d="M365.8414,521.0129" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M454.2911,584.8761H430.6925c-2.6377,0-5.5147-1.0751-5.52-3.2666" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M558.1783,561.1867h44.7774a7.1333,7.1333,0,0,1,7.1333,7.1333v44.7778a7.1338,7.1338,0,0,1-7.1338,7.1338H558.1778a7.1333,7.1333,0,0,1-7.1333-7.1333V568.3205A7.1338,7.1338,0,0,1,558.1783,561.1867Z" style="fill: none;stroke: #b1b1b1;stroke-miterlimit: 10"/>\n                <path d="M621.1988,614.882s-13.042.2324-15.2929,0-7.917-.2246-13.8174-3.8037c-1.8867-1.1445-4.5025-2.252-4.6577,1.4746s0,19.3311,0,19.3311" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M606.2735,631.173V614.91s-7.21-25.6943-9.1963-31.667-7.1157-18.4726-7.3007-23.5976,0-13,0-13" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M601.1964,631.173V616.9552a3.3494,3.3494,0,0,1,1.1977-2.3964" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M596.3736,631.173V615.6359a2.4087,2.4087,0,0,1,1.4073-2.0361" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M592.0514,631.173s.0913-15.78.0913-16.6142a6.0157,6.0157,0,0,1,1.1782-2.7813" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="622.2164" y1="564.5207" x2="591.0489" y2="564.5207" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="621.6988" y1="569.3957" x2="592.5514" y2="569.3957" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="621.6988" y1="574.0207" x2="594.0919" y2="574.0207" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <circle cx="607.8185" cy="562.6447" r="3.125" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <circle cx="607.8185" cy="562.6447" r="12.5" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="621.2652" y1="578.6808" x2="595.7794" y2="578.6808" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="621.2652" y1="583.547" x2="597.5772" y2="583.547" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="621.2652" y1="588.047" x2="598.9132" y2="588.047" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="621.2652" y1="592.3654" x2="600.1905" y2="592.3654" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="621.2652" y1="597.2922" x2="601.6207" y2="597.2922" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="621.2652" y1="601.7931" x2="602.9742" y2="601.7931" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="621.2652" y1="606.1115" x2="604.1446" y2="606.1115" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <line x1="621.2652" y1="610.9162" x2="605.5069" y2="610.9162" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M609.3722,639.0138a11.2168,11.2168,0,0,0-10.3628,6.9288c.2-.0088.3955-.0293.5976-.0293a13.0251,13.0251,0,0,1,12.9575,15.0634,11.2131,11.2131,0,0,0-3.1923-21.9629Z" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n                <path d="M620.78,733.8556a11.2165,11.2165,0,0,0-6.9287-10.3632c.0088.1992.0293.3955.0293.5976a13.0252,13.0252,0,0,1-15.0635,12.957,11.2131,11.2131,0,0,0,21.9629-3.1914Z" transform="translate(0.5 0.5)" style="fill: none;stroke: #1d1d1b;stroke-miterlimit: 10;stroke-width: 0.5px"/>\n            </g>\n            </svg>\n          '
        }
      },
      akRoomLabel: '',
      akRoomWorkList: []
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getRoomObjects']), {
    showCatalog: function showCatalog() {
      var _this = this;

      this.pdfUrl = this.roomPeriods.find(function (rp) {
        return rp.year === _this.akPeriod;
      }).pdf;
    },
    catalogThumb: function catalogThumb() {
      var _this2 = this;

      return this.roomPeriods.find(function (rp) {
        return rp.year === _this2.akPeriod;
      }).thumb;
    },
    setRoomDisplay: function setRoomDisplay(id, label) {
      var _this3 = this;

      var workList = this.tryWorklist(id);
      if (workList.length === 0) {
        setTimeout(function () {
          workList = _this3.tryWorklist(id);
        }, 2000);
      }
      this.akRoomLabel = label;
      this.akRoomWorkList = workList;
    },
    tryWorklist: function tryWorklist(id) {
      return this.objectsInRoom(id, 'period' + this.akPeriod);
    },
    changeLevelTo: function changeLevelTo(level) {
      this.akRoomLabel = '';
      this.akRoomWorkList = [];
      this.akLevel = level;
    },
    akPeriodLevels: function akPeriodLevels() {
      var _this4 = this;

      return this.roomPeriods.find(function (rp) {
        return rp.year === _this4.akPeriod;
      }).levels;
    },
    akPlan: function akPlan() {
      return this['planSVGs']['p' + this.akPeriod]['' + this.akLevel];
    },
    akMarkers: function akMarkers() {
      return this['markers' + this.akPeriod]['' + this.akLevel.toLowerCase()];
    },
    objectsInRoom: function objectsInRoom(room, period) {
      var objects = this.roomListings[room] ? this.roomListings[room][period] : [];
      return objects.map(function (o) {
        var object = {};
        object.title = o.title ? o.title : undefined;
        object.urheber = o.author ? o.author : undefined;
        object.soId = o.soId ? o.soId : undefined;
        return object;
      });
    }
  }),
  created: function created() {
    this.getRoomObjects();
    // Notice we have to use a $ here
    this.$forceUpdate();
    // this.generateData()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2207de58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Rooms.vue
var Rooms_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"rooms"}},[_c('div',{class:{ open: _vm.pdfUrl },attrs:{"id":"pdf-viewer"}},[_c('v-btn',{staticClass:"btn-close",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.pdfUrl = ''}}},[_c('img',{staticClass:"close",attrs:{"src":"/static/img/icons/close.svg","alt":"close"}})]),_vm._v(" "),_c('iframe',{attrs:{"src":_vm.pdfUrl,"frameborder":"0"}})],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{staticClass:"main_layout_db",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","md7":"","lg7":""}},[_c('v-card',{staticClass:"trbg rooms-card",attrs:{"flat":""}},[_c('div',[_c('div',{staticClass:"plan-svg"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.akPlan())}}),_vm._v(" "),_vm._l((_vm.akMarkers()),function(marker,index){return _c('div',{key:("marker-" + index),staticClass:"marker",style:(("top: " + (marker.top) + "%; left: " + (marker.left) + "%;"))},[_c('div',{staticClass:"label",on:{"click":function($event){return _vm.setRoomDisplay(marker.id, marker.label)}}},[_vm._v("\n                    "+_vm._s(marker.label)+"\n                  ")])])})],2)])])],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","md5":"","lg5":""}},[_c('v-card',{staticClass:"trbg rooms-card",attrs:{"flat":""}},[_c('h1',[_vm._v(_vm._s(_vm.translate['Intro Pläne'][_vm.lang]))]),_vm._v(" "),_c('div',{staticClass:"periods",staticStyle:{"border-top":"1px solid #ccc","padding":".6rem 0 .2rem 0"}},[_vm._v("\n            "+_vm._s(_vm.translate['Zeitstufe'][_vm.lang])+":\n            "),_vm._l((_vm.provPeriods),function(period,index){return _c('div',{key:("period-" + index),staticClass:"period-switch"},[(period === _vm.akPeriod)?_c('span',{staticStyle:{"font-weight":"bold","cursor":"default"}},[_vm._v("\n                "+_vm._s(period)+"\n              ")]):_c('span',{staticStyle:{"font-weight":"normal","cursor":"default","opacity":".2"}},[_vm._v("\n                "+_vm._s(period)+"\n              ")])])})],2),_vm._v(" "),_c('div',{staticClass:"levels",staticStyle:{"border-bottom":"1px solid #ccc","padding":".2rem 0 .6rem 0"}},[_vm._v("\n            "+_vm._s(_vm.translate['Geschoss'][_vm.lang])+":\n            "),_vm._l((_vm.akPeriodLevels ()),function(level,index){return _c('div',{key:("level-" + index),staticClass:"level-switch"},[(level === _vm.akLevel)?_c('span',{staticClass:"active-choice"},[_vm._v("\n                "+_vm._s(_vm.translate[level][_vm.lang])+"\n              ")]):_c('span',{staticClass:"inactive-choice",on:{"click":function($event){return _vm.changeLevelTo(level)}}},[_vm._v("\n                "+_vm._s(_vm.translate[level][_vm.lang])+"\n              ")])])})],2),_vm._v(" "),(_vm.akRoomLabel)?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.translate[_vm.akLevel][_vm.lang])+", "+_vm._s(_vm.translate['Werke in Raum'][_vm.lang])+": "),_c('strong',[_vm._v(_vm._s(_vm.akRoomLabel))])]),_vm._v(" "),(_vm.akRoomWorkList.length)?_c('div',_vm._l((_vm.akRoomWorkList),function(work,index){return _c('div',{key:("work-" + index),staticClass:"work-listing"},[_c('a',{attrs:{"href":("/db/" + (work.soId)),"target":"_blank"}},[(work.urheber)?_c('span',{staticClass:"work-author"},[_c('em',[_vm._v(_vm._s(work.urheber))]),_vm._v(", ")]):_vm._e(),_c('span',{staticClass:"work-title"},[_vm._v(_vm._s(work.title))])])])}),0):_vm._e()]):_c('div',[_c('h2',[_vm._v(" "+_vm._s(_vm.translate['Zur Anzeige der Werke bitte im Plan auf einen Raum klicken!'][_vm.lang]))])]),_vm._v(" "),_c('div',{staticClass:"catalog-source",staticStyle:{"border-top":"1px solid #ccc","padding":"1.2rem 0 .2rem 0"}},[_c('div',{staticClass:"source-info"},[_c('h3',[_vm._v(_vm._s(_vm.translate['Quelle der Rekonstruktion'][_vm.lang]))]),_vm._v(" "),_c('p',[_c('a',{attrs:{"id":"lnk_open","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showCatalog()}}},[_vm._v(_vm._s(_vm.translate['Katalog einsehen'][_vm.lang]))])])]),_vm._v(" "),_c('div',{staticClass:"catalog-thumb"},[_c('img',{attrs:{"src":_vm.catalogThumb()},on:{"click":function($event){return _vm.showCatalog()}}})])])])],1)],1)],1)],1)}
var Rooms_staticRenderFns = []
var Rooms_esExports = { render: Rooms_render, staticRenderFns: Rooms_staticRenderFns }
/* harmony default export */ var pages_Rooms = (Rooms_esExports);
// CONCATENATED MODULE: ./src/components/pages/Rooms.vue
function Rooms_injectStyle (ssrContext) {
  __webpack_require__("glFB")
  __webpack_require__("fhKC")
}
var Rooms_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Rooms___vue_template_functional__ = false
/* styles */
var Rooms___vue_styles__ = Rooms_injectStyle
/* scopeId */
var Rooms___vue_scopeId__ = "data-v-2207de58"
/* moduleIdentifier (server only) */
var Rooms___vue_module_identifier__ = null
var Rooms_Component = Rooms_normalizeComponent(
  Rooms,
  pages_Rooms,
  Rooms___vue_template_functional__,
  Rooms___vue_styles__,
  Rooms___vue_scopeId__,
  Rooms___vue_module_identifier__
)

/* harmony default export */ var components_pages_Rooms = (Rooms_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/partials/Letter-display.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Letter_display = ({
  name: 'letter-display',
  props: {
    letter: String
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    setAlbumPage: 'setAlbumPage'
  }), {
    getPersons: function getPersons() {
      var _this = this;

      return this.album.filter(function (e) {
        return e.lastName[0].toLowerCase() === _this.letter.toLowerCase();
      }).length > 0 ? this.album.filter(function (e) {
        return e.lastName[0].toLowerCase() === _this.letter.toLowerCase();
      }) : undefined;
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    album: 'album'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e773b4d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/partials/Letter-display.vue
var Letter_display_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getPersons())?_c('div',{staticClass:"letter-display"},[_c('h5',[_vm._v(_vm._s(_vm.letter))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"listing-container"},_vm._l((_vm.getPersons()),function(person,index){return _c('div',{key:("person-" + index),staticClass:"person-listing clickable",on:{"click":function($event){return _vm.setAlbumPage(person)}}},[_vm._v("\n      "+_vm._s(person.firstName)+" "),_c('strong',[_vm._v(_vm._s(person.lastName))])])}),0)]):_vm._e()}
var Letter_display_staticRenderFns = []
var Letter_display_esExports = { render: Letter_display_render, staticRenderFns: Letter_display_staticRenderFns }
/* harmony default export */ var partials_Letter_display = (Letter_display_esExports);
// CONCATENATED MODULE: ./src/components/pages/partials/Letter-display.vue
function Letter_display_injectStyle (ssrContext) {
  __webpack_require__("n5W+")
}
var Letter_display_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Letter_display___vue_template_functional__ = false
/* styles */
var Letter_display___vue_styles__ = Letter_display_injectStyle
/* scopeId */
var Letter_display___vue_scopeId__ = "data-v-1e773b4d"
/* moduleIdentifier (server only) */
var Letter_display___vue_module_identifier__ = null
var Letter_display_Component = Letter_display_normalizeComponent(
  Letter_display,
  partials_Letter_display,
  Letter_display___vue_template_functional__,
  Letter_display___vue_styles__,
  Letter_display___vue_scopeId__,
  Letter_display___vue_module_identifier__
)

/* harmony default export */ var pages_partials_Letter_display = (Letter_display_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Album.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'
// import BootstrapVue from 'bootstrap-vue'



/* harmony default export */ var Album = ({
  name: 'Album',
  components: {
    LetterDisplay: pages_partials_Letter_display
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['plans', 'roomListings', 'roomIds', 'roomPeriods', 'markers1908', 'translate', 'lang', 'album', 'currAlbumPage', 'oSharedObjects'])),
  data: function data() {
    return {
      alphabet: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      pdfUrl: '',
      // provisorische Jahresangaben
      provPeriods: [1900, 1908, 1912, 1913, 1915, 1921],
      akPeriod: 1908,
      akLevel: 'OG1',

      akRoomLabel: '',
      akRoomWorkList: []
    };
  },

  methods: {
    showCatalog: function showCatalog() {
      // this.pdfUrl = this.roomPeriods.find(rp => rp.year === this.akPeriod).pdf
      this.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Album_Amicorum_mittel.pdf';
    },
    catalogThumb: function catalogThumb() {
      var _this = this;

      return this.roomPeriods.find(function (rp) {
        return rp.year === _this.akPeriod;
      }).thumb;
    }
  },
  created: function created() {
    this.$forceUpdate(); // Notice we have to use a $ here
    // this.generateData()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-409e24bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Album.vue
var Album_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"rooms"}},[_c('div',{class:{ open: _vm.pdfUrl },attrs:{"id":"pdf-viewer"}},[_c('v-btn',{staticClass:"btn-close",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();_vm.pdfUrl = ''}}},[_c('img',{staticClass:"close",attrs:{"src":"/static/img/icons/close.svg","alt":"close"}})]),_vm._v(" "),_c('iframe',{attrs:{"src":_vm.pdfUrl,"frameborder":"0"}})],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{staticClass:"main_layout_db",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","md7":"","lg7":""}},[_c('v-card',{staticClass:"trbg rooms-card",attrs:{"flat":""}},[_c('div',[_c('div',{staticClass:"album-page"},[(_vm.currAlbumPage)?_c('div',[_c('img',{attrs:{"src":("https://www.mari-portal.de/omeka/files/album/" + (_vm.currAlbumPage.scan) + "_mittel.jpg"),"alt":("Album Amicorum, Seite mit Widmung von " + (_vm.currAlbumPage.name)),"tile":("Album Amicorum, Seite mit Widmung von " + (_vm.currAlbumPage.name))}})]):_c('div',[_c('img',{attrs:{"src":"https://www.mari-portal.de/omeka/files/album/00000005_mittel.jpg","alt":"Album Amicorum, Titel","tile":"Album Amicorum, Titel"}})])])])])],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","md5":"","lg5":""}},[_c('v-card',{staticClass:"trbg rooms-card",attrs:{"flat":""}},[_c('h1',{staticClass:"album-title"},[_vm._v(_vm._s(_vm.translate['Intro Album'][_vm.lang]))]),_vm._v(" "),_c('h3',{staticClass:"album-sub-title"},[_vm._v(_vm._s(_vm.translate['Sub Album'][_vm.lang]))]),_vm._v(" "),(_vm.currAlbumPage)?_c('div',{staticClass:"currently-shown"},[_vm._v("\n          "+_vm._s(_vm.translate['Widmung von'][_vm.lang])+" "),_c('strong',[_vm._v(_vm._s(_vm.currAlbumPage.firstName)+" "+_vm._s(_vm.currAlbumPage.lastName))])]):_c('div',{staticClass:"currently-shown"},[_vm._v("\n          "+_vm._s(_vm.translate['Titelseite Album'][_vm.lang])+"\n        ")]),_vm._v(" "),_c('div',[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.translate['Widmungen'][_vm.lang])}}),_vm._v(" "),_c('div',{staticClass:"name-listing"},_vm._l((_vm.alphabet),function(letter,index){return _c('div',{key:("letter-" + index)},[_c('LetterDisplay',{attrs:{"letter":letter}})],1)}),0)])])],1)],1)],1)],1)}
var Album_staticRenderFns = []
var Album_esExports = { render: Album_render, staticRenderFns: Album_staticRenderFns }
/* harmony default export */ var pages_Album = (Album_esExports);
// CONCATENATED MODULE: ./src/components/pages/Album.vue
function Album_injectStyle (ssrContext) {
  __webpack_require__("slAP")
}
var Album_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Album___vue_template_functional__ = false
/* styles */
var Album___vue_styles__ = Album_injectStyle
/* scopeId */
var Album___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Album___vue_module_identifier__ = null
var Album_Component = Album_normalizeComponent(
  Album,
  pages_Album,
  Album___vue_template_functional__,
  Album___vue_styles__,
  Album___vue_scopeId__,
  Album___vue_module_identifier__
)

/* harmony default export */ var components_pages_Album = (Album_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Archivbestaende.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Archivbestaende = ({
  data: function data() {
    return {
      pwd: '',
      authorized: false
    };
  },

  components: {
    Archivbestand: pages_partials_Archivbestand
  },
  methods: {
    stringToHash: function stringToHash(string) {
      var hash = 0;
      if (string.length === 0) return hash;
      for (var i = 0; i < string.length; i++) {
        var char = string.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
      }
      return hash;
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['lang']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99d2cb70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Archivbestaende.vue
var Archivbestaende_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page list-archivbestaende"},[_c('v-container',{attrs:{"grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"sec_col flex-grow-1 flex-shrink-0",attrs:{"sm12":""}},[_c('div',{staticClass:"col-inner col-highlight"},[_c('h1',[_vm._v("Archivbestände")]),_vm._v(" "),(_vm.authorized)?_c('Archivbestand',{attrs:{"lang":_vm.lang}}):_c('div',[_c('p',[_vm._v("Bitte geben Sie das Passwort ein, um die Archivbestände zu sehen.")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Passwort","type":"password","color":"secondary"},model:{value:(_vm.pwd),callback:function ($$v) {_vm.pwd=$$v},expression:"pwd"}}),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.authorized = _vm.stringToHash(_vm.pwd) === 164812873}}},[_vm._v("Einloggen")])],1)],1)])],1)],1)],1)}
var Archivbestaende_staticRenderFns = []
var Archivbestaende_esExports = { render: Archivbestaende_render, staticRenderFns: Archivbestaende_staticRenderFns }
/* harmony default export */ var pages_Archivbestaende = (Archivbestaende_esExports);
// CONCATENATED MODULE: ./src/components/pages/Archivbestaende.vue
function Archivbestaende_injectStyle (ssrContext) {
  __webpack_require__("WA4v")
}
var Archivbestaende_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Archivbestaende___vue_template_functional__ = false
/* styles */
var Archivbestaende___vue_styles__ = Archivbestaende_injectStyle
/* scopeId */
var Archivbestaende___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Archivbestaende___vue_module_identifier__ = null
var Archivbestaende_Component = Archivbestaende_normalizeComponent(
  Archivbestaende,
  pages_Archivbestaende,
  Archivbestaende___vue_template_functional__,
  Archivbestaende___vue_styles__,
  Archivbestaende___vue_scopeId__,
  Archivbestaende___vue_module_identifier__
)

/* harmony default export */ var components_pages_Archivbestaende = (Archivbestaende_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/PageNotFound.vue

//
//
//
//
//
//
//
//


/* harmony default export */ var PageNotFound = ({
  name: 'PageNotFound',
  // data () {
  //   return {
  //     // cssClass: this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
  //   }
  // },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['translate', 'lang']), {
    cssClass: function cssClass() {
      return this.$options.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b03b9c02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageNotFound.vue
var PageNotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-sm":"","fluid":""}},[_c('div',{class:_vm.cssClass},[_c('h1',[_vm._v(_vm._s(_vm.translate['page_not_found'][_vm.lang]))])])])}
var PageNotFound_staticRenderFns = []
var PageNotFound_esExports = { render: PageNotFound_render, staticRenderFns: PageNotFound_staticRenderFns }
/* harmony default export */ var pages_PageNotFound = (PageNotFound_esExports);
// CONCATENATED MODULE: ./src/components/pages/PageNotFound.vue
function PageNotFound_injectStyle (ssrContext) {
  __webpack_require__("SRBV")
}
var PageNotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageNotFound___vue_template_functional__ = false
/* styles */
var PageNotFound___vue_styles__ = PageNotFound_injectStyle
/* scopeId */
var PageNotFound___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageNotFound___vue_module_identifier__ = null
var PageNotFound_Component = PageNotFound_normalizeComponent(
  PageNotFound,
  pages_PageNotFound,
  PageNotFound___vue_template_functional__,
  PageNotFound___vue_styles__,
  PageNotFound___vue_scopeId__,
  PageNotFound___vue_module_identifier__
)

/* harmony default export */ var components_pages_PageNotFound = (PageNotFound_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js
/* eslint-disable space-before-function-paren */












vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Startseite',
    component: components_pages_Startseite,
    label: { de: 'Startseite', en: 'Home' },
    displayNav: true,
    listItemCssClass: 'navitem_start',
    initNavOpen: true,
    position: 1
  }, {
    path: '/db/:oid?',
    alias: '/object/:oid?',
    name: 'Database',
    component: components_pages_DBNew,
    label: { de: 'Datenbank', en: 'Database' },
    displayNav: true,
    listItemCssClass: 'navitem_database',
    initNavOpen: true,
    position: 2
  }, {
    path: '/posts',
    name: 'Posts',
    component: components_pages_Posts,
    label: { de: 'Beiträge', en: 'Articles' },
    displayNav: true,
    listItemCssClass: '',
    initNavOpen: true,
    position: 2
  }, {
    path: '/posts/:pid',
    name: 'Post',
    component: components_pages_Posts,
    label: { de: 'Beitrag', en: 'Article' },
    displayNav: false,
    listItemCssClass: '',
    initNavOpen: true,
    position: 0
  }, {
    path: '/news',
    name: 'News',
    component: components_pages_News,
    label: { de: 'Aktuelles', en: 'News' },
    displayNav: true,
    listItemCssClass: '',
    initNavOpen: true,
    position: 3
  }, {
    path: '/news/:pid',
    name: 'NewsId',
    component: components_pages_News,
    label: { de: 'Aktuelles', en: 'News' },
    displayNav: false,
    listItemCssClass: '',
    initNavOpen: true,
    position: 0
  }, {
    path: '/page/:slug',
    name: 'Seite',
    component: components_pages_Page,
    label: { de: 'Seite', en: 'Page' },
    displayNav: false,
    listItemCssClass: '',
    initNavOpen: true,
    position: 0
  }, {
    path: '/rooms',
    name: 'Rooms',
    component: components_pages_Rooms,
    label: { de: 'Mosse-Palais', en: 'Mosse-Palais' },
    displayNav: true,
    listItemCssClass: '',
    initNavOpen: true,
    position: 6
  }, {
    path: '/album',
    name: 'Album',
    component: components_pages_Album,
    label: { de: 'Album Amicorum', en: 'Album Amicorum' },
    displayNav: true,
    listItemCssClass: '',
    initNavOpen: true,
    position: 7
  }, {
    path: '/archivbestaende',
    name: 'Archivbestaende',
    component: components_pages_Archivbestaende,
    label: { de: 'Archivbestände', en: 'Archive holdings' },
    displayNav: false,
    listItemCssClass: '',
    initNavOpen: true,
    position: 8
  }, {
    path: '/404',
    name: '404',
    component: components_pages_PageNotFound,
    label: { de: 'Seite nicht gefunden', en: 'Page not found' },
    displayNav: false,
    listItemCssClass: '',
    initNavOpen: true,
    position: 0
  }, {
    path: '*',
    redirect: '/404'
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.path !== '/plans' && from.path === '/plans') {
    window.location.href = to.path;
  }
  next();
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./scss/custom.scss
var custom = __webpack_require__("vFWM");
var custom_default = /*#__PURE__*/__webpack_require__.n(custom);

// CONCATENATED MODULE: ./src/main.js








vue_esm["default"].use(vuetify_default.a, {
  theme: {
    primary: '#fff',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    mari: '#6928ff',
    'mari-darker': '#5c23e0',
    white: '#fff'
  }
});
vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  store: store,
  el: '#app',
  router: src_router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "QCv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SRBV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WA4v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fhKC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "glFB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jU8+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kh7F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n5W+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qAEK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sh8n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "slAP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tRYF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vFWM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f015326a888c797ea3d1.js